import * as $n from "vue";
import { ref as z, defineComponent as ut, watch as wt, openBlock as V, createElementBlock as H, createElementVNode as h, Fragment as xe, renderList as We, withDirectives as Ge, vModelText as ft, vModelSelect as bs, toDisplayString as q, reactive as vs, normalizeClass as Pe, createCommentVNode as $e, onMounted as kn, createVNode as kt, unref as ae, Transition as oo, withCtx as so, inject as Xr, computed as Ae, onUnmounted as qr, shallowRef as zr, h as _s, Text as Jr, createTextVNode as xt, vModelDynamic as Zr } from "vue";
import { logger as Hn } from "@myorg/type-lib";
function Qr(e) {
  const t = z([]), n = z(!1), o = z(null), s = async () => {
    n.value = !0;
    try {
      t.value = await e.getConfigs();
    } catch (a) {
      o.value = a.message || "獲取配置失敗";
    } finally {
      n.value = !1;
    }
  };
  return { configs: t, isLoading: n, error: o, fetchConfigs: s, saveConfig: async (a) => {
    n.value = !0;
    try {
      await e.upsertConfig(a), await s();
    } catch (l) {
      throw o.value = l.message || "儲存配置失敗", l;
    } finally {
      n.value = !1;
    }
  } };
}
function ea(e) {
  const t = z([]), n = z(!1), o = z(!1), s = z(null);
  return {
    configs: t,
    loading: n,
    isSaving: o,
    error: s,
    loadConfigs: async () => {
      n.value = !0, s.value = null;
      try {
        const l = await e.fetchConfigs();
        t.value = l || [];
      } catch (l) {
        s.value = "無法載入時段配置", console.error("[TimeConfig] Load Failed:", l);
      } finally {
        n.value = !1;
      }
    },
    updateConfigs: async (l) => {
      o.value = !0, s.value = null;
      try {
        return await e.saveConfigs(l), t.value = [...l], !0;
      } catch (i) {
        return s.value = "儲存時段配置失敗", console.error("[TimeConfig] Save Failed:", i), !1;
      } finally {
        o.value = !1;
      }
    }
  };
}
function ta(e) {
  const t = z({ 0: [], 1: [], 2: [] }), n = z(!1), o = z(!1);
  return { holidayData: t, loading: n, isSaving: o, loadHolidays: async () => {
    n.value = !0;
    try {
      t.value = await e.getHolidays();
    } catch (a) {
      console.error("Fetch failed", a);
    } finally {
      n.value = !1;
    }
  }, submitHolidays: async (a) => {
    o.value = !0;
    try {
      await e.saveHolidays(a), t.value = a;
    } finally {
      o.value = !1;
    }
  } };
}
const na = { class: "space-y-4 p-6 bg-white rounded-2xl border border-slate-100 shadow-sm" }, oa = {
  key: 0,
  class: "py-10 text-center text-slate-700"
}, sa = {
  key: 1,
  class: "space-y-3"
}, ra = ["onUpdate:modelValue"], aa = ["onUpdate:modelValue"], ia = { class: "flex items-end gap-2" }, la = { class: "flex-1" }, ca = ["onUpdate:modelValue"], ua = ["onClick"], da = { class: "pt-4 border-t border-slate-100 flex justify-end" }, fa = ["disabled"], ma = /* @__PURE__ */ ut({
  __name: "TimeConfigManager",
  props: {
    configs: {},
    loading: { type: Boolean },
    isSaving: { type: Boolean }
  },
  emits: ["save"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = z([]);
    wt(() => n.configs, (i) => {
      s.value = JSON.parse(JSON.stringify(i));
    }, { immediate: !0 });
    const r = () => {
      s.value.push({ Start: "09:00", End: "12:00", Interval: 30 });
    }, a = (i) => {
      s.value.splice(i, 1);
    }, l = () => {
      o("save", s.value);
    };
    return (i, f) => (V(), H("div", na, [
      h("div", { class: "flex items-center justify-between" }, [
        f[0] || (f[0] = h("h3", { class: "text-lg font-bold text-slate-700" }, "營業時段配置", -1)),
        h("button", {
          onClick: r,
          class: "px-4 py-2 bg-indigo-100 text-indigo-700 rounded-xl text-sm font-bold hover:bg-indigo-100 transition-colors"
        }, " + 新增時段區間 ")
      ]),
      e.loading ? (V(), H("div", oa, "讀取中...")) : (V(), H("div", sa, [
        (V(!0), H(xe, null, We(s.value, (g, y) => (V(), H("div", {
          key: y,
          class: "group relative grid grid-cols-1 md:grid-cols-3 gap-4 p-4 bg-slate-100 rounded-xl border border-transparent hover:border-indigo-100 transition-all"
        }, [
          h("div", null, [
            f[1] || (f[1] = h("label", { class: "block text-xs font-semibold text-slate-700 mb-1" }, "開始時間", -1)),
            Ge(h("input", {
              type: "time",
              "onUpdate:modelValue": (m) => g.Start = m,
              class: "w-full rounded-lg border-slate-100 focus:ring-indigo-700"
            }, null, 8, ra), [
              [ft, g.Start]
            ])
          ]),
          h("div", null, [
            f[2] || (f[2] = h("label", { class: "block text-xs font-semibold text-slate-700 mb-1" }, "結束時間", -1)),
            Ge(h("input", {
              type: "time",
              "onUpdate:modelValue": (m) => g.End = m,
              class: "w-full rounded-lg border-slate-100 focus:ring-indigo-700"
            }, null, 8, aa), [
              [ft, g.End]
            ])
          ]),
          h("div", ia, [
            h("div", la, [
              f[4] || (f[4] = h("label", { class: "block text-xs font-semibold text-slate-700 mb-1" }, "間隔 (分鐘)", -1)),
              Ge(h("select", {
                "onUpdate:modelValue": (m) => g.Interval = m,
                class: "w-full rounded-lg border-slate-100"
              }, [...f[3] || (f[3] = [
                h("option", { value: 15 }, "15 分鐘", -1),
                h("option", { value: 30 }, "30 分鐘", -1),
                h("option", { value: 60 }, "60 分鐘", -1)
              ])], 8, ca), [
                [
                  bs,
                  g.Interval,
                  void 0,
                  { number: !0 }
                ]
              ])
            ]),
            h("button", {
              onClick: (m) => a(y),
              class: "p-2 text-red-700 hover:text-red-700 transition-colors"
            }, [...f[5] || (f[5] = [
              h("svg", {
                class: "w-5 h-5",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                h("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                })
              ], -1)
            ])], 8, ua)
          ])
        ]))), 128)),
        h("div", da, [
          h("button", {
            onClick: l,
            disabled: e.isSaving,
            class: "px-8 py-2.5 bg-indigo-700 text-white rounded-xl font-bold hover:bg-indigo-700 disabled:opacity-100 shadow-lg shadow-indigo-100"
          }, q(e.isSaving ? "儲存中..." : "確認儲存"), 9, fa)
        ])
      ]))
    ]));
  }
}), pa = { class: "space-y-4 p-6 bg-white rounded-2xl border border-slate-100 shadow-sm" }, ha = { class: "flex justify-between items-center mb-8" }, wa = { class: "flex gap-3" }, ga = ["disabled"], ba = {
  key: 0,
  class: "py-20 text-center bg-slate-100 rounded-3xl border-2 border-dashed border-slate-200"
}, va = {
  key: 1,
  class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
}, _a = ["onClick"], ya = { class: "flex items-center gap-4" }, Ea = { class: "w-12 h-12 bg-slate-100 text-slate-700 rounded-xl flex items-center justify-center text-lg font-black group-hover:bg-blue-700 group-hover:text-white transition-colors" }, ka = { class: "font-bold text-slate-700" }, xa = { class: "text-xs text-slate-700 font-bold" }, Ca = {
  key: 2,
  class: "fixed inset-0 bg-slate-700 backdrop-blur-sm flex items-center justify-center p-4 z-100"
}, Ta = { class: "bg-white rounded-[2rem] p-8 max-w-md w-full shadow-2xl" }, La = { class: "text-2xl font-black text-slate-700 mb-6" }, Na = { class: "space-y-4" }, Aa = { class: "grid grid-cols-2 gap-4" }, Oa = { class: "bg-blue-100 p-5 rounded-2xl space-y-3" }, Ia = { class: "grid grid-cols-2 gap-3" }, Sa = { class: "flex gap-4 mt-8" }, Da = /* @__PURE__ */ ut({
  __name: "TableLayoutManager",
  props: {
    configs: {},
    loading: { type: Boolean }
  },
  emits: ["save", "refresh"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = z(!1), r = vs({}), a = (i) => {
      i ? Object.assign(r, JSON.parse(JSON.stringify(i))) : Object.assign(r, {
        id: void 0,
        table_number: n.configs.length > 0 ? Math.max(...n.configs.map((f) => f.table_number)) + 1 : 1,
        zone_id: 1,
        min_people: 2,
        max_people: 4
      }), s.value = !0;
    }, l = () => {
      o("save", { ...r }), s.value = !1;
    };
    return (i, f) => (V(), H("div", pa, [
      h("header", ha, [
        f[7] || (f[7] = h("div", null, [
          h("h2", { class: "text-2xl font-black text-slate-700" }, "桌位佈局管理"),
          h("p", { class: "text-sm text-slate-700" }, "管理區域、桌號與人數上限")
        ], -1)),
        h("div", wa, [
          h("button", {
            onClick: f[0] || (f[0] = (g) => i.$emit("refresh")),
            disabled: e.loading,
            class: "p-2 text-slate-700 hover:text-blue-700 transition-colors"
          }, [
            h("span", {
              class: Pe({ "animate-spin inline-block": e.loading })
            }, "🔄", 2)
          ], 8, ga),
          h("button", {
            onClick: f[1] || (f[1] = (g) => a()),
            class: "bg-blue-700 text-white px-6 py-2 rounded-xl font-bold shadow-lg hover:bg-blue-700 transition"
          }, " + 新增桌位 ")
        ])
      ]),
      e.loading && e.configs.length === 0 ? (V(), H("div", ba, [...f[8] || (f[8] = [
        h("p", { class: "text-slate-700 font-bold" }, "讀取配置中...", -1)
      ])])) : (V(), H("div", va, [
        (V(!0), H(xe, null, We(e.configs, (g) => (V(), H("div", {
          key: g.id,
          onClick: (y) => a(g),
          class: "bg-white p-5 rounded-2xl border border-slate-100 shadow-sm hover:border-blue-200 hover:shadow-md transition cursor-pointer flex justify-between items-center group"
        }, [
          h("div", ya, [
            h("div", Ea, q(g.table_number), 1),
            h("div", null, [
              h("div", ka, "桌號 #" + q(g.table_number), 1),
              h("div", xa, "區域 " + q(g.zone_id) + " • " + q(g.min_people) + "-" + q(g.max_people) + " 人", 1)
            ])
          ]),
          f[9] || (f[9] = h("span", { class: "text-blue-700 opacity-0 group-hover:opacity-100 transition-opacity text-sm font-bold" }, "編輯", -1))
        ], 8, _a))), 128))
      ])),
      s.value ? (V(), H("div", Ca, [
        h("div", Ta, [
          h("h2", La, q(r.id ? "編輯桌位" : "新增桌位"), 1),
          h("div", Na, [
            h("div", Aa, [
              h("div", null, [
                f[10] || (f[10] = h("label", { class: "text-xs font-black text-slate-700 uppercase mb-1 block" }, "桌號", -1)),
                Ge(h("input", {
                  "onUpdate:modelValue": f[2] || (f[2] = (g) => r.table_number = g),
                  type: "number",
                  class: "w-full bg-slate-100 border-none rounded-xl p-3 focus:ring-2 ring-blue-700 outline-none font-bold"
                }, null, 512), [
                  [
                    ft,
                    r.table_number,
                    void 0,
                    { number: !0 }
                  ]
                ])
              ]),
              h("div", null, [
                f[11] || (f[11] = h("label", { class: "text-xs font-black text-slate-700 uppercase mb-1 block" }, "區域", -1)),
                Ge(h("input", {
                  "onUpdate:modelValue": f[3] || (f[3] = (g) => r.zone_id = g),
                  type: "number",
                  class: "w-full bg-slate-100 border-none rounded-xl p-3 focus:ring-2 ring-blue-700 outline-none font-bold"
                }, null, 512), [
                  [
                    ft,
                    r.zone_id,
                    void 0,
                    { number: !0 }
                  ]
                ])
              ])
            ]),
            h("div", Oa, [
              f[12] || (f[12] = h("p", { class: "text-xs font-black text-blue-700 uppercase" }, "人數設定", -1)),
              h("div", Ia, [
                Ge(h("input", {
                  "onUpdate:modelValue": f[4] || (f[4] = (g) => r.min_people = g),
                  type: "number",
                  placeholder: "最小",
                  class: "w-full border-none rounded-xl p-3 shadow-inner font-bold"
                }, null, 512), [
                  [
                    ft,
                    r.min_people,
                    void 0,
                    { number: !0 }
                  ]
                ]),
                Ge(h("input", {
                  "onUpdate:modelValue": f[5] || (f[5] = (g) => r.max_people = g),
                  type: "number",
                  placeholder: "最大",
                  class: "w-full border-none rounded-xl p-3 shadow-inner font-bold"
                }, null, 512), [
                  [
                    ft,
                    r.max_people,
                    void 0,
                    { number: !0 }
                  ]
                ])
              ])
            ])
          ]),
          h("div", Sa, [
            h("button", {
              onClick: f[6] || (f[6] = (g) => s.value = !1),
              class: "flex-1 py-4 text-slate-700 font-bold"
            }, "取消"),
            h("button", {
              onClick: l,
              class: "flex-[2] py-4 bg-blue-700 text-white rounded-2xl font-black text-lg shadow-lg"
            }, "確認儲存")
          ])
        ])
      ])) : $e("", !0)
    ]));
  }
}), Pa = { class: "space-y-10" }, $a = { class: "flex items-center justify-between border-b-2 border-slate-700 pb-4" }, Ma = ["disabled"], Ra = {
  key: 0,
  class: "py-10 text-center font-black text-slate-700"
}, Fa = {
  key: 1,
  class: "space-y-12"
}, Ua = { class: "grid grid-cols-7 gap-1" }, Ba = ["onClick"], Va = /* @__PURE__ */ ut({
  __name: "HolidayAdminPage",
  props: {
    holidayData: {},
    loading: { type: Boolean },
    isSaving: { type: Boolean }
  },
  emits: ["save"],
  setup(e, { emit: t }) {
    const n = e, o = t, s = z({ 0: [], 1: [], 2: [] }), r = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"], a = z(""), l = z("");
    wt(() => n.holidayData, (y) => {
      s.value = JSON.parse(JSON.stringify(y)), a.value = s.value[2].join(", "), l.value = s.value[1].map((m) => m.toString().padStart(4, "0")).join(", ");
    }, { immediate: !0, deep: !0 });
    const i = (y) => {
      const m = s.value[0].indexOf(y);
      m > -1 ? s.value[0].splice(m, 1) : s.value[0].push(y);
    }, f = () => {
      const y = a.value.split(",").map((S) => Number.parseInt(S.trim())).filter((S) => !Number.isNaN(S) && S >= 1 && S <= 31), m = l.value.split(",").map((S) => Number.parseInt(S.trim())).filter((S) => !Number.isNaN(S) && S >= 101 && S <= 1231), T = {
        0: s.value[0],
        1: Array.from(new Set(m)).sort((S, p) => S - p),
        2: Array.from(new Set(y)).sort((S, p) => S - p)
      };
      o("save", T);
    }, g = () => {
      const y = localStorage.getItem("merchantId");
      if (y) {
        const m = `/booking/${y}`;
        window.open(m, "_blank");
      } else
        alert("找不到商家資訊，無法前往預約頁面。");
    };
    return (y, m) => (V(), H("div", Pa, [
      h("div", { class: "flex items-center gap-2 mb-4" }, [
        h("button", {
          onClick: g,
          class: "bg-blue-700 text-white px-6 py-3 font-black text-sm hover:bg-sky-700 active:scale-95 transition-all shadow-lg hover:shadow-xl"
        }, " 線上預約頁面 ")
      ]),
      h("div", $a, [
        m[2] || (m[2] = h("h3", { class: "text-xl font-black text-slate-700 uppercase tracking-tight" }, "Holiday Configuration", -1)),
        h("button", {
          onClick: f,
          disabled: e.isSaving || e.loading,
          class: "bg-slate-700 text-white px-6 py-2 font-black text-sm hover:bg-slate-700 active:scale-95 transition-all disabled:bg-slate-100"
        }, q(e.isSaving ? "SAVING..." : "CONFIRM SAVE"), 9, Ma)
      ]),
      e.loading ? (V(), H("div", Ra, "LOADING...")) : (V(), H("div", Fa, [
        h("section", null, [
          m[3] || (m[3] = h("div", { class: "flex items-center gap-2 mb-4" }, [
            h("span", { class: "bg-slate-700 text-white text-[10px] px-2 py-0.5 font-black" }, "TYPE 0"),
            h("h4", { class: "text-xs font-black text-slate-700 uppercase tracking-widest" }, "Weekly Recurring")
          ], -1)),
          h("div", Ua, [
            (V(), H(xe, null, We(r, (T, S) => h("button", {
              key: S,
              onClick: (p) => i(S),
              class: Pe([s.value[0].includes(S) ? "bg-slate-700 text-white" : "bg-slate-100 text-slate-700", "py-4 font-black text-xs transition-all border border-transparent hover:border-slate-700"])
            }, q(T), 11, Ba)), 64))
          ])
        ]),
        h("section", null, [
          m[4] || (m[4] = h("div", { class: "flex items-center gap-2 mb-4" }, [
            h("span", { class: "bg-slate-700 text-white text-[10px] px-2 py-0.5 font-black" }, "TYPE 2"),
            h("h4", { class: "text-xs font-black text-slate-700 uppercase tracking-widest" }, "Monthly Recurring (Days)")
          ], -1)),
          Ge(h("input", {
            "onUpdate:modelValue": m[0] || (m[0] = (T) => a.value = T),
            placeholder: "Ex: 1, 15, 31",
            class: "w-full bg-slate-100 border-l-4 border-slate-700 p-4 font-black text-slate-700 outline-none focus:bg-white transition-colors"
          }, null, 512), [
            [ft, a.value]
          ]),
          m[5] || (m[5] = h("p", { class: "text-[10px] text-slate-700 mt-2 font-bold uppercase tracking-tighter" }, "Use commas to separate days (1-31)", -1))
        ]),
        h("section", null, [
          m[6] || (m[6] = h("div", { class: "flex items-center gap-2 mb-4" }, [
            h("span", { class: "bg-slate-700 text-white text-[10px] px-2 py-0.5 font-black" }, "TYPE 1"),
            h("h4", { class: "text-xs font-black text-slate-700 uppercase tracking-widest" }, "Specific Dates (MMDD)")
          ], -1)),
          Ge(h("input", {
            "onUpdate:modelValue": m[1] || (m[1] = (T) => l.value = T),
            placeholder: "Ex: 0101, 1225",
            class: "w-full bg-slate-100 border-l-4 border-slate-700 p-4 font-black text-slate-700 outline-none focus:bg-white transition-colors"
          }, null, 512), [
            [ft, l.value]
          ]),
          m[7] || (m[7] = h("p", { class: "text-[10px] text-slate-700 mt-2 font-bold uppercase tracking-tighter" }, "Use commas to separate dates (MonthDay format)", -1))
        ])
      ]))
    ]));
  }
}), Ha = { class: "p-8 space-y-12 max-w-4xl" }, Ya = { class: "bg-white p-8 border-2 border-slate-700" }, ja = { class: "p-8" }, Wa = { class: "max-w-5xl mx-auto" }, Ga = {
  key: 0,
  class: "fixed bottom-8 right-8 bg-red-600 text-white px-6 py-4 rounded-2xl shadow-2xl flex items-center gap-3"
}, Ka = /* @__PURE__ */ ut({
  __name: "BookingConfigPage",
  props: {
    bookingApi: {},
    bookingTimeApi: {},
    holidayApi: {}
  },
  setup(e) {
    const t = e, {
      configs: n,
      // 重命名為時間配置
      loading: o,
      isSaving: s,
      loadConfigs: r,
      updateConfigs: a
    } = ea(t.bookingTimeApi), { configs: l, isLoading: i, error: f, fetchConfigs: g, saveConfig: y } = Qr(t.bookingApi);
    z(!1), vs({
      id: void 0,
      merchant_id: "",
      // 提交前會由後端或 Service 補上
      table_number: 1,
      zone_id: 1,
      min_people: 2,
      max_people: 4
    }), kn(async () => {
      await g(), await r(), await T();
    });
    const {
      holidayData: m,
      loadHolidays: T
    } = ta(t.holidayApi), S = z(!1), p = z(!1), E = async (u) => {
      p.value = !0;
      try {
        await t.holidayApi.saveHolidays(u), m.value = u;
      } finally {
        p.value = !1;
      }
    };
    return (u, b) => (V(), H(xe, null, [
      h("div", Ha, [
        h("div", Ya, [
          kt(Va, {
            holidayData: ae(m),
            loading: S.value,
            isSaving: p.value,
            onSave: E
          }, null, 8, ["holidayData", "loading", "isSaving"])
        ])
      ]),
      h("div", ja, [
        kt(ma, {
          configs: ae(n),
          loading: ae(o),
          isSaving: ae(s),
          onSave: ae(a)
        }, null, 8, ["configs", "loading", "isSaving", "onSave"])
      ]),
      h("div", Wa, [
        kt(Da, {
          configs: ae(l),
          loading: ae(i),
          onRefresh: ae(g),
          onSave: ae(y)
        }, null, 8, ["configs", "loading", "onRefresh", "onSave"]),
        kt(oo, { name: "fade" }, {
          default: so(() => [
            ae(f) ? (V(), H("div", Ga, [
              h("span", null, "⚠️ " + q(ae(f)), 1),
              h("button", {
                onClick: b[0] || (b[0] = (x) => f.value = null),
                class: "bg-white/20 rounded-full w-6 h-6"
              }, "✕")
            ])) : $e("", !0)
          ]),
          _: 1
        })
      ])
    ], 64));
  }
}), ro = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, s] of t)
    n[o] = s;
  return n;
}, sm = /* @__PURE__ */ ro(Ka, [["__scopeId", "data-v-40890156"]]);
var ao = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ys(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Es = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(ao, function() {
    var n = 1e3, o = 6e4, s = 36e5, r = "millisecond", a = "second", l = "minute", i = "hour", f = "day", g = "week", y = "month", m = "quarter", T = "year", S = "date", p = "Invalid Date", E = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, u = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, b = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(O) {
      var I = ["th", "st", "nd", "rd"], D = O % 100;
      return "[" + O + (I[(D - 20) % 10] || I[D] || I[0]) + "]";
    } }, x = function(O, I, D) {
      var F = String(O);
      return !F || F.length >= I ? O : "" + Array(I + 1 - F.length).join(D) + O;
    }, _ = { s: x, z: function(O) {
      var I = -O.utcOffset(), D = Math.abs(I), F = Math.floor(D / 60), P = D % 60;
      return (I <= 0 ? "+" : "-") + x(F, 2, "0") + ":" + x(P, 2, "0");
    }, m: function O(I, D) {
      if (I.date() < D.date()) return -O(D, I);
      var F = 12 * (D.year() - I.year()) + (D.month() - I.month()), P = I.clone().add(F, y), W = D - P < 0, B = I.clone().add(F + (W ? -1 : 1), y);
      return +(-(F + (D - P) / (W ? P - B : B - P)) || 0);
    }, a: function(O) {
      return O < 0 ? Math.ceil(O) || 0 : Math.floor(O);
    }, p: function(O) {
      return { M: y, y: T, w: g, d: f, D: S, h: i, m: l, s: a, ms: r, Q: m }[O] || String(O || "").toLowerCase().replace(/s$/, "");
    }, u: function(O) {
      return O === void 0;
    } }, A = "en", N = {};
    N[A] = b;
    var k = "$isDayjsObject", j = function(O) {
      return O instanceof U || !(!O || !O[k]);
    }, K = function O(I, D, F) {
      var P;
      if (!I) return A;
      if (typeof I == "string") {
        var W = I.toLowerCase();
        N[W] && (P = W), D && (N[W] = D, P = W);
        var B = I.split("-");
        if (!P && B.length > 1) return O(B[0]);
      } else {
        var J = I.name;
        N[J] = I, P = J;
      }
      return !F && P && (A = P), P || !F && A;
    }, X = function(O, I) {
      if (j(O)) return O.clone();
      var D = typeof I == "object" ? I : {};
      return D.date = O, D.args = arguments, new U(D);
    }, G = _;
    G.l = K, G.i = j, G.w = function(O, I) {
      return X(O, { locale: I.$L, utc: I.$u, x: I.$x, $offset: I.$offset });
    };
    var U = function() {
      function O(D) {
        this.$L = K(D.locale, null, !0), this.parse(D), this.$x = this.$x || D.x || {}, this[k] = !0;
      }
      var I = O.prototype;
      return I.parse = function(D) {
        this.$d = function(F) {
          var P = F.date, W = F.utc;
          if (P === null) return /* @__PURE__ */ new Date(NaN);
          if (G.u(P)) return /* @__PURE__ */ new Date();
          if (P instanceof Date) return new Date(P);
          if (typeof P == "string" && !/Z$/i.test(P)) {
            var B = P.match(E);
            if (B) {
              var J = B[2] - 1 || 0, le = (B[7] || "0").substring(0, 3);
              return W ? new Date(Date.UTC(B[1], J, B[3] || 1, B[4] || 0, B[5] || 0, B[6] || 0, le)) : new Date(B[1], J, B[3] || 1, B[4] || 0, B[5] || 0, B[6] || 0, le);
            }
          }
          return new Date(P);
        }(D), this.init();
      }, I.init = function() {
        var D = this.$d;
        this.$y = D.getFullYear(), this.$M = D.getMonth(), this.$D = D.getDate(), this.$W = D.getDay(), this.$H = D.getHours(), this.$m = D.getMinutes(), this.$s = D.getSeconds(), this.$ms = D.getMilliseconds();
      }, I.$utils = function() {
        return G;
      }, I.isValid = function() {
        return this.$d.toString() !== p;
      }, I.isSame = function(D, F) {
        var P = X(D);
        return this.startOf(F) <= P && P <= this.endOf(F);
      }, I.isAfter = function(D, F) {
        return X(D) < this.startOf(F);
      }, I.isBefore = function(D, F) {
        return this.endOf(F) < X(D);
      }, I.$g = function(D, F, P) {
        return G.u(D) ? this[F] : this.set(P, D);
      }, I.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, I.valueOf = function() {
        return this.$d.getTime();
      }, I.startOf = function(D, F) {
        var P = this, W = !!G.u(F) || F, B = G.p(D), J = function(je, ve) {
          var Be = G.w(P.$u ? Date.UTC(P.$y, ve, je) : new Date(P.$y, ve, je), P);
          return W ? Be : Be.endOf(f);
        }, le = function(je, ve) {
          return G.w(P.toDate()[je].apply(P.toDate("s"), (W ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ve)), P);
        }, de = this.$W, be = this.$M, Ce = this.$D, ot = "set" + (this.$u ? "UTC" : "");
        switch (B) {
          case T:
            return W ? J(1, 0) : J(31, 11);
          case y:
            return W ? J(1, be) : J(0, be + 1);
          case g:
            var Ye = this.$locale().weekStart || 0, qe = (de < Ye ? de + 7 : de) - Ye;
            return J(W ? Ce - qe : Ce + (6 - qe), be);
          case f:
          case S:
            return le(ot + "Hours", 0);
          case i:
            return le(ot + "Minutes", 1);
          case l:
            return le(ot + "Seconds", 2);
          case a:
            return le(ot + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, I.endOf = function(D) {
        return this.startOf(D, !1);
      }, I.$set = function(D, F) {
        var P, W = G.p(D), B = "set" + (this.$u ? "UTC" : ""), J = (P = {}, P[f] = B + "Date", P[S] = B + "Date", P[y] = B + "Month", P[T] = B + "FullYear", P[i] = B + "Hours", P[l] = B + "Minutes", P[a] = B + "Seconds", P[r] = B + "Milliseconds", P)[W], le = W === f ? this.$D + (F - this.$W) : F;
        if (W === y || W === T) {
          var de = this.clone().set(S, 1);
          de.$d[J](le), de.init(), this.$d = de.set(S, Math.min(this.$D, de.daysInMonth())).$d;
        } else J && this.$d[J](le);
        return this.init(), this;
      }, I.set = function(D, F) {
        return this.clone().$set(D, F);
      }, I.get = function(D) {
        return this[G.p(D)]();
      }, I.add = function(D, F) {
        var P, W = this;
        D = Number(D);
        var B = G.p(F), J = function(be) {
          var Ce = X(W);
          return G.w(Ce.date(Ce.date() + Math.round(be * D)), W);
        };
        if (B === y) return this.set(y, this.$M + D);
        if (B === T) return this.set(T, this.$y + D);
        if (B === f) return J(1);
        if (B === g) return J(7);
        var le = (P = {}, P[l] = o, P[i] = s, P[a] = n, P)[B] || 1, de = this.$d.getTime() + D * le;
        return G.w(de, this);
      }, I.subtract = function(D, F) {
        return this.add(-1 * D, F);
      }, I.format = function(D) {
        var F = this, P = this.$locale();
        if (!this.isValid()) return P.invalidDate || p;
        var W = D || "YYYY-MM-DDTHH:mm:ssZ", B = G.z(this), J = this.$H, le = this.$m, de = this.$M, be = P.weekdays, Ce = P.months, ot = P.meridiem, Ye = function(ve, Be, st, ze) {
          return ve && (ve[Be] || ve(F, W)) || st[Be].slice(0, ze);
        }, qe = function(ve) {
          return G.s(J % 12 || 12, ve, "0");
        }, je = ot || function(ve, Be, st) {
          var ze = ve < 12 ? "AM" : "PM";
          return st ? ze.toLowerCase() : ze;
        };
        return W.replace(u, function(ve, Be) {
          return Be || function(st) {
            switch (st) {
              case "YY":
                return String(F.$y).slice(-2);
              case "YYYY":
                return G.s(F.$y, 4, "0");
              case "M":
                return de + 1;
              case "MM":
                return G.s(de + 1, 2, "0");
              case "MMM":
                return Ye(P.monthsShort, de, Ce, 3);
              case "MMMM":
                return Ye(Ce, de);
              case "D":
                return F.$D;
              case "DD":
                return G.s(F.$D, 2, "0");
              case "d":
                return String(F.$W);
              case "dd":
                return Ye(P.weekdaysMin, F.$W, be, 2);
              case "ddd":
                return Ye(P.weekdaysShort, F.$W, be, 3);
              case "dddd":
                return be[F.$W];
              case "H":
                return String(J);
              case "HH":
                return G.s(J, 2, "0");
              case "h":
                return qe(1);
              case "hh":
                return qe(2);
              case "a":
                return je(J, le, !0);
              case "A":
                return je(J, le, !1);
              case "m":
                return String(le);
              case "mm":
                return G.s(le, 2, "0");
              case "s":
                return String(F.$s);
              case "ss":
                return G.s(F.$s, 2, "0");
              case "SSS":
                return G.s(F.$ms, 3, "0");
              case "Z":
                return B;
            }
            return null;
          }(ve) || B.replace(":", "");
        });
      }, I.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, I.diff = function(D, F, P) {
        var W, B = this, J = G.p(F), le = X(D), de = (le.utcOffset() - this.utcOffset()) * o, be = this - le, Ce = function() {
          return G.m(B, le);
        };
        switch (J) {
          case T:
            W = Ce() / 12;
            break;
          case y:
            W = Ce();
            break;
          case m:
            W = Ce() / 3;
            break;
          case g:
            W = (be - de) / 6048e5;
            break;
          case f:
            W = (be - de) / 864e5;
            break;
          case i:
            W = be / s;
            break;
          case l:
            W = be / o;
            break;
          case a:
            W = be / n;
            break;
          default:
            W = be;
        }
        return P ? W : G.a(W);
      }, I.daysInMonth = function() {
        return this.endOf(y).$D;
      }, I.$locale = function() {
        return N[this.$L];
      }, I.locale = function(D, F) {
        if (!D) return this.$L;
        var P = this.clone(), W = K(D, F, !0);
        return W && (P.$L = W), P;
      }, I.clone = function() {
        return G.w(this.$d, this);
      }, I.toDate = function() {
        return new Date(this.valueOf());
      }, I.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, I.toISOString = function() {
        return this.$d.toISOString();
      }, I.toString = function() {
        return this.$d.toUTCString();
      }, O;
    }(), te = U.prototype;
    return X.prototype = te, [["$ms", r], ["$s", a], ["$m", l], ["$H", i], ["$W", f], ["$M", y], ["$y", T], ["$D", S]].forEach(function(O) {
      te[O[1]] = function(I) {
        return this.$g(I, O[0], O[1]);
      };
    }), X.extend = function(O, I) {
      return O.$i || (O(I, U, X), O.$i = !0), X;
    }, X.locale = K, X.isDayjs = j, X.unix = function(O) {
      return X(1e3 * O);
    }, X.en = N[A], X.Ls = N, X.p = {}, X;
  });
})(Es);
var ks = Es.exports;
const at = /* @__PURE__ */ ys(ks);
var Xa = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o(ks);
  })(ao, function(n) {
    function o(a) {
      return a && typeof a == "object" && "default" in a ? a : { default: a };
    }
    var s = o(n), r = { name: "zh-tw", weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"), weekdaysShort: "週日_週一_週二_週三_週四_週五_週六".split("_"), weekdaysMin: "日_一_二_三_四_五_六".split("_"), months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"), monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"), ordinal: function(a, l) {
      return l === "W" ? a + "週" : a + "日";
    }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "YYYY/MM/DD", LL: "YYYY年M月D日", LLL: "YYYY年M月D日 HH:mm", LLLL: "YYYY年M月D日dddd HH:mm", l: "YYYY/M/D", ll: "YYYY年M月D日", lll: "YYYY年M月D日 HH:mm", llll: "YYYY年M月D日dddd HH:mm" }, relativeTime: { future: "%s內", past: "%s前", s: "幾秒", m: "1 分鐘", mm: "%d 分鐘", h: "1 小時", hh: "%d 小時", d: "1 天", dd: "%d 天", M: "1 個月", MM: "%d 個月", y: "1 年", yy: "%d 年" }, meridiem: function(a, l) {
      var i = 100 * a + l;
      return i < 600 ? "凌晨" : i < 900 ? "早上" : i < 1100 ? "上午" : i < 1300 ? "中午" : i < 1800 ? "下午" : "晚上";
    } };
    return s.default.locale(r, null, !0), r;
  });
})(Xa);
var xs = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(ao, function() {
    var n = "minute", o = /[+-]\d\d(?::?\d\d)?/g, s = /([+-]|\d\d)/g;
    return function(r, a, l) {
      var i = a.prototype;
      l.utc = function(p) {
        var E = { date: p, utc: !0, args: arguments };
        return new a(E);
      }, i.utc = function(p) {
        var E = l(this.toDate(), { locale: this.$L, utc: !0 });
        return p ? E.add(this.utcOffset(), n) : E;
      }, i.local = function() {
        return l(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var f = i.parse;
      i.parse = function(p) {
        p.utc && (this.$u = !0), this.$utils().u(p.$offset) || (this.$offset = p.$offset), f.call(this, p);
      };
      var g = i.init;
      i.init = function() {
        if (this.$u) {
          var p = this.$d;
          this.$y = p.getUTCFullYear(), this.$M = p.getUTCMonth(), this.$D = p.getUTCDate(), this.$W = p.getUTCDay(), this.$H = p.getUTCHours(), this.$m = p.getUTCMinutes(), this.$s = p.getUTCSeconds(), this.$ms = p.getUTCMilliseconds();
        } else g.call(this);
      };
      var y = i.utcOffset;
      i.utcOffset = function(p, E) {
        var u = this.$utils().u;
        if (u(p)) return this.$u ? 0 : u(this.$offset) ? y.call(this) : this.$offset;
        if (typeof p == "string" && (p = function(A) {
          A === void 0 && (A = "");
          var N = A.match(o);
          if (!N) return null;
          var k = ("" + N[0]).match(s) || ["-", 0, 0], j = k[0], K = 60 * +k[1] + +k[2];
          return K === 0 ? 0 : j === "+" ? K : -K;
        }(p), p === null)) return this;
        var b = Math.abs(p) <= 16 ? 60 * p : p;
        if (b === 0) return this.utc(E);
        var x = this.clone();
        if (E) return x.$offset = b, x.$u = !1, x;
        var _ = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
        return (x = this.local().add(b + _, n)).$offset = b, x.$x.$localOffset = _, x;
      };
      var m = i.format;
      i.format = function(p) {
        var E = p || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return m.call(this, E);
      }, i.valueOf = function() {
        var p = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * p;
      }, i.isUTC = function() {
        return !!this.$u;
      }, i.toISOString = function() {
        return this.toDate().toISOString();
      }, i.toString = function() {
        return this.toDate().toUTCString();
      };
      var T = i.toDate;
      i.toDate = function(p) {
        return p === "s" && this.$offset ? l(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : T.call(this);
      };
      var S = i.diff;
      i.diff = function(p, E, u) {
        if (p && this.$u === p.$u) return S.call(this, p, E, u);
        var b = this.local(), x = l(p).local();
        return S.call(b, x, E, u);
      };
    };
  });
})(xs);
var qa = xs.exports;
const za = /* @__PURE__ */ ys(qa);
/*!
* sweetalert2 v11.26.17
* Released under the MIT License.
*/
function Cs(e, t, n) {
  if (typeof e == "function" ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
  throw new TypeError("Private element is not present on this object");
}
function Ja(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function So(e, t) {
  return e.get(Cs(e, t));
}
function Za(e, t, n) {
  Ja(e, t), t.set(e, n);
}
function Qa(e, t, n) {
  return e.set(Cs(e, t), n), n;
}
const ei = 100, R = {}, ti = () => {
  R.previousActiveElement instanceof HTMLElement ? (R.previousActiveElement.focus(), R.previousActiveElement = null) : document.body && document.body.focus();
}, ni = (e) => new Promise((t) => {
  if (!e)
    return t();
  const n = window.scrollX, o = window.scrollY;
  R.restoreFocusTimeout = setTimeout(() => {
    ti(), t();
  }, ei), window.scrollTo(n, o);
}), Ts = "swal2-", oi = ["container", "shown", "height-auto", "iosfix", "popup", "modal", "no-backdrop", "no-transition", "toast", "toast-shown", "show", "hide", "close", "title", "html-container", "actions", "confirm", "deny", "cancel", "footer", "icon", "icon-content", "image", "input", "file", "range", "select", "radio", "checkbox", "label", "textarea", "inputerror", "input-label", "validation-message", "progress-steps", "active-progress-step", "progress-step", "progress-step-line", "loader", "loading", "styled", "top", "top-start", "top-end", "top-left", "top-right", "center", "center-start", "center-end", "center-left", "center-right", "bottom", "bottom-start", "bottom-end", "bottom-left", "bottom-right", "grow-row", "grow-column", "grow-fullscreen", "rtl", "timer-progress-bar", "timer-progress-bar-container", "scrollbar-measure", "icon-success", "icon-warning", "icon-info", "icon-question", "icon-error", "draggable", "dragging"], w = oi.reduce(
  (e, t) => (e[t] = Ts + t, e),
  /** @type {SwalClasses} */
  {}
), si = ["success", "warning", "info", "question", "error"], un = si.reduce(
  (e, t) => (e[t] = Ts + t, e),
  /** @type {SwalIcons} */
  {}
), Ls = "SweetAlert2:", io = (e) => e.charAt(0).toUpperCase() + e.slice(1), Oe = (e) => {
  console.warn(`${Ls} ${typeof e == "object" ? e.join(" ") : e}`);
}, Ot = (e) => {
  console.error(`${Ls} ${e}`);
}, Do = [], ri = (e) => {
  Do.includes(e) || (Do.push(e), Oe(e));
}, Ns = (e, t = null) => {
  ri(`"${e}" is deprecated and will be removed in the next major release.${t ? ` Use "${t}" instead.` : ""}`);
}, xn = (e) => typeof e == "function" ? e() : e, lo = (e) => e && typeof e.toPromise == "function", Jt = (e) => lo(e) ? e.toPromise() : Promise.resolve(e), co = (e) => e && Promise.resolve(e) === e, Ie = () => document.body.querySelector(`.${w.container}`), Zt = (e) => {
  const t = Ie();
  return t ? t.querySelector(e) : null;
}, Fe = (e) => Zt(`.${e}`), se = () => Fe(w.popup), Ft = () => Fe(w.icon), ai = () => Fe(w["icon-content"]), As = () => Fe(w.title), uo = () => Fe(w["html-container"]), Os = () => Fe(w.image), fo = () => Fe(w["progress-steps"]), Cn = () => Fe(w["validation-message"]), tt = () => (
  /** @type {HTMLButtonElement} */
  Zt(`.${w.actions} .${w.confirm}`)
), Ut = () => (
  /** @type {HTMLButtonElement} */
  Zt(`.${w.actions} .${w.cancel}`)
), It = () => (
  /** @type {HTMLButtonElement} */
  Zt(`.${w.actions} .${w.deny}`)
), ii = () => Fe(w["input-label"]), Bt = () => Zt(`.${w.loader}`), Qt = () => Fe(w.actions), Is = () => Fe(w.footer), Tn = () => Fe(w["timer-progress-bar"]), mo = () => Fe(w.close), li = `
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`, po = () => {
  const e = se();
  if (!e)
    return [];
  const t = e.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'), n = Array.from(t).sort((r, a) => {
    const l = parseInt(r.getAttribute("tabindex") || "0"), i = parseInt(a.getAttribute("tabindex") || "0");
    return l > i ? 1 : l < i ? -1 : 0;
  }), o = e.querySelectorAll(li), s = Array.from(o).filter((r) => r.getAttribute("tabindex") !== "-1");
  return [...new Set(n.concat(s))].filter((r) => De(r));
}, ho = () => lt(document.body, w.shown) && !lt(document.body, w["toast-shown"]) && !lt(document.body, w["no-backdrop"]), Ln = () => {
  const e = se();
  return e ? lt(e, w.toast) : !1;
}, ci = () => {
  const e = se();
  return e ? e.hasAttribute("data-loading") : !1;
}, Ue = (e, t) => {
  if (e.textContent = "", t) {
    const o = new DOMParser().parseFromString(t, "text/html"), s = o.querySelector("head");
    s && Array.from(s.childNodes).forEach((a) => {
      e.appendChild(a);
    });
    const r = o.querySelector("body");
    r && Array.from(r.childNodes).forEach((a) => {
      a instanceof HTMLVideoElement || a instanceof HTMLAudioElement ? e.appendChild(a.cloneNode(!0)) : e.appendChild(a);
    });
  }
}, lt = (e, t) => {
  if (!t)
    return !1;
  const n = t.split(/\s+/);
  for (let o = 0; o < n.length; o++)
    if (!e.classList.contains(n[o]))
      return !1;
  return !0;
}, ui = (e, t) => {
  Array.from(e.classList).forEach((n) => {
    !Object.values(w).includes(n) && !Object.values(un).includes(n) && !Object.values(t.showClass || {}).includes(n) && e.classList.remove(n);
  });
}, Re = (e, t, n) => {
  if (ui(e, t), !t.customClass)
    return;
  const o = t.customClass[
    /** @type {keyof SweetAlertCustomClass} */
    n
  ];
  if (o) {
    if (typeof o != "string" && !o.forEach) {
      Oe(`Invalid type of customClass.${n}! Expected string or iterable object, got "${typeof o}"`);
      return;
    }
    oe(e, o);
  }
}, Nn = (e, t) => {
  if (!t)
    return null;
  switch (t) {
    case "select":
    case "textarea":
    case "file":
      return e.querySelector(`.${w.popup} > .${w[t]}`);
    case "checkbox":
      return e.querySelector(`.${w.popup} > .${w.checkbox} input`);
    case "radio":
      return e.querySelector(`.${w.popup} > .${w.radio} input:checked`) || e.querySelector(`.${w.popup} > .${w.radio} input:first-child`);
    case "range":
      return e.querySelector(`.${w.popup} > .${w.range} input`);
    default:
      return e.querySelector(`.${w.popup} > .${w.input}`);
  }
}, Ss = (e) => {
  if (e.focus(), e.type !== "file") {
    const t = e.value;
    e.value = "", e.value = t;
  }
}, Ds = (e, t, n) => {
  !e || !t || (typeof t == "string" && (t = t.split(/\s+/).filter(Boolean)), t.forEach((o) => {
    Array.isArray(e) ? e.forEach((s) => {
      n ? s.classList.add(o) : s.classList.remove(o);
    }) : n ? e.classList.add(o) : e.classList.remove(o);
  }));
}, oe = (e, t) => {
  Ds(e, t, !0);
}, He = (e, t) => {
  Ds(e, t, !1);
}, mt = (e, t) => {
  const n = Array.from(e.children);
  for (let o = 0; o < n.length; o++) {
    const s = n[o];
    if (s instanceof HTMLElement && lt(s, t))
      return s;
  }
}, Tt = (e, t, n) => {
  n === `${parseInt(`${n}`)}` && (n = parseInt(n)), n || parseInt(`${n}`) === 0 ? e.style.setProperty(t, typeof n == "number" ? `${n}px` : (
    /** @type {string} */
    n
  )) : e.style.removeProperty(t);
}, Ee = (e, t = "flex") => {
  e && (e.style.display = t);
}, Ne = (e) => {
  e && (e.style.display = "none");
}, wo = (e, t = "block") => {
  e && new MutationObserver(() => {
    en(e, e.innerHTML, t);
  }).observe(e, {
    childList: !0,
    subtree: !0
  });
}, Po = (e, t, n, o) => {
  const s = e.querySelector(t);
  s && s.style.setProperty(n, o);
}, en = (e, t, n = "flex") => {
  t ? Ee(e, n) : Ne(e);
}, De = (e) => !!(e && (e.offsetWidth || e.offsetHeight || e.getClientRects().length)), di = () => !De(tt()) && !De(It()) && !De(Ut()), Yn = (e) => e.scrollHeight > e.clientHeight, fi = (e, t) => {
  let n = (
    /** @type {HTMLElement | null} */
    e
  );
  for (; n && n !== t; ) {
    if (Yn(n))
      return !0;
    n = n.parentElement;
  }
  return !1;
}, Ps = (e) => {
  const t = window.getComputedStyle(e), n = parseFloat(t.getPropertyValue("animation-duration") || "0"), o = parseFloat(t.getPropertyValue("transition-duration") || "0");
  return n > 0 || o > 0;
}, go = (e, t = !1) => {
  const n = Tn();
  n && De(n) && (t && (n.style.transition = "none", n.style.width = "100%"), setTimeout(() => {
    n.style.transition = `width ${e / 1e3}s linear`, n.style.width = "0%";
  }, 10));
}, mi = () => {
  const e = Tn();
  if (!e)
    return;
  const t = parseInt(window.getComputedStyle(e).width);
  e.style.removeProperty("transition"), e.style.width = "100%";
  const n = parseInt(window.getComputedStyle(e).width), o = t / n * 100;
  e.style.width = `${o}%`;
}, pi = () => typeof window > "u" || typeof document > "u", hi = `
 <div aria-labelledby="${w.title}" aria-describedby="${w["html-container"]}" class="${w.popup}" tabindex="-1">
   <button type="button" class="${w.close}"></button>
   <ul class="${w["progress-steps"]}"></ul>
   <div class="${w.icon}"></div>
   <img class="${w.image}" />
   <h2 class="${w.title}" id="${w.title}"></h2>
   <div class="${w["html-container"]}" id="${w["html-container"]}"></div>
   <input class="${w.input}" id="${w.input}" />
   <input type="file" class="${w.file}" />
   <div class="${w.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${w.select}" id="${w.select}"></select>
   <div class="${w.radio}"></div>
   <label class="${w.checkbox}">
     <input type="checkbox" id="${w.checkbox}" />
     <span class="${w.label}"></span>
   </label>
   <textarea class="${w.textarea}" id="${w.textarea}"></textarea>
   <div class="${w["validation-message"]}" id="${w["validation-message"]}"></div>
   <div class="${w.actions}">
     <div class="${w.loader}"></div>
     <button type="button" class="${w.confirm}"></button>
     <button type="button" class="${w.deny}"></button>
     <button type="button" class="${w.cancel}"></button>
   </div>
   <div class="${w.footer}"></div>
   <div class="${w["timer-progress-bar-container"]}">
     <div class="${w["timer-progress-bar"]}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, ""), wi = () => {
  const e = Ie();
  return e ? (e.remove(), He([document.documentElement, document.body], [
    w["no-backdrop"],
    w["toast-shown"],
    // @ts-ignore: 'has-column' is not defined in swalClasses but may be set dynamically
    w["has-column"]
  ]), !0) : !1;
}, Et = () => {
  R.currentInstance && R.currentInstance.resetValidationMessage();
}, gi = () => {
  const e = se();
  if (!e)
    return;
  const t = mt(e, w.input), n = mt(e, w.file), o = e.querySelector(`.${w.range} input`), s = e.querySelector(`.${w.range} output`), r = mt(e, w.select), a = e.querySelector(`.${w.checkbox} input`), l = mt(e, w.textarea);
  t && (t.oninput = Et), n && (n.onchange = Et), r && (r.onchange = Et), a && (a.onchange = Et), l && (l.oninput = Et), o && s && (o.oninput = () => {
    Et(), s.value = o.value;
  }, o.onchange = () => {
    Et(), s.value = o.value;
  });
}, bi = (e) => {
  if (typeof e == "string") {
    const t = document.querySelector(e);
    if (!t)
      throw new Error(`Target element "${e}" not found`);
    return (
      /** @type {HTMLElement} */
      t
    );
  }
  return e;
}, vi = (e) => {
  const t = se();
  t && (t.setAttribute("role", e.toast ? "alert" : "dialog"), t.setAttribute("aria-live", e.toast ? "polite" : "assertive"), e.toast || t.setAttribute("aria-modal", "true"));
}, _i = (e) => {
  window.getComputedStyle(e).direction === "rtl" && (oe(Ie(), w.rtl), R.isRTL = !0);
}, yi = (e) => {
  const t = wi();
  if (pi()) {
    Ot("SweetAlert2 requires document to initialize");
    return;
  }
  const n = document.createElement("div");
  n.className = w.container, t && oe(n, w["no-transition"]), Ue(n, hi), n.dataset.swal2Theme = e.theme;
  const o = bi(e.target || "body");
  o.appendChild(n), e.topLayer && (n.setAttribute("popover", ""), n.showPopover()), vi(e), _i(o), gi();
}, bo = (e, t) => {
  e instanceof HTMLElement ? t.appendChild(e) : typeof e == "object" ? Ei(e, t) : e && Ue(t, e);
}, Ei = (e, t) => {
  "jquery" in e ? ki(t, e) : Ue(t, e.toString());
}, ki = (e, t) => {
  if (e.textContent = "", 0 in t)
    for (let n = 0; n in t; n++)
      e.appendChild(t[n].cloneNode(!0));
  else
    e.appendChild(t.cloneNode(!0));
}, xi = (e, t) => {
  const n = Qt(), o = Bt();
  !n || !o || (!t.showConfirmButton && !t.showDenyButton && !t.showCancelButton ? Ne(n) : Ee(n), Re(n, t, "actions"), Ci(n, o, t), Ue(o, t.loaderHtml || ""), Re(o, t, "loader"));
};
function Ci(e, t, n) {
  const o = tt(), s = It(), r = Ut();
  !o || !s || !r || (Rn(o, "confirm", n), Rn(s, "deny", n), Rn(r, "cancel", n), Ti(o, s, r, n), n.reverseButtons && (n.toast ? (e.insertBefore(r, o), e.insertBefore(s, o)) : (e.insertBefore(r, t), e.insertBefore(s, t), e.insertBefore(o, t))));
}
function Ti(e, t, n, o) {
  if (!o.buttonsStyling) {
    He([e, t, n], w.styled);
    return;
  }
  oe([e, t, n], w.styled), o.confirmButtonColor && e.style.setProperty("--swal2-confirm-button-background-color", o.confirmButtonColor), o.denyButtonColor && t.style.setProperty("--swal2-deny-button-background-color", o.denyButtonColor), o.cancelButtonColor && n.style.setProperty("--swal2-cancel-button-background-color", o.cancelButtonColor), Mn(e), Mn(t), Mn(n);
}
function Mn(e) {
  const t = window.getComputedStyle(e);
  if (t.getPropertyValue("--swal2-action-button-focus-box-shadow"))
    return;
  const n = t.backgroundColor.replace(/rgba?\((\d+), (\d+), (\d+).*/, "rgba($1, $2, $3, 0.5)");
  e.style.setProperty("--swal2-action-button-focus-box-shadow", t.getPropertyValue("--swal2-outline").replace(/ rgba\(.*/, ` ${n}`));
}
function Rn(e, t, n) {
  const o = (
    /** @type {'Confirm' | 'Deny' | 'Cancel'} */
    io(t)
  );
  en(e, n[`show${o}Button`], "inline-block"), Ue(e, n[`${t}ButtonText`] || ""), e.setAttribute("aria-label", n[`${t}ButtonAriaLabel`] || ""), e.className = w[t], Re(e, n, `${t}Button`);
}
const Li = (e, t) => {
  const n = mo();
  n && (Ue(n, t.closeButtonHtml || ""), Re(n, t, "closeButton"), en(n, t.showCloseButton), n.setAttribute("aria-label", t.closeButtonAriaLabel || ""));
}, Ni = (e, t) => {
  const n = Ie();
  n && (Ai(n, t.backdrop), Oi(n, t.position), Ii(n, t.grow), Re(n, t, "container"));
};
function Ai(e, t) {
  typeof t == "string" ? e.style.background = t : t || oe([document.documentElement, document.body], w["no-backdrop"]);
}
function Oi(e, t) {
  t && (t in w ? oe(e, w[t]) : (Oe('The "position" parameter is not valid, defaulting to "center"'), oe(e, w.center)));
}
function Ii(e, t) {
  t && oe(e, w[`grow-${t}`]);
}
var ie = {
  innerParams: /* @__PURE__ */ new WeakMap(),
  domCache: /* @__PURE__ */ new WeakMap()
};
const Si = ["input", "file", "range", "select", "radio", "checkbox", "textarea"], Di = (e, t) => {
  const n = se();
  if (!n)
    return;
  const o = ie.innerParams.get(e), s = !o || t.input !== o.input;
  Si.forEach((r) => {
    const a = mt(n, w[r]);
    a && (Mi(r, t.inputAttributes), a.className = w[r], s && Ne(a));
  }), t.input && (s && Pi(t), Ri(t));
}, Pi = (e) => {
  if (!e.input)
    return;
  if (!pe[e.input]) {
    Ot(`Unexpected type of input! Expected ${Object.keys(pe).join(" | ")}, got "${e.input}"`);
    return;
  }
  const t = $s(e.input);
  if (!t)
    return;
  const n = pe[e.input](t, e);
  Ee(t), e.inputAutoFocus && setTimeout(() => {
    Ss(n);
  });
}, $i = (e) => {
  for (let t = 0; t < e.attributes.length; t++) {
    const n = e.attributes[t].name;
    ["id", "type", "value", "style"].includes(n) || e.removeAttribute(n);
  }
}, Mi = (e, t) => {
  const n = se();
  if (!n)
    return;
  const o = Nn(n, e);
  if (o) {
    $i(o);
    for (const s in t)
      o.setAttribute(s, t[s]);
  }
}, Ri = (e) => {
  if (!e.input)
    return;
  const t = $s(e.input);
  t && Re(t, e, "input");
}, vo = (e, t) => {
  !e.placeholder && t.inputPlaceholder && (e.placeholder = t.inputPlaceholder);
}, tn = (e, t, n) => {
  if (n.inputLabel) {
    const o = document.createElement("label"), s = w["input-label"];
    o.setAttribute("for", e.id), o.className = s, typeof n.customClass == "object" && oe(o, n.customClass.inputLabel), o.innerText = n.inputLabel, t.insertAdjacentElement("beforebegin", o);
  }
}, $s = (e) => {
  const t = se();
  if (t)
    return mt(t, w[
      /** @type {SwalClass} */
      e
    ] || w.input);
}, dn = (e, t) => {
  ["string", "number"].includes(typeof t) ? e.value = `${t}` : co(t) || Oe(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof t}"`);
}, pe = {};
pe.text = pe.email = pe.password = pe.number = pe.tel = pe.url = pe.search = pe.date = pe["datetime-local"] = pe.time = pe.week = pe.month = /** @type {(input: Input | HTMLElement, params: SweetAlertOptions) => Input} */
(e, t) => {
  const n = (
    /** @type {HTMLInputElement} */
    e
  );
  return dn(n, t.inputValue), tn(n, n, t), vo(n, t), n.type = /** @type {string} */
  t.input, n;
};
pe.file = (e, t) => {
  const n = (
    /** @type {HTMLInputElement} */
    e
  );
  return tn(n, n, t), vo(n, t), n;
};
pe.range = (e, t) => {
  const n = (
    /** @type {HTMLElement} */
    e
  ), o = n.querySelector("input"), s = n.querySelector("output");
  return o && (dn(o, t.inputValue), o.type = /** @type {string} */
  t.input, tn(
    o,
    /** @type {Input} */
    e,
    t
  )), s && dn(s, t.inputValue), /** @type {Input} */
  e;
};
pe.select = (e, t) => {
  const n = (
    /** @type {HTMLSelectElement} */
    e
  );
  if (n.textContent = "", t.inputPlaceholder) {
    const o = document.createElement("option");
    Ue(o, t.inputPlaceholder), o.value = "", o.disabled = !0, o.selected = !0, n.appendChild(o);
  }
  return tn(n, n, t), n;
};
pe.radio = (e) => {
  const t = (
    /** @type {HTMLElement} */
    e
  );
  return t.textContent = "", /** @type {Input} */
  e;
};
pe.checkbox = (e, t) => {
  const n = se();
  if (!n)
    throw new Error("Popup not found");
  const o = Nn(n, "checkbox");
  if (!o)
    throw new Error("Checkbox input not found");
  o.value = "1", o.checked = !!t.inputValue;
  const r = /** @type {HTMLElement} */ e.querySelector("span");
  if (r) {
    const a = t.inputPlaceholder || t.inputLabel;
    a && Ue(r, a);
  }
  return o;
};
pe.textarea = (e, t) => {
  const n = (
    /** @type {HTMLTextAreaElement} */
    e
  );
  dn(n, t.inputValue), vo(n, t), tn(n, n, t);
  const o = (s) => parseInt(window.getComputedStyle(s).marginLeft) + parseInt(window.getComputedStyle(s).marginRight);
  return setTimeout(() => {
    if ("MutationObserver" in window) {
      const s = se();
      if (!s)
        return;
      const r = parseInt(window.getComputedStyle(s).width), a = () => {
        if (!document.body.contains(n))
          return;
        const l = n.offsetWidth + o(n), i = se();
        i && (l > r ? i.style.width = `${l}px` : Tt(i, "width", t.width));
      };
      new MutationObserver(a).observe(n, {
        attributes: !0,
        attributeFilter: ["style"]
      });
    }
  }), n;
};
const Fi = (e, t) => {
  const n = uo();
  n && (wo(n), Re(n, t, "htmlContainer"), t.html ? (bo(t.html, n), Ee(n, "block")) : t.text ? (n.textContent = t.text, Ee(n, "block")) : Ne(n), Di(e, t));
}, Ui = (e, t) => {
  const n = Is();
  n && (wo(n), en(n, !!t.footer, "block"), t.footer && bo(t.footer, n), Re(n, t, "footer"));
}, Bi = (e, t) => {
  const n = ie.innerParams.get(e), o = Ft();
  if (!o)
    return;
  if (n && t.icon === n.icon) {
    Mo(o, t), $o(o, t);
    return;
  }
  if (!t.icon && !t.iconHtml) {
    Ne(o);
    return;
  }
  if (t.icon && Object.keys(un).indexOf(t.icon) === -1) {
    Ot(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${t.icon}"`), Ne(o);
    return;
  }
  Ee(o), Mo(o, t), $o(o, t), oe(o, t.showClass && t.showClass.icon), window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", Ms);
}, $o = (e, t) => {
  for (const [n, o] of Object.entries(un))
    t.icon !== n && He(e, o);
  oe(e, t.icon && un[t.icon]), Yi(e, t), Ms(), Re(e, t, "icon");
}, Ms = () => {
  const e = se();
  if (!e)
    return;
  const t = window.getComputedStyle(e).getPropertyValue("background-color"), n = e.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix");
  for (let o = 0; o < n.length; o++)
    n[o].style.backgroundColor = t;
}, Vi = (e) => `
  ${e.animation ? '<div class="swal2-success-circular-line-left"></div>' : ""}
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div>
  ${e.animation ? '<div class="swal2-success-fix"></div>' : ""}
  ${e.animation ? '<div class="swal2-success-circular-line-right"></div>' : ""}
`, Hi = `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`, Mo = (e, t) => {
  if (!t.icon && !t.iconHtml)
    return;
  let n = e.innerHTML, o = "";
  t.iconHtml ? o = Ro(t.iconHtml) : t.icon === "success" ? (o = Vi(t), n = n.replace(/ style=".*?"/g, "")) : t.icon === "error" ? o = Hi : t.icon && (o = Ro({
    question: "?",
    warning: "!",
    info: "i"
  }[t.icon])), n.trim() !== o.trim() && Ue(e, o);
}, Yi = (e, t) => {
  if (t.iconColor) {
    e.style.color = t.iconColor, e.style.borderColor = t.iconColor;
    for (const n of [".swal2-success-line-tip", ".swal2-success-line-long", ".swal2-x-mark-line-left", ".swal2-x-mark-line-right"])
      Po(e, n, "background-color", t.iconColor);
    Po(e, ".swal2-success-ring", "border-color", t.iconColor);
  }
}, Ro = (e) => `<div class="${w["icon-content"]}">${e}</div>`, ji = (e, t) => {
  const n = Os();
  if (n) {
    if (!t.imageUrl) {
      Ne(n);
      return;
    }
    Ee(n, ""), n.setAttribute("src", t.imageUrl), n.setAttribute("alt", t.imageAlt || ""), Tt(n, "width", t.imageWidth), Tt(n, "height", t.imageHeight), n.className = w.image, Re(n, t, "image");
  }
};
let _o = !1, Rs = 0, Fs = 0, Us = 0, Bs = 0;
const Wi = (e) => {
  e.addEventListener("mousedown", fn), document.body.addEventListener("mousemove", mn), e.addEventListener("mouseup", pn), e.addEventListener("touchstart", fn), document.body.addEventListener("touchmove", mn), e.addEventListener("touchend", pn);
}, Gi = (e) => {
  e.removeEventListener("mousedown", fn), document.body.removeEventListener("mousemove", mn), e.removeEventListener("mouseup", pn), e.removeEventListener("touchstart", fn), document.body.removeEventListener("touchmove", mn), e.removeEventListener("touchend", pn);
}, fn = (e) => {
  const t = se();
  if (!t)
    return;
  const n = Ft();
  if (e.target === t || n && n.contains(
    /** @type {HTMLElement} */
    e.target
  )) {
    _o = !0;
    const o = Vs(e);
    Rs = o.clientX, Fs = o.clientY, Us = parseInt(t.style.insetInlineStart) || 0, Bs = parseInt(t.style.insetBlockStart) || 0, oe(t, "swal2-dragging");
  }
}, mn = (e) => {
  const t = se();
  if (t && _o) {
    let {
      clientX: n,
      clientY: o
    } = Vs(e);
    const s = n - Rs;
    t.style.insetInlineStart = `${Us + (R.isRTL ? -s : s)}px`, t.style.insetBlockStart = `${Bs + (o - Fs)}px`;
  }
}, pn = () => {
  const e = se();
  _o = !1, He(e, "swal2-dragging");
}, Vs = (e) => {
  let t = 0, n = 0;
  return e.type.startsWith("mouse") ? (t = /** @type {MouseEvent} */
  e.clientX, n = /** @type {MouseEvent} */
  e.clientY) : e.type.startsWith("touch") && (t = /** @type {TouchEvent} */
  e.touches[0].clientX, n = /** @type {TouchEvent} */
  e.touches[0].clientY), {
    clientX: t,
    clientY: n
  };
}, Ki = (e, t) => {
  const n = Ie(), o = se();
  if (!(!n || !o)) {
    if (t.toast) {
      Tt(n, "width", t.width), o.style.width = "100%";
      const s = Bt();
      s && o.insertBefore(s, Ft());
    } else
      Tt(o, "width", t.width);
    Tt(o, "padding", t.padding), t.color && (o.style.color = t.color), t.background && (o.style.background = t.background), Ne(Cn()), Xi(o, t), t.draggable && !t.toast ? (oe(o, w.draggable), Wi(o)) : (He(o, w.draggable), Gi(o));
  }
}, Xi = (e, t) => {
  const n = t.showClass || {};
  e.className = `${w.popup} ${De(e) ? n.popup : ""}`, t.toast ? (oe([document.documentElement, document.body], w["toast-shown"]), oe(e, w.toast)) : oe(e, w.modal), Re(e, t, "popup"), typeof t.customClass == "string" && oe(e, t.customClass), t.icon && oe(e, w[`icon-${t.icon}`]);
}, qi = (e, t) => {
  const n = fo();
  if (!n)
    return;
  const {
    progressSteps: o,
    currentProgressStep: s
  } = t;
  if (!o || o.length === 0 || s === void 0) {
    Ne(n);
    return;
  }
  Ee(n), n.textContent = "", s >= o.length && Oe("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"), o.forEach((r, a) => {
    const l = zi(r);
    if (n.appendChild(l), a === s && oe(l, w["active-progress-step"]), a !== o.length - 1) {
      const i = Ji(t);
      n.appendChild(i);
    }
  });
}, zi = (e) => {
  const t = document.createElement("li");
  return oe(t, w["progress-step"]), Ue(t, e), t;
}, Ji = (e) => {
  const t = document.createElement("li");
  return oe(t, w["progress-step-line"]), e.progressStepsDistance && Tt(t, "width", e.progressStepsDistance), t;
}, Zi = (e, t) => {
  const n = As();
  n && (wo(n), en(n, !!(t.title || t.titleText), "block"), t.title && bo(t.title, n), t.titleText && (n.innerText = t.titleText), Re(n, t, "title"));
}, Hs = (e, t) => {
  var n;
  Ki(e, t), Ni(e, t), qi(e, t), Bi(e, t), ji(e, t), Zi(e, t), Li(e, t), Fi(e, t), xi(e, t), Ui(e, t);
  const o = se();
  typeof t.didRender == "function" && o && t.didRender(o), (n = R.eventEmitter) === null || n === void 0 || n.emit("didRender", o);
}, Qi = () => De(se()), Ys = () => {
  var e;
  return (e = tt()) === null || e === void 0 ? void 0 : e.click();
}, el = () => {
  var e;
  return (e = It()) === null || e === void 0 ? void 0 : e.click();
}, tl = () => {
  var e;
  return (e = Ut()) === null || e === void 0 ? void 0 : e.click();
}, Vt = Object.freeze({
  cancel: "cancel",
  backdrop: "backdrop",
  close: "close",
  esc: "esc",
  timer: "timer"
}), js = (e) => {
  if (e.keydownTarget && e.keydownHandlerAdded && e.keydownHandler) {
    const t = (
      /** @type {EventListenerOrEventListenerObject} */
      /** @type {unknown} */
      e.keydownHandler
    );
    e.keydownTarget.removeEventListener("keydown", t, {
      capture: e.keydownListenerCapture
    }), e.keydownHandlerAdded = !1;
  }
}, nl = (e, t, n) => {
  if (js(e), !t.toast) {
    const o = (r) => sl(t, r, n);
    e.keydownHandler = o;
    const s = t.keydownListenerCapture ? window : se();
    if (s) {
      e.keydownTarget = s, e.keydownListenerCapture = t.keydownListenerCapture;
      const r = (
        /** @type {EventListenerOrEventListenerObject} */
        /** @type {unknown} */
        o
      );
      e.keydownTarget.addEventListener("keydown", r, {
        capture: e.keydownListenerCapture
      }), e.keydownHandlerAdded = !0;
    }
  }
}, jn = (e, t) => {
  var n;
  const o = po();
  if (o.length) {
    e = e + t, e === -2 && (e = o.length - 1), e === o.length ? e = 0 : e === -1 && (e = o.length - 1), o[e].focus();
    return;
  }
  (n = se()) === null || n === void 0 || n.focus();
}, Ws = ["ArrowRight", "ArrowDown"], ol = ["ArrowLeft", "ArrowUp"], sl = (e, t, n) => {
  e && (t.isComposing || t.keyCode === 229 || (e.stopKeydownPropagation && t.stopPropagation(), t.key === "Enter" ? rl(t, e) : t.key === "Tab" ? al(t) : [...Ws, ...ol].includes(t.key) ? il(t.key) : t.key === "Escape" && ll(t, e, n)));
}, rl = (e, t) => {
  if (!xn(t.allowEnterKey))
    return;
  const n = se();
  if (!n || !t.input)
    return;
  const o = Nn(n, t.input);
  if (e.target && o && e.target instanceof HTMLElement && e.target.outerHTML === o.outerHTML) {
    if (["textarea", "file"].includes(t.input))
      return;
    Ys(), e.preventDefault();
  }
}, al = (e) => {
  const t = e.target, n = po();
  let o = -1;
  for (let s = 0; s < n.length; s++)
    if (t === n[s]) {
      o = s;
      break;
    }
  e.shiftKey ? jn(o, -1) : jn(o, 1), e.stopPropagation(), e.preventDefault();
}, il = (e) => {
  const t = Qt(), n = tt(), o = It(), s = Ut();
  if (!t || !n || !o || !s)
    return;
  const r = [n, o, s];
  if (document.activeElement instanceof HTMLElement && !r.includes(document.activeElement))
    return;
  const a = Ws.includes(e) ? "nextElementSibling" : "previousElementSibling";
  let l = document.activeElement;
  if (l) {
    for (let i = 0; i < t.children.length; i++) {
      if (l = l[a], !l)
        return;
      if (l instanceof HTMLButtonElement && De(l))
        break;
    }
    l instanceof HTMLButtonElement && l.focus();
  }
}, ll = (e, t, n) => {
  e.preventDefault(), xn(t.allowEscapeKey) && n(Vt.esc);
};
var $t = {
  swalPromiseResolve: /* @__PURE__ */ new WeakMap(),
  swalPromiseReject: /* @__PURE__ */ new WeakMap()
};
const cl = () => {
  const e = Ie();
  Array.from(document.body.children).forEach((n) => {
    n.contains(e) || (n.hasAttribute("aria-hidden") && n.setAttribute("data-previous-aria-hidden", n.getAttribute("aria-hidden") || ""), n.setAttribute("aria-hidden", "true"));
  });
}, Gs = () => {
  Array.from(document.body.children).forEach((t) => {
    t.hasAttribute("data-previous-aria-hidden") ? (t.setAttribute("aria-hidden", t.getAttribute("data-previous-aria-hidden") || ""), t.removeAttribute("data-previous-aria-hidden")) : t.removeAttribute("aria-hidden");
  });
}, Ks = typeof window < "u" && !!window.GestureEvent, ul = () => {
  if (Ks && !lt(document.body, w.iosfix)) {
    const e = document.body.scrollTop;
    document.body.style.top = `${e * -1}px`, oe(document.body, w.iosfix), dl();
  }
}, dl = () => {
  const e = Ie();
  if (!e)
    return;
  let t;
  e.ontouchstart = (n) => {
    t = fl(n);
  }, e.ontouchmove = (n) => {
    t && (n.preventDefault(), n.stopPropagation());
  };
}, fl = (e) => {
  const t = e.target, n = Ie(), o = uo();
  return !n || !o || ml(e) || pl(e) ? !1 : t === n || !Yn(n) && t instanceof HTMLElement && !fi(t, o) && // #2823
  t.tagName !== "INPUT" && // #1603
  t.tagName !== "TEXTAREA" && // #2266
  !(Yn(o) && // #1944
  o.contains(t));
}, ml = (e) => !!(e.touches && e.touches.length && // @ts-ignore - touchType is not a standard property
e.touches[0].touchType === "stylus"), pl = (e) => e.touches && e.touches.length > 1, hl = () => {
  if (lt(document.body, w.iosfix)) {
    const e = parseInt(document.body.style.top, 10);
    He(document.body, w.iosfix), document.body.style.top = "", document.body.scrollTop = e * -1;
  }
}, wl = () => {
  const e = document.createElement("div");
  e.className = w["scrollbar-measure"], document.body.appendChild(e);
  const t = e.getBoundingClientRect().width - e.clientWidth;
  return document.body.removeChild(e), t;
};
let Pt = null;
const gl = (e) => {
  Pt === null && (document.body.scrollHeight > window.innerHeight || e === "scroll") && (Pt = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")), document.body.style.paddingRight = `${Pt + wl()}px`);
}, bl = () => {
  Pt !== null && (document.body.style.paddingRight = `${Pt}px`, Pt = null);
};
function Xs(e, t, n, o) {
  Ln() ? Fo(e, o) : (ni(n).then(() => Fo(e, o)), js(R)), Ks ? (t.setAttribute("style", "display:none !important"), t.removeAttribute("class"), t.innerHTML = "") : t.remove(), ho() && (bl(), hl(), Gs()), vl();
}
function vl() {
  He([document.documentElement, document.body], [w.shown, w["height-auto"], w["no-backdrop"], w["toast-shown"]]);
}
function pt(e) {
  e = yl(e);
  const t = $t.swalPromiseResolve.get(this), n = _l(this);
  this.isAwaitingPromise ? e.isDismissed || (nn(this), t(e)) : n && t(e);
}
const _l = (e) => {
  const t = se();
  if (!t)
    return !1;
  const n = ie.innerParams.get(e);
  if (!n || lt(t, n.hideClass.popup))
    return !1;
  He(t, n.showClass.popup), oe(t, n.hideClass.popup);
  const o = Ie();
  return He(o, n.showClass.backdrop), oe(o, n.hideClass.backdrop), El(e, t, n), !0;
};
function qs(e) {
  const t = $t.swalPromiseReject.get(this);
  nn(this), t && t(e);
}
const nn = (e) => {
  e.isAwaitingPromise && (delete e.isAwaitingPromise, ie.innerParams.get(e) || e._destroy());
}, yl = (e) => typeof e > "u" ? {
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !0
} : Object.assign({
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !1
}, e), El = (e, t, n) => {
  var o;
  const s = Ie(), r = Ps(t);
  typeof n.willClose == "function" && n.willClose(t), (o = R.eventEmitter) === null || o === void 0 || o.emit("willClose", t), r && s ? kl(e, t, s, !!n.returnFocus, n.didClose) : s && Xs(e, s, !!n.returnFocus, n.didClose);
}, kl = (e, t, n, o, s) => {
  R.swalCloseEventFinishedCallback = Xs.bind(null, e, n, o, s);
  const r = function(a) {
    if (a.target === t) {
      var l;
      (l = R.swalCloseEventFinishedCallback) === null || l === void 0 || l.call(R), delete R.swalCloseEventFinishedCallback, t.removeEventListener("animationend", r), t.removeEventListener("transitionend", r);
    }
  };
  t.addEventListener("animationend", r), t.addEventListener("transitionend", r);
}, Fo = (e, t) => {
  setTimeout(() => {
    var n;
    typeof t == "function" && t.bind(e.params)(), (n = R.eventEmitter) === null || n === void 0 || n.emit("didClose"), e._destroy && e._destroy();
  });
}, Mt = (e) => {
  let t = se();
  if (t || new Gt(), t = se(), !t)
    return;
  const n = Bt();
  Ln() ? Ne(Ft()) : xl(t, e), Ee(n), t.setAttribute("data-loading", "true"), t.setAttribute("aria-busy", "true"), t.focus();
}, xl = (e, t) => {
  const n = Qt(), o = Bt();
  !n || !o || (!t && De(tt()) && (t = tt()), Ee(n), t && (Ne(t), o.setAttribute("data-button-to-replace", t.className), n.insertBefore(o, t)), oe([e, n], w.loading));
}, Cl = (e, t) => {
  t.input === "select" || t.input === "radio" ? Ol(e, t) : ["text", "email", "number", "tel", "textarea"].some((n) => n === t.input) && (lo(t.inputValue) || co(t.inputValue)) && (Mt(tt()), Il(e, t));
}, Tl = (e, t) => {
  const n = e.getInput();
  if (!n)
    return null;
  switch (t.input) {
    case "checkbox":
      return Ll(n);
    case "radio":
      return Nl(n);
    case "file":
      return Al(n);
    default:
      return t.inputAutoTrim ? n.value.trim() : n.value;
  }
}, Ll = (e) => e.checked ? 1 : 0, Nl = (e) => e.checked ? e.value : null, Al = (e) => e.files && e.files.length ? e.getAttribute("multiple") !== null ? e.files : e.files[0] : null, Ol = (e, t) => {
  const n = se();
  if (!n)
    return;
  const o = (s) => {
    t.input === "select" ? Sl(n, hn(s), t) : t.input === "radio" && Dl(n, hn(s), t);
  };
  lo(t.inputOptions) || co(t.inputOptions) ? (Mt(tt()), Jt(t.inputOptions).then((s) => {
    e.hideLoading(), o(s);
  })) : typeof t.inputOptions == "object" ? o(t.inputOptions) : Ot(`Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof t.inputOptions}`);
}, Il = (e, t) => {
  const n = e.getInput();
  n && (Ne(n), Jt(t.inputValue).then((o) => {
    n.value = t.input === "number" ? `${parseFloat(o) || 0}` : `${o}`, Ee(n), n.focus(), e.hideLoading();
  }).catch((o) => {
    Ot(`Error in inputValue promise: ${o}`), n.value = "", Ee(n), n.focus(), e.hideLoading();
  }));
};
function Sl(e, t, n) {
  const o = mt(e, w.select);
  if (!o)
    return;
  const s = (r, a, l) => {
    const i = document.createElement("option");
    i.value = l, Ue(i, a), i.selected = zs(l, n.inputValue), r.appendChild(i);
  };
  t.forEach((r) => {
    const a = r[0], l = r[1];
    if (Array.isArray(l)) {
      const i = document.createElement("optgroup");
      i.label = a, i.disabled = !1, o.appendChild(i), l.forEach((f) => s(i, f[1], f[0]));
    } else
      s(o, l, a);
  }), o.focus();
}
function Dl(e, t, n) {
  const o = mt(e, w.radio);
  if (!o)
    return;
  t.forEach((r) => {
    const a = r[0], l = r[1], i = document.createElement("input"), f = document.createElement("label");
    i.type = "radio", i.name = w.radio, i.value = a, zs(a, n.inputValue) && (i.checked = !0);
    const g = document.createElement("span");
    Ue(g, l), g.className = w.label, f.appendChild(i), f.appendChild(g), o.appendChild(f);
  });
  const s = o.querySelectorAll("input");
  s.length && s[0].focus();
}
const hn = (e) => {
  const t = [];
  return e instanceof Map ? e.forEach((n, o) => {
    let s = n;
    typeof s == "object" && (s = hn(s)), t.push([o, s]);
  }) : Object.keys(e).forEach((n) => {
    let o = e[n];
    typeof o == "object" && (o = hn(o)), t.push([n, o]);
  }), t;
}, zs = (e, t) => !!t && t !== null && t !== void 0 && t.toString() === e.toString(), Pl = (e) => {
  const t = ie.innerParams.get(e);
  e.disableButtons(), t.input ? Js(e, "confirm") : Eo(e, !0);
}, $l = (e) => {
  const t = ie.innerParams.get(e);
  e.disableButtons(), t.returnInputValueOnDeny ? Js(e, "deny") : yo(e, !1);
}, Ml = (e, t) => {
  e.disableButtons(), t(Vt.cancel);
}, Js = (e, t) => {
  const n = ie.innerParams.get(e);
  if (!n.input) {
    Ot(`The "input" parameter is needed to be set when using returnInputValueOn${io(t)}`);
    return;
  }
  const o = e.getInput(), s = Tl(e, n);
  n.inputValidator ? Rl(e, s, t) : o && !o.checkValidity() ? (e.enableButtons(), e.showValidationMessage(n.validationMessage || o.validationMessage)) : t === "deny" ? yo(e, s) : Eo(e, s);
}, Rl = (e, t, n) => {
  const o = ie.innerParams.get(e);
  e.disableInput(), Promise.resolve().then(() => Jt(o.inputValidator(t, o.validationMessage))).then((r) => {
    e.enableButtons(), e.enableInput(), r ? e.showValidationMessage(r) : n === "deny" ? yo(e, t) : Eo(e, t);
  });
}, yo = (e, t) => {
  const n = ie.innerParams.get(e);
  n.showLoaderOnDeny && Mt(It()), n.preDeny ? (e.isAwaitingPromise = !0, Promise.resolve().then(() => Jt(n.preDeny(t, n.validationMessage))).then((s) => {
    s === !1 ? (e.hideLoading(), nn(e)) : e.close(
      /** @type SweetAlertResult */
      {
        isDenied: !0,
        value: typeof s > "u" ? t : s
      }
    );
  }).catch((s) => Zs(e, s))) : e.close(
    /** @type SweetAlertResult */
    {
      isDenied: !0,
      value: t
    }
  );
}, Uo = (e, t) => {
  e.close(
    /** @type SweetAlertResult */
    {
      isConfirmed: !0,
      value: t
    }
  );
}, Zs = (e, t) => {
  e.rejectPromise(t);
}, Eo = (e, t) => {
  const n = ie.innerParams.get(e);
  n.showLoaderOnConfirm && Mt(), n.preConfirm ? (e.resetValidationMessage(), e.isAwaitingPromise = !0, Promise.resolve().then(() => Jt(n.preConfirm(t, n.validationMessage))).then((s) => {
    De(Cn()) || s === !1 ? (e.hideLoading(), nn(e)) : Uo(e, typeof s > "u" ? t : s);
  }).catch((s) => Zs(e, s))) : Uo(e, t);
};
function wn() {
  const e = ie.innerParams.get(this);
  if (!e)
    return;
  const t = ie.domCache.get(this);
  Ne(t.loader), Ln() ? e.icon && Ee(Ft()) : Fl(t), He([t.popup, t.actions], w.loading), t.popup.removeAttribute("aria-busy"), t.popup.removeAttribute("data-loading"), t.confirmButton.disabled = !1, t.denyButton.disabled = !1, t.cancelButton.disabled = !1;
}
const Fl = (e) => {
  const t = e.loader.getAttribute("data-button-to-replace"), n = t ? e.popup.getElementsByClassName(t) : [];
  n.length ? Ee(
    /** @type {HTMLElement} */
    n[0],
    "inline-block"
  ) : di() && Ne(e.actions);
};
function Qs() {
  const e = ie.innerParams.get(this), t = ie.domCache.get(this);
  return t ? Nn(t.popup, e.input) : null;
}
function er(e, t, n) {
  const o = ie.domCache.get(e);
  t.forEach((s) => {
    o[s].disabled = n;
  });
}
function tr(e, t) {
  const n = se();
  if (!(!n || !e))
    if (e.type === "radio") {
      const o = n.querySelectorAll(`[name="${w.radio}"]`);
      for (let s = 0; s < o.length; s++)
        o[s].disabled = t;
    } else
      e.disabled = t;
}
function nr() {
  er(this, ["confirmButton", "denyButton", "cancelButton"], !1);
}
function or() {
  er(this, ["confirmButton", "denyButton", "cancelButton"], !0);
}
function sr() {
  tr(this.getInput(), !1);
}
function rr() {
  tr(this.getInput(), !0);
}
function ar(e) {
  const t = ie.domCache.get(this), n = ie.innerParams.get(this);
  Ue(t.validationMessage, e), t.validationMessage.className = w["validation-message"], n.customClass && n.customClass.validationMessage && oe(t.validationMessage, n.customClass.validationMessage), Ee(t.validationMessage);
  const o = this.getInput();
  o && (o.setAttribute("aria-invalid", "true"), o.setAttribute("aria-describedby", w["validation-message"]), Ss(o), oe(o, w.inputerror));
}
function ir() {
  const e = ie.domCache.get(this);
  e.validationMessage && Ne(e.validationMessage);
  const t = this.getInput();
  t && (t.removeAttribute("aria-invalid"), t.removeAttribute("aria-describedby"), He(t, w.inputerror));
}
const ht = {
  title: "",
  titleText: "",
  text: "",
  html: "",
  footer: "",
  icon: void 0,
  iconColor: void 0,
  iconHtml: void 0,
  template: void 0,
  toast: !1,
  draggable: !1,
  animation: !0,
  theme: "light",
  showClass: {
    popup: "swal2-show",
    backdrop: "swal2-backdrop-show",
    icon: "swal2-icon-show"
  },
  hideClass: {
    popup: "swal2-hide",
    backdrop: "swal2-backdrop-hide",
    icon: "swal2-icon-hide"
  },
  customClass: {},
  target: "body",
  color: void 0,
  backdrop: !0,
  heightAuto: !0,
  allowOutsideClick: !0,
  allowEscapeKey: !0,
  allowEnterKey: !0,
  stopKeydownPropagation: !0,
  keydownListenerCapture: !1,
  showConfirmButton: !0,
  showDenyButton: !1,
  showCancelButton: !1,
  preConfirm: void 0,
  preDeny: void 0,
  confirmButtonText: "OK",
  confirmButtonAriaLabel: "",
  confirmButtonColor: void 0,
  denyButtonText: "No",
  denyButtonAriaLabel: "",
  denyButtonColor: void 0,
  cancelButtonText: "Cancel",
  cancelButtonAriaLabel: "",
  cancelButtonColor: void 0,
  buttonsStyling: !0,
  reverseButtons: !1,
  focusConfirm: !0,
  focusDeny: !1,
  focusCancel: !1,
  returnFocus: !0,
  showCloseButton: !1,
  closeButtonHtml: "&times;",
  closeButtonAriaLabel: "Close this dialog",
  loaderHtml: "",
  showLoaderOnConfirm: !1,
  showLoaderOnDeny: !1,
  imageUrl: void 0,
  imageWidth: void 0,
  imageHeight: void 0,
  imageAlt: "",
  timer: void 0,
  timerProgressBar: !1,
  width: void 0,
  padding: void 0,
  background: void 0,
  input: void 0,
  inputPlaceholder: "",
  inputLabel: "",
  inputValue: "",
  inputOptions: {},
  inputAutoFocus: !0,
  inputAutoTrim: !0,
  inputAttributes: {},
  inputValidator: void 0,
  returnInputValueOnDeny: !1,
  validationMessage: void 0,
  grow: !1,
  position: "center",
  progressSteps: [],
  currentProgressStep: void 0,
  progressStepsDistance: void 0,
  willOpen: void 0,
  didOpen: void 0,
  didRender: void 0,
  willClose: void 0,
  didClose: void 0,
  didDestroy: void 0,
  scrollbarPadding: !0,
  topLayer: !1
}, Ul = ["allowEscapeKey", "allowOutsideClick", "background", "buttonsStyling", "cancelButtonAriaLabel", "cancelButtonColor", "cancelButtonText", "closeButtonAriaLabel", "closeButtonHtml", "color", "confirmButtonAriaLabel", "confirmButtonColor", "confirmButtonText", "currentProgressStep", "customClass", "denyButtonAriaLabel", "denyButtonColor", "denyButtonText", "didClose", "didDestroy", "draggable", "footer", "hideClass", "html", "icon", "iconColor", "iconHtml", "imageAlt", "imageHeight", "imageUrl", "imageWidth", "preConfirm", "preDeny", "progressSteps", "returnFocus", "reverseButtons", "showCancelButton", "showCloseButton", "showConfirmButton", "showDenyButton", "text", "title", "titleText", "theme", "willClose"], Bl = {
  allowEnterKey: void 0
}, Vl = ["allowOutsideClick", "allowEnterKey", "backdrop", "draggable", "focusConfirm", "focusDeny", "focusCancel", "returnFocus", "heightAuto", "keydownListenerCapture"], lr = (e) => Object.prototype.hasOwnProperty.call(ht, e), cr = (e) => Ul.indexOf(e) !== -1, ur = (e) => Bl[e], Hl = (e) => {
  lr(e) || Oe(`Unknown parameter "${e}"`);
}, Yl = (e) => {
  Vl.includes(e) && Oe(`The parameter "${e}" is incompatible with toasts`);
}, jl = (e) => {
  const t = ur(e);
  t && Ns(e, t);
}, dr = (e) => {
  e.backdrop === !1 && e.allowOutsideClick && Oe('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`'), e.theme && !["light", "dark", "auto", "minimal", "borderless", "bootstrap-4", "bootstrap-4-light", "bootstrap-4-dark", "bootstrap-5", "bootstrap-5-light", "bootstrap-5-dark", "material-ui", "material-ui-light", "material-ui-dark", "embed-iframe", "bulma", "bulma-light", "bulma-dark"].includes(e.theme) && Oe(`Invalid theme "${e.theme}"`);
  for (const t in e)
    Hl(t), e.toast && Yl(t), jl(t);
};
function fr(e) {
  const t = Ie(), n = se(), o = ie.innerParams.get(this);
  if (!n || lt(n, o.hideClass.popup)) {
    Oe("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
    return;
  }
  const s = Wl(e), r = Object.assign({}, o, s);
  dr(r), t && (t.dataset.swal2Theme = r.theme), Hs(this, r), ie.innerParams.set(this, r), Object.defineProperties(this, {
    params: {
      value: Object.assign({}, this.params, e),
      writable: !1,
      enumerable: !0
    }
  });
}
const Wl = (e) => {
  const t = {};
  return Object.keys(e).forEach((n) => {
    if (cr(n)) {
      const o = (
        /** @type {Record<string, any>} */
        e
      );
      t[n] = o[n];
    } else
      Oe(`Invalid parameter to update: ${n}`);
  }), t;
};
function mr() {
  var e;
  const t = ie.domCache.get(this), n = ie.innerParams.get(this);
  if (!n) {
    pr(this);
    return;
  }
  t.popup && R.swalCloseEventFinishedCallback && (R.swalCloseEventFinishedCallback(), delete R.swalCloseEventFinishedCallback), typeof n.didDestroy == "function" && n.didDestroy(), (e = R.eventEmitter) === null || e === void 0 || e.emit("didDestroy"), Gl(this);
}
const Gl = (e) => {
  pr(e), delete e.params, delete R.keydownHandler, delete R.keydownTarget, delete R.currentInstance;
}, pr = (e) => {
  e.isAwaitingPromise ? (Fn(ie, e), e.isAwaitingPromise = !0) : (Fn($t, e), Fn(ie, e), delete e.isAwaitingPromise, delete e.disableButtons, delete e.enableButtons, delete e.getInput, delete e.disableInput, delete e.enableInput, delete e.hideLoading, delete e.disableLoading, delete e.showValidationMessage, delete e.resetValidationMessage, delete e.close, delete e.closePopup, delete e.closeModal, delete e.closeToast, delete e.rejectPromise, delete e.update, delete e._destroy);
}, Fn = (e, t) => {
  for (const n in e)
    e[n].delete(t);
};
var Kl = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  _destroy: mr,
  close: pt,
  closeModal: pt,
  closePopup: pt,
  closeToast: pt,
  disableButtons: or,
  disableInput: rr,
  disableLoading: wn,
  enableButtons: nr,
  enableInput: sr,
  getInput: Qs,
  handleAwaitingPromise: nn,
  hideLoading: wn,
  rejectPromise: qs,
  resetValidationMessage: ir,
  showValidationMessage: ar,
  update: fr
});
const Xl = (e, t, n) => {
  e.toast ? ql(e, t, n) : (Jl(t), Zl(t), Ql(e, t, n));
}, ql = (e, t, n) => {
  t.popup.onclick = () => {
    e && (zl(e) || e.timer || e.input) || n(Vt.close);
  };
}, zl = (e) => !!(e.showConfirmButton || e.showDenyButton || e.showCancelButton || e.showCloseButton);
let gn = !1;
const Jl = (e) => {
  e.popup.onmousedown = () => {
    e.container.onmouseup = function(t) {
      e.container.onmouseup = () => {
      }, t.target === e.container && (gn = !0);
    };
  };
}, Zl = (e) => {
  e.container.onmousedown = (t) => {
    t.target === e.container && t.preventDefault(), e.popup.onmouseup = function(n) {
      e.popup.onmouseup = () => {
      }, (n.target === e.popup || n.target instanceof HTMLElement && e.popup.contains(n.target)) && (gn = !0);
    };
  };
}, Ql = (e, t, n) => {
  t.container.onclick = (o) => {
    if (gn) {
      gn = !1;
      return;
    }
    o.target === t.container && xn(e.allowOutsideClick) && n(Vt.backdrop);
  };
}, ec = (e) => typeof e == "object" && e.jquery, Bo = (e) => e instanceof Element || ec(e), tc = (e) => {
  const t = {};
  return typeof e[0] == "object" && !Bo(e[0]) ? Object.assign(t, e[0]) : ["title", "html", "icon"].forEach((n, o) => {
    const s = e[o];
    typeof s == "string" || Bo(s) ? t[n] = s : s !== void 0 && Ot(`Unexpected type of ${n}! Expected "string" or "Element", got ${typeof s}`);
  }), t;
};
function nc(...e) {
  return new this(...e);
}
function oc(e) {
  class t extends this {
    /**
     * @param {any} params
     * @param {any} priorityMixinParams
     */
    _main(o, s) {
      return super._main(o, Object.assign({}, e, s));
    }
  }
  return t;
}
const sc = () => R.timeout && R.timeout.getTimerLeft(), hr = () => {
  if (R.timeout)
    return mi(), R.timeout.stop();
}, wr = () => {
  if (R.timeout) {
    const e = R.timeout.start();
    return go(e), e;
  }
}, rc = () => {
  const e = R.timeout;
  return e && (e.running ? hr() : wr());
}, ac = (e) => {
  if (R.timeout) {
    const t = R.timeout.increase(e);
    return go(t, !0), t;
  }
}, ic = () => !!(R.timeout && R.timeout.isRunning());
let Vo = !1;
const Wn = {};
function lc(e = "data-swal-template") {
  Wn[e] = this, Vo || (document.body.addEventListener("click", cc), Vo = !0);
}
const cc = (e) => {
  for (let t = (
    /** @type {any} */
    e.target
  ); t && t !== document; t = t.parentNode)
    for (const n in Wn) {
      const o = t.getAttribute && t.getAttribute(n);
      if (o) {
        Wn[n].fire({
          template: o
        });
        return;
      }
    }
};
class uc {
  constructor() {
    this.events = {};
  }
  /**
   * @param {string} eventName
   * @returns {EventHandlers}
   */
  _getHandlersByEventName(t) {
    return typeof this.events[t] > "u" && (this.events[t] = []), this.events[t];
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  on(t, n) {
    const o = this._getHandlersByEventName(t);
    o.includes(n) || o.push(n);
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  once(t, n) {
    const o = (...s) => {
      this.removeListener(t, o), n.apply(this, s);
    };
    this.on(t, o);
  }
  /**
   * @param {string} eventName
   * @param {...any} args
   */
  emit(t, ...n) {
    this._getHandlersByEventName(t).forEach(
      /**
       * @param {EventHandler} eventHandler
       */
      (o) => {
        try {
          o.apply(this, n);
        } catch (s) {
          console.error(s);
        }
      }
    );
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  removeListener(t, n) {
    const o = this._getHandlersByEventName(t), s = o.indexOf(n);
    s > -1 && o.splice(s, 1);
  }
  /**
   * @param {string} eventName
   */
  removeAllListeners(t) {
    this.events[t] !== void 0 && (this.events[t].length = 0);
  }
  reset() {
    this.events = {};
  }
}
R.eventEmitter = new uc();
const dc = (e, t) => {
  R.eventEmitter && R.eventEmitter.on(e, t);
}, fc = (e, t) => {
  R.eventEmitter && R.eventEmitter.once(e, t);
}, mc = (e, t) => {
  if (R.eventEmitter) {
    if (!e) {
      R.eventEmitter.reset();
      return;
    }
    t ? R.eventEmitter.removeListener(e, t) : R.eventEmitter.removeAllListeners(e);
  }
};
var pc = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  argsToParams: tc,
  bindClickHandler: lc,
  clickCancel: tl,
  clickConfirm: Ys,
  clickDeny: el,
  enableLoading: Mt,
  fire: nc,
  getActions: Qt,
  getCancelButton: Ut,
  getCloseButton: mo,
  getConfirmButton: tt,
  getContainer: Ie,
  getDenyButton: It,
  getFocusableElements: po,
  getFooter: Is,
  getHtmlContainer: uo,
  getIcon: Ft,
  getIconContent: ai,
  getImage: Os,
  getInputLabel: ii,
  getLoader: Bt,
  getPopup: se,
  getProgressSteps: fo,
  getTimerLeft: sc,
  getTimerProgressBar: Tn,
  getTitle: As,
  getValidationMessage: Cn,
  increaseTimer: ac,
  isDeprecatedParameter: ur,
  isLoading: ci,
  isTimerRunning: ic,
  isUpdatableParameter: cr,
  isValidParameter: lr,
  isVisible: Qi,
  mixin: oc,
  off: mc,
  on: dc,
  once: fc,
  resumeTimer: wr,
  showLoading: Mt,
  stopTimer: hr,
  toggleTimer: rc
});
class hc {
  /**
   * @param {() => void} callback
   * @param {number} delay
   */
  constructor(t, n) {
    this.callback = t, this.remaining = n, this.running = !1, this.start();
  }
  /**
   * @returns {number}
   */
  start() {
    return this.running || (this.running = !0, this.started = /* @__PURE__ */ new Date(), this.id = setTimeout(this.callback, this.remaining)), this.remaining;
  }
  /**
   * @returns {number}
   */
  stop() {
    return this.started && this.running && (this.running = !1, clearTimeout(this.id), this.remaining -= (/* @__PURE__ */ new Date()).getTime() - this.started.getTime()), this.remaining;
  }
  /**
   * @param {number} n
   * @returns {number}
   */
  increase(t) {
    const n = this.running;
    return n && this.stop(), this.remaining += t, n && this.start(), this.remaining;
  }
  /**
   * @returns {number}
   */
  getTimerLeft() {
    return this.running && (this.stop(), this.start()), this.remaining;
  }
  /**
   * @returns {boolean}
   */
  isRunning() {
    return this.running;
  }
}
const gr = ["swal-title", "swal-html", "swal-footer"], wc = (e) => {
  const t = typeof e.template == "string" ? (
    /** @type {HTMLTemplateElement} */
    document.querySelector(e.template)
  ) : e.template;
  if (!t)
    return {};
  const n = t.content;
  return xc(n), Object.assign(gc(n), bc(n), vc(n), _c(n), yc(n), Ec(n), kc(n, gr));
}, gc = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-param")).forEach((o) => {
    Lt(o, ["name", "value"]);
    const s = (
      /** @type {keyof SweetAlertOptions} */
      o.getAttribute("name")
    ), r = o.getAttribute("value");
    !s || !r || (s in ht && typeof ht[
      /** @type {keyof typeof defaultParams} */
      s
    ] == "boolean" ? t[s] = r !== "false" : s in ht && typeof ht[
      /** @type {keyof typeof defaultParams} */
      s
    ] == "object" ? t[s] = JSON.parse(r) : t[s] = r);
  }), t;
}, bc = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-function-param")).forEach((o) => {
    const s = (
      /** @type {keyof SweetAlertOptions} */
      o.getAttribute("name")
    ), r = o.getAttribute("value");
    !s || !r || (t[s] = new Function(`return ${r}`)());
  }), t;
}, vc = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-button")).forEach((o) => {
    Lt(o, ["type", "color", "aria-label"]);
    const s = o.getAttribute("type");
    if (!(!s || !["confirm", "cancel", "deny"].includes(s))) {
      if (t[`${s}ButtonText`] = o.innerHTML, t[`show${io(s)}Button`] = !0, o.hasAttribute("color")) {
        const r = o.getAttribute("color");
        r !== null && (t[`${s}ButtonColor`] = r);
      }
      if (o.hasAttribute("aria-label")) {
        const r = o.getAttribute("aria-label");
        r !== null && (t[`${s}ButtonAriaLabel`] = r);
      }
    }
  }), t;
}, _c = (e) => {
  const t = {}, n = e.querySelector("swal-image");
  return n && (Lt(n, ["src", "width", "height", "alt"]), n.hasAttribute("src") && (t.imageUrl = n.getAttribute("src") || void 0), n.hasAttribute("width") && (t.imageWidth = n.getAttribute("width") || void 0), n.hasAttribute("height") && (t.imageHeight = n.getAttribute("height") || void 0), n.hasAttribute("alt") && (t.imageAlt = n.getAttribute("alt") || void 0)), t;
}, yc = (e) => {
  const t = {}, n = e.querySelector("swal-icon");
  return n && (Lt(n, ["type", "color"]), n.hasAttribute("type") && (t.icon = n.getAttribute("type")), n.hasAttribute("color") && (t.iconColor = n.getAttribute("color")), t.iconHtml = n.innerHTML), t;
}, Ec = (e) => {
  const t = {}, n = e.querySelector("swal-input");
  n && (Lt(n, ["type", "label", "placeholder", "value"]), t.input = n.getAttribute("type") || "text", n.hasAttribute("label") && (t.inputLabel = n.getAttribute("label")), n.hasAttribute("placeholder") && (t.inputPlaceholder = n.getAttribute("placeholder")), n.hasAttribute("value") && (t.inputValue = n.getAttribute("value")));
  const o = Array.from(e.querySelectorAll("swal-input-option"));
  return o.length && (t.inputOptions = {}, o.forEach((s) => {
    Lt(s, ["value"]);
    const r = s.getAttribute("value");
    if (!r)
      return;
    const a = s.innerHTML;
    t.inputOptions[r] = a;
  })), t;
}, kc = (e, t) => {
  const n = {};
  for (const o in t) {
    const s = t[o], r = e.querySelector(s);
    r && (Lt(r, []), n[s.replace(/^swal-/, "")] = r.innerHTML.trim());
  }
  return n;
}, xc = (e) => {
  const t = gr.concat(["swal-param", "swal-function-param", "swal-button", "swal-image", "swal-icon", "swal-input", "swal-input-option"]);
  Array.from(e.children).forEach((n) => {
    const o = n.tagName.toLowerCase();
    t.includes(o) || Oe(`Unrecognized element <${o}>`);
  });
}, Lt = (e, t) => {
  Array.from(e.attributes).forEach((n) => {
    t.indexOf(n.name) === -1 && Oe([`Unrecognized attribute "${n.name}" on <${e.tagName.toLowerCase()}>.`, `${t.length ? `Allowed attributes are: ${t.join(", ")}` : "To set the value, use HTML within the element."}`]);
  });
}, br = 10, Cc = (e) => {
  var t, n;
  const o = Ie(), s = se();
  if (!o || !s)
    return;
  typeof e.willOpen == "function" && e.willOpen(s), (t = R.eventEmitter) === null || t === void 0 || t.emit("willOpen", s);
  const a = window.getComputedStyle(document.body).overflowY;
  if (Nc(o, s, e), setTimeout(() => {
    Tc(o, s);
  }, br), ho() && (Lc(o, e.scrollbarPadding !== void 0 ? e.scrollbarPadding : !1, a), cl()), !Ln() && !R.previousActiveElement && (R.previousActiveElement = document.activeElement), typeof e.didOpen == "function") {
    const l = e.didOpen;
    setTimeout(() => l(s));
  }
  (n = R.eventEmitter) === null || n === void 0 || n.emit("didOpen", s);
}, bn = (e) => {
  const t = se();
  if (!t || e.target !== t)
    return;
  const n = Ie();
  n && (t.removeEventListener("animationend", bn), t.removeEventListener("transitionend", bn), n.style.overflowY = "auto", He(n, w["no-transition"]));
}, Tc = (e, t) => {
  Ps(t) ? (e.style.overflowY = "hidden", t.addEventListener("animationend", bn), t.addEventListener("transitionend", bn)) : e.style.overflowY = "auto";
}, Lc = (e, t, n) => {
  ul(), t && n !== "hidden" && gl(n), setTimeout(() => {
    e.scrollTop = 0;
  });
}, Nc = (e, t, n) => {
  var o;
  (o = n.showClass) !== null && o !== void 0 && o.backdrop && oe(e, n.showClass.backdrop), n.animation ? (t.style.setProperty("opacity", "0", "important"), Ee(t, "grid"), setTimeout(() => {
    var s;
    (s = n.showClass) !== null && s !== void 0 && s.popup && oe(t, n.showClass.popup), t.style.removeProperty("opacity");
  }, br)) : Ee(t, "grid"), oe([document.documentElement, document.body], w.shown), n.heightAuto && n.backdrop && !n.toast && oe([document.documentElement, document.body], w["height-auto"]);
};
var Ho = {
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  email: (e, t) => /^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid email address"),
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  url: (e, t) => /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid URL")
};
function Ac(e) {
  e.inputValidator || (e.input === "email" && (e.inputValidator = Ho.email), e.input === "url" && (e.inputValidator = Ho.url));
}
function Oc(e) {
  (!e.target || typeof e.target == "string" && !document.querySelector(e.target) || typeof e.target != "string" && !e.target.appendChild) && (Oe('Target parameter is not valid, defaulting to "body"'), e.target = "body");
}
function Ic(e) {
  Ac(e), e.showLoaderOnConfirm && !e.preConfirm && Oe(`showLoaderOnConfirm is set to true, but preConfirm is not defined.
showLoaderOnConfirm should be used together with preConfirm, see usage example:
https://sweetalert2.github.io/#ajax-request`), Oc(e), typeof e.title == "string" && (e.title = e.title.split(`
`).join("<br />")), yi(e);
}
let Qe;
var sn = /* @__PURE__ */ new WeakMap();
class ge {
  /**
   * @param {...(SweetAlertOptions | string)} args
   * @this {SweetAlert}
   */
  constructor(...t) {
    if (Za(
      this,
      sn,
      /** @type {Promise<SweetAlertResult>} */
      Promise.resolve({
        isConfirmed: !1,
        isDenied: !1,
        isDismissed: !0
      })
    ), typeof window > "u")
      return;
    Qe = this;
    const n = Object.freeze(this.constructor.argsToParams(t));
    this.params = n, this.isAwaitingPromise = !1, Qa(sn, this, this._main(Qe.params));
  }
  /**
   * @param {any} userParams
   * @param {any} mixinParams
   */
  _main(t, n = {}) {
    if (dr(Object.assign({}, n, t)), R.currentInstance) {
      const r = $t.swalPromiseResolve.get(R.currentInstance), {
        isAwaitingPromise: a
      } = R.currentInstance;
      R.currentInstance._destroy(), a || r({
        isDismissed: !0
      }), ho() && Gs();
    }
    R.currentInstance = Qe;
    const o = Dc(t, n);
    Ic(o), Object.freeze(o), R.timeout && (R.timeout.stop(), delete R.timeout), clearTimeout(R.restoreFocusTimeout);
    const s = Pc(Qe);
    return Hs(Qe, o), ie.innerParams.set(Qe, o), Sc(Qe, s, o);
  }
  // `catch` cannot be the name of a module export, so we define our thenable methods here instead
  /**
   * @param {any} onFulfilled
   */
  then(t) {
    return So(sn, this).then(t);
  }
  /**
   * @param {any} onFinally
   */
  finally(t) {
    return So(sn, this).finally(t);
  }
}
const Sc = (e, t, n) => new Promise((o, s) => {
  const r = (a) => {
    e.close({
      isDismissed: !0,
      dismiss: a,
      isConfirmed: !1,
      isDenied: !1
    });
  };
  $t.swalPromiseResolve.set(e, o), $t.swalPromiseReject.set(e, s), t.confirmButton.onclick = () => {
    Pl(e);
  }, t.denyButton.onclick = () => {
    $l(e);
  }, t.cancelButton.onclick = () => {
    Ml(e, r);
  }, t.closeButton.onclick = () => {
    r(Vt.close);
  }, Xl(n, t, r), nl(R, n, r), Cl(e, n), Cc(n), $c(R, n, r), Mc(t, n), setTimeout(() => {
    t.container.scrollTop = 0;
  });
}), Dc = (e, t) => {
  const n = wc(e), o = Object.assign({}, ht, t, n, e);
  return o.showClass = Object.assign({}, ht.showClass, o.showClass), o.hideClass = Object.assign({}, ht.hideClass, o.hideClass), o.animation === !1 && (o.showClass = {
    backdrop: "swal2-noanimation"
  }, o.hideClass = {}), o;
}, Pc = (e) => {
  const t = (
    /** @type {DomCache} */
    {
      popup: (
        /** @type {HTMLElement} */
        se()
      ),
      container: (
        /** @type {HTMLElement} */
        Ie()
      ),
      actions: (
        /** @type {HTMLElement} */
        Qt()
      ),
      confirmButton: (
        /** @type {HTMLElement} */
        tt()
      ),
      denyButton: (
        /** @type {HTMLElement} */
        It()
      ),
      cancelButton: (
        /** @type {HTMLElement} */
        Ut()
      ),
      loader: (
        /** @type {HTMLElement} */
        Bt()
      ),
      closeButton: (
        /** @type {HTMLElement} */
        mo()
      ),
      validationMessage: (
        /** @type {HTMLElement} */
        Cn()
      ),
      progressSteps: (
        /** @type {HTMLElement} */
        fo()
      )
    }
  );
  return ie.domCache.set(e, t), t;
}, $c = (e, t, n) => {
  const o = Tn();
  Ne(o), t.timer && (e.timeout = new hc(() => {
    n("timer"), delete e.timeout;
  }, t.timer), t.timerProgressBar && o && (Ee(o), Re(o, t, "timerProgressBar"), setTimeout(() => {
    e.timeout && e.timeout.running && go(
      /** @type {number} */
      t.timer
    );
  })));
}, Mc = (e, t) => {
  if (!t.toast) {
    if (!xn(t.allowEnterKey)) {
      Ns("allowEnterKey"), Uc();
      return;
    }
    Rc(e) || Fc(e, t) || jn(-1, 1);
  }
}, Rc = (e) => {
  const t = Array.from(e.popup.querySelectorAll("[autofocus]"));
  for (const n of t)
    if (n instanceof HTMLElement && De(n))
      return n.focus(), !0;
  return !1;
}, Fc = (e, t) => t.focusDeny && De(e.denyButton) ? (e.denyButton.focus(), !0) : t.focusCancel && De(e.cancelButton) ? (e.cancelButton.focus(), !0) : t.focusConfirm && De(e.confirmButton) ? (e.confirmButton.focus(), !0) : !1, Uc = () => {
  document.activeElement instanceof HTMLElement && typeof document.activeElement.blur == "function" && document.activeElement.blur();
};
ge.prototype.disableButtons = or;
ge.prototype.enableButtons = nr;
ge.prototype.getInput = Qs;
ge.prototype.disableInput = rr;
ge.prototype.enableInput = sr;
ge.prototype.hideLoading = wn;
ge.prototype.disableLoading = wn;
ge.prototype.showValidationMessage = ar;
ge.prototype.resetValidationMessage = ir;
ge.prototype.close = pt;
ge.prototype.closePopup = pt;
ge.prototype.closeModal = pt;
ge.prototype.closeToast = pt;
ge.prototype.rejectPromise = qs;
ge.prototype.update = fr;
ge.prototype._destroy = mr;
Object.assign(ge, pc);
Object.keys(Kl).forEach((e) => {
  ge[e] = function(...t) {
    if (Qe && Qe[e])
      return Qe[e](...t);
  };
});
ge.DismissReason = Vt;
ge.version = "11.26.17";
const Gt = ge;
Gt.default = Gt;
typeof document < "u" && function(e, t) {
  var n = e.createElement("style");
  if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);
  else try {
    n.innerHTML = t;
  } catch {
    n.innerText = t;
  }
}(document, ':root{--swal2-outline: 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-container-padding: 0.625em;--swal2-backdrop: rgba(0, 0, 0, 0.4);--swal2-backdrop-transition: background-color 0.15s;--swal2-width: 32em;--swal2-padding: 0 0 1.25em;--swal2-border: none;--swal2-border-radius: 0.3125rem;--swal2-background: white;--swal2-color: #545454;--swal2-show-animation: swal2-show 0.3s;--swal2-hide-animation: swal2-hide 0.15s forwards;--swal2-icon-zoom: 1;--swal2-icon-animations: true;--swal2-title-padding: 0.8em 1em 0;--swal2-html-container-padding: 1em 1.6em 0.3em;--swal2-input-border: 1px solid #d9d9d9;--swal2-input-border-radius: 0.1875em;--swal2-input-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-background: transparent;--swal2-input-transition: border-color 0.2s, box-shadow 0.2s;--swal2-input-hover-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-focus-border: 1px solid #b4dbed;--swal2-input-focus-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-progress-step-background: #add8e6;--swal2-validation-message-background: #f0f0f0;--swal2-validation-message-color: #666;--swal2-footer-border-color: #eee;--swal2-footer-background: transparent;--swal2-footer-color: inherit;--swal2-timer-progress-bar-background: rgba(0, 0, 0, 0.3);--swal2-close-button-position: initial;--swal2-close-button-inset: auto;--swal2-close-button-font-size: 2.5em;--swal2-close-button-color: #ccc;--swal2-close-button-transition: color 0.2s, box-shadow 0.2s;--swal2-close-button-outline: initial;--swal2-close-button-box-shadow: inset 0 0 0 3px transparent;--swal2-close-button-focus-box-shadow: inset var(--swal2-outline);--swal2-close-button-hover-transform: none;--swal2-actions-justify-content: center;--swal2-actions-width: auto;--swal2-actions-margin: 1.25em auto 0;--swal2-actions-padding: 0;--swal2-actions-border-radius: 0;--swal2-actions-background: transparent;--swal2-action-button-transition: background-color 0.2s, box-shadow 0.2s;--swal2-action-button-hover: black 10%;--swal2-action-button-active: black 10%;--swal2-confirm-button-box-shadow: none;--swal2-confirm-button-border-radius: 0.25em;--swal2-confirm-button-background-color: #7066e0;--swal2-confirm-button-color: #fff;--swal2-deny-button-box-shadow: none;--swal2-deny-button-border-radius: 0.25em;--swal2-deny-button-background-color: #dc3741;--swal2-deny-button-color: #fff;--swal2-cancel-button-box-shadow: none;--swal2-cancel-button-border-radius: 0.25em;--swal2-cancel-button-background-color: #6e7881;--swal2-cancel-button-color: #fff;--swal2-toast-show-animation: swal2-toast-show 0.5s;--swal2-toast-hide-animation: swal2-toast-hide 0.1s forwards;--swal2-toast-border: none;--swal2-toast-box-shadow: 0 0 1px hsl(0deg 0% 0% / 0.075), 0 1px 2px hsl(0deg 0% 0% / 0.075), 1px 2px 4px hsl(0deg 0% 0% / 0.075), 1px 3px 8px hsl(0deg 0% 0% / 0.075), 2px 4px 16px hsl(0deg 0% 0% / 0.075)}[data-swal2-theme=dark]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}@media(prefers-color-scheme: dark){[data-swal2-theme=auto]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:all}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px var(--swal2-backdrop)}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}@media print{body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown) .swal2-container{position:static !important}}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:"top-start     top            top-end" "center-start  center         center-end" "bottom-start  bottom-center  bottom-end";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:var(--swal2-container-padding);overflow-x:hidden;transition:var(--swal2-backdrop-transition);-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:var(--swal2-backdrop)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;place-self:start center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;place-self:start end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;place-self:center center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;place-self:center end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;place-self:end center}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;place-self:end end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container)[popover]{width:auto;border:0}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:var(--swal2-width);max-width:100%;padding:var(--swal2-padding);border:var(--swal2-border);border-radius:var(--swal2-border-radius);background:var(--swal2-background);color:var(--swal2-color);font-family:inherit;font-size:1rem;container-name:swal2-popup}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable{cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable div:where(.swal2-icon){cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging{cursor:grabbing}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging div:where(.swal2-icon){cursor:grabbing}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:var(--swal2-title-padding);color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;overflow-wrap:break-word;cursor:initial}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:var(--swal2-actions-justify-content);width:var(--swal2-actions-width);margin:var(--swal2-actions-margin);padding:var(--swal2-actions-padding);border-radius:var(--swal2-actions-border-radius);background:var(--swal2-actions-background)}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:var(--swal2-action-button-transition);border:none;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm){border-radius:var(--swal2-confirm-button-border-radius);background:initial;background-color:var(--swal2-confirm-button-background-color);box-shadow:var(--swal2-confirm-button-box-shadow);color:var(--swal2-confirm-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):hover{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):active{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny){border-radius:var(--swal2-deny-button-border-radius);background:initial;background-color:var(--swal2-deny-button-background-color);box-shadow:var(--swal2-deny-button-box-shadow);color:var(--swal2-deny-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):hover{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):active{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel){border-radius:var(--swal2-cancel-button-border-radius);background:initial;background-color:var(--swal2-cancel-button-background-color);box-shadow:var(--swal2-cancel-button-box-shadow);color:var(--swal2-cancel-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):hover{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):active{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):focus-visible{outline:none;box-shadow:var(--swal2-action-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-styled)[disabled]:not(.swal2-loading){opacity:.4}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid var(--swal2-footer-border-color);background:var(--swal2-footer-background);color:var(--swal2-footer-color);font-size:1em;text-align:center;cursor:initial}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:var(--swal2-border-radius);border-bottom-left-radius:var(--swal2-border-radius)}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:var(--swal2-timer-progress-bar-background)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em;cursor:initial}div:where(.swal2-container) button:where(.swal2-close){position:var(--swal2-close-button-position);inset:var(--swal2-close-button-inset);z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:var(--swal2-close-button-transition);border:none;border-radius:var(--swal2-border-radius);outline:var(--swal2-close-button-outline);background:rgba(0,0,0,0);color:var(--swal2-close-button-color);font-family:monospace;font-size:var(--swal2-close-button-font-size);cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:var(--swal2-close-button-hover-transform);background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus-visible{outline:none;box-shadow:var(--swal2-close-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-html-container){z-index:1;justify-content:center;margin:0;padding:var(--swal2-html-container-padding);overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;overflow-wrap:break-word;word-break:break-word;cursor:initial}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:var(--swal2-input-transition);border:var(--swal2-input-border);border-radius:var(--swal2-input-border-radius);background:var(--swal2-input-background);box-shadow:var(--swal2-input-box-shadow);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):hover,div:where(.swal2-container) input:where(.swal2-file):hover,div:where(.swal2-container) textarea:where(.swal2-textarea):hover{box-shadow:var(--swal2-input-hover-box-shadow)}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:var(--swal2-input-focus-border);outline:none;box-shadow:var(--swal2-input-focus-box-shadow)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:var(--swal2-background)}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:var(--swal2-input-background);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:var(--swal2-input-background);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:var(--swal2-background);color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:var(--swal2-validation-message-background);color:var(--swal2-validation-message-color);font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:"!";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:var(--swal2-progress-step-background);color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:var(--swal2-progress-step-background)}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;zoom:var(--swal2-icon-zoom);border:.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}}div:where(.swal2-icon).swal2-warning{border-color:#f8bb86;color:#f8bb86}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}}div:where(.swal2-icon).swal2-info{border-color:#3fc3ee;color:#3fc3ee}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}}div:where(.swal2-icon).swal2-question{border-color:#87adbd;color:#87adbd}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:var(--swal2-show-animation)}.swal2-hide{animation:var(--swal2-hide-animation)}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;border:var(--swal2-toast-border);background:var(--swal2-background);box-shadow:var(--swal2-toast-box-shadow);pointer-events:all}.swal2-toast>*{grid-column:2}.swal2-toast h2:where(.swal2-title){margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-toast .swal2-loading{justify-content:center}.swal2-toast input:where(.swal2-input){height:2em;margin:.5em;font-size:1em}.swal2-toast .swal2-validation-message{font-size:1em}.swal2-toast div:where(.swal2-footer){margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-toast button:where(.swal2-close){grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-toast div:where(.swal2-html-container){margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-toast div:where(.swal2-html-container):empty{padding:0}.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-toast div:where(.swal2-actions){justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-toast button:where(.swal2-styled){margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;border-radius:50%}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}@container swal2-popup style(--swal2-icon-animations:true){.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}}.swal2-toast.swal2-show{animation:var(--swal2-toast-show-animation)}.swal2-toast.swal2-hide{animation:var(--swal2-toast-hide-animation)}@keyframes swal2-show{0%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}100%{transform:translate3d(0, 0, 0) scale(1);opacity:1}}@keyframes swal2-hide{0%{transform:translate3d(0, 0, 0) scale(1);opacity:1}100%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}');
/*!
  * shared v11.2.8
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function nt(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const Yo = {};
function Bc(e) {
  Yo[e] || (Yo[e] = !0, nt(e));
}
const ct = typeof window < "u";
let Me, Nt;
if (process.env.NODE_ENV !== "production") {
  const e = ct && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (Me = (t) => {
    e.mark(t);
  }, Nt = (t, n, o) => {
    e.measure(t, n, o), e.clearMarks(n), e.clearMarks(o);
  });
}
const Vc = /\{([0-9a-zA-Z]+)\}/g;
function An(e, ...t) {
  return t.length === 1 && ee(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(Vc, (n, o) => t.hasOwnProperty(o) ? t[o] : "");
}
const dt = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), Hc = (e, t, n) => Yc({ l: e, k: t, s: n }), Yc = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), _e = (e) => typeof e == "number" && isFinite(e), jc = (e) => ko(e) === "[object Date]", vn = (e) => ko(e) === "[object RegExp]", On = (e) => Q(e) && Object.keys(e).length === 0, ye = Object.assign, Wc = Object.create, re = (e = null) => Wc(e);
let jo;
const Ct = () => jo || (jo = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : re());
function Wo(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/\//g, "&#x2F;").replace(/=/g, "&#x3D;");
}
function Go(e) {
  return e.replace(/&(?![a-zA-Z0-9#]{2,6};)/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function Gc(e) {
  return e = e.replace(/(\w+)\s*=\s*"([^"]*)"/g, (o, s, r) => `${s}="${Go(r)}"`), e = e.replace(/(\w+)\s*=\s*'([^']*)'/g, (o, s, r) => `${s}='${Go(r)}'`), /\s*on\w+\s*=\s*["']?[^"'>]+["']?/gi.test(e) && (process.env.NODE_ENV !== "production" && nt("Potentially dangerous event handlers detected in translation. Consider removing onclick, onerror, etc. from your translation messages."), e = e.replace(/(\s+)(on)(\w+\s*=)/gi, "$1&#111;n$3")), [
    // In href, src, action, formaction attributes
    /(\s+(?:href|src|action|formaction)\s*=\s*["']?)\s*javascript:/gi,
    // In style attributes within url()
    /(style\s*=\s*["'][^"']*url\s*\(\s*)javascript:/gi
  ].forEach((o) => {
    e = e.replace(o, "$1javascript&#58;");
  }), e;
}
const Kc = Object.prototype.hasOwnProperty;
function Ke(e, t) {
  return Kc.call(e, t);
}
const we = Array.isArray, ue = (e) => typeof e == "function", $ = (e) => typeof e == "string", he = (e) => typeof e == "boolean", ee = (e) => e !== null && typeof e == "object", Xc = (e) => ee(e) && ue(e.then) && ue(e.catch), vr = Object.prototype.toString, ko = (e) => vr.call(e), Q = (e) => ko(e) === "[object Object]", qc = (e) => e == null ? "" : we(e) || Q(e) && e.toString === vr ? JSON.stringify(e, null, 2) : String(e);
function xo(e, t = "") {
  return e.reduce((n, o, s) => s === 0 ? n + o : n + t + o, "");
}
const Ko = 2;
function zc(e, t = 0, n = e.length) {
  const o = e.split(/\r?\n/);
  let s = 0;
  const r = [];
  for (let a = 0; a < o.length; a++)
    if (s += o[a].length + 1, s >= t) {
      for (let l = a - Ko; l <= a + Ko || n > s; l++) {
        if (l < 0 || l >= o.length)
          continue;
        const i = l + 1;
        r.push(`${i}${" ".repeat(3 - String(i).length)}|  ${o[l]}`);
        const f = o[l].length;
        if (l === a) {
          const g = t - (s - f) + 1, y = Math.max(1, n > s ? f - g : n - t);
          r.push("   |  " + " ".repeat(g) + "^".repeat(y));
        } else if (l > a) {
          if (n > s) {
            const g = Math.max(Math.min(n - s, f), 1);
            r.push("   |  " + "^".repeat(g));
          }
          s += f + 1;
        }
      }
      break;
    }
  return r.join(`
`);
}
function Jc() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, o) {
      const s = e.get(n);
      s && s.push(o) || e.set(n, [o]);
    },
    off(n, o) {
      const s = e.get(n);
      s && s.splice(s.indexOf(o) >>> 0, 1);
    },
    emit(n, o) {
      (e.get(n) || []).slice().map((s) => s(o)), (e.get("*") || []).slice().map((s) => s(n, o));
    }
  };
}
const rn = (e) => !ee(e) || we(e);
function cn(e, t) {
  if (rn(e) || rn(t))
    throw new Error("Invalid value");
  const n = [{ src: e, des: t }];
  for (; n.length; ) {
    const { src: o, des: s } = n.pop();
    Object.keys(o).forEach((r) => {
      r !== "__proto__" && (ee(o[r]) && !ee(s[r]) && (s[r] = Array.isArray(o[r]) ? [] : re()), rn(s[r]) || rn(o[r]) ? s[r] = o[r] : n.push({ src: o[r], des: s[r] }));
    });
  }
}
/*!
  * message-compiler v11.2.8
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function Zc(e, t, n) {
  return { line: e, column: t, offset: n };
}
function Gn(e, t, n) {
  return { start: e, end: t };
}
const Y = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, Qc = 17, eu = {
  // tokenizer error messages
  [Y.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [Y.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [Y.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [Y.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [Y.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [Y.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [Y.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [Y.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [Y.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [Y.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [Y.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [Y.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [Y.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [Y.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [Y.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [Y.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function Ht(e, t, n = {}) {
  const { domain: o, messages: s, args: r } = n, a = process.env.NODE_ENV !== "production" ? An((s || eu)[e] || "", ...r || []) : e, l = new SyntaxError(String(a));
  return l.code = e, t && (l.location = t), l.domain = o, l;
}
function tu(e) {
  throw e;
}
const nu = /<\/?[\w\s="/.':;#-\/]+>/, ou = (e) => nu.test(e), Je = " ", su = "\r", Te = `
`, ru = "\u2028", au = "\u2029";
function iu(e) {
  const t = e;
  let n = 0, o = 1, s = 1, r = 0;
  const a = (k) => t[k] === su && t[k + 1] === Te, l = (k) => t[k] === Te, i = (k) => t[k] === au, f = (k) => t[k] === ru, g = (k) => a(k) || l(k) || i(k) || f(k), y = () => n, m = () => o, T = () => s, S = () => r, p = (k) => a(k) || i(k) || f(k) ? Te : t[k], E = () => p(n), u = () => p(n + r);
  function b() {
    return r = 0, g(n) && (o++, s = 0), a(n) && n++, n++, s++, t[n];
  }
  function x() {
    return a(n + r) && r++, r++, t[n + r];
  }
  function _() {
    n = 0, o = 1, s = 1, r = 0;
  }
  function A(k = 0) {
    r = k;
  }
  function N() {
    const k = n + r;
    for (; k !== n; )
      b();
    r = 0;
  }
  return {
    index: y,
    line: m,
    column: T,
    peekOffset: S,
    charAt: p,
    currentChar: E,
    currentPeek: u,
    next: b,
    peek: x,
    reset: _,
    resetPeek: A,
    skipToPeek: N
  };
}
const rt = void 0, lu = ".", Xo = "'", cu = "tokenizer";
function uu(e, t = {}) {
  const n = t.location !== !1, o = iu(e), s = () => o.index(), r = () => Zc(o.line(), o.column(), o.index()), a = r(), l = s(), i = {
    currentType: 13,
    offset: l,
    startLoc: a,
    endLoc: a,
    lastType: 13,
    lastOffset: l,
    lastStartLoc: a,
    lastEndLoc: a,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, f = () => i, { onError: g } = t;
  function y(c, d, C, ...M) {
    const ce = f();
    if (d.column += C, d.offset += C, g) {
      const fe = n ? Gn(ce.startLoc, d) : null, Z = Ht(c, fe, {
        domain: cu,
        args: M
      });
      g(Z);
    }
  }
  function m(c, d, C) {
    c.endLoc = r(), c.currentType = d;
    const M = { type: d };
    return n && (M.loc = Gn(c.startLoc, c.endLoc)), C != null && (M.value = C), M;
  }
  const T = (c) => m(
    c,
    13
    /* TokenTypes.EOF */
  );
  function S(c, d) {
    return c.currentChar() === d ? (c.next(), d) : (y(Y.EXPECTED_TOKEN, r(), 0, d), "");
  }
  function p(c) {
    let d = "";
    for (; c.currentPeek() === Je || c.currentPeek() === Te; )
      d += c.currentPeek(), c.peek();
    return d;
  }
  function E(c) {
    const d = p(c);
    return c.skipToPeek(), d;
  }
  function u(c) {
    if (c === rt)
      return !1;
    const d = c.charCodeAt(0);
    return d >= 97 && d <= 122 || // a-z
    d >= 65 && d <= 90 || // A-Z
    d === 95;
  }
  function b(c) {
    if (c === rt)
      return !1;
    const d = c.charCodeAt(0);
    return d >= 48 && d <= 57;
  }
  function x(c, d) {
    const { currentType: C } = d;
    if (C !== 2)
      return !1;
    p(c);
    const M = u(c.currentPeek());
    return c.resetPeek(), M;
  }
  function _(c, d) {
    const { currentType: C } = d;
    if (C !== 2)
      return !1;
    p(c);
    const M = c.currentPeek() === "-" ? c.peek() : c.currentPeek(), ce = b(M);
    return c.resetPeek(), ce;
  }
  function A(c, d) {
    const { currentType: C } = d;
    if (C !== 2)
      return !1;
    p(c);
    const M = c.currentPeek() === Xo;
    return c.resetPeek(), M;
  }
  function N(c, d) {
    const { currentType: C } = d;
    if (C !== 7)
      return !1;
    p(c);
    const M = c.currentPeek() === ".";
    return c.resetPeek(), M;
  }
  function k(c, d) {
    const { currentType: C } = d;
    if (C !== 8)
      return !1;
    p(c);
    const M = u(c.currentPeek());
    return c.resetPeek(), M;
  }
  function j(c, d) {
    const { currentType: C } = d;
    if (!(C === 7 || C === 11))
      return !1;
    p(c);
    const M = c.currentPeek() === ":";
    return c.resetPeek(), M;
  }
  function K(c, d) {
    const { currentType: C } = d;
    if (C !== 9)
      return !1;
    const M = () => {
      const fe = c.currentPeek();
      return fe === "{" ? u(c.peek()) : fe === "@" || fe === "|" || fe === ":" || fe === "." || fe === Je || !fe ? !1 : fe === Te ? (c.peek(), M()) : G(c, !1);
    }, ce = M();
    return c.resetPeek(), ce;
  }
  function X(c) {
    p(c);
    const d = c.currentPeek() === "|";
    return c.resetPeek(), d;
  }
  function G(c, d = !0) {
    const C = (ce = !1, fe = "") => {
      const Z = c.currentPeek();
      return Z === "{" || Z === "@" || !Z ? ce : Z === "|" ? !(fe === Je || fe === Te) : Z === Je ? (c.peek(), C(!0, Je)) : Z === Te ? (c.peek(), C(!0, Te)) : !0;
    }, M = C();
    return d && c.resetPeek(), M;
  }
  function U(c, d) {
    const C = c.currentChar();
    return C === rt ? rt : d(C) ? (c.next(), C) : null;
  }
  function te(c) {
    const d = c.charCodeAt(0);
    return d >= 97 && d <= 122 || // a-z
    d >= 65 && d <= 90 || // A-Z
    d >= 48 && d <= 57 || // 0-9
    d === 95 || // _
    d === 36;
  }
  function O(c) {
    return U(c, te);
  }
  function I(c) {
    const d = c.charCodeAt(0);
    return d >= 97 && d <= 122 || // a-z
    d >= 65 && d <= 90 || // A-Z
    d >= 48 && d <= 57 || // 0-9
    d === 95 || // _
    d === 36 || // $
    d === 45;
  }
  function D(c) {
    return U(c, I);
  }
  function F(c) {
    const d = c.charCodeAt(0);
    return d >= 48 && d <= 57;
  }
  function P(c) {
    return U(c, F);
  }
  function W(c) {
    const d = c.charCodeAt(0);
    return d >= 48 && d <= 57 || // 0-9
    d >= 65 && d <= 70 || // A-F
    d >= 97 && d <= 102;
  }
  function B(c) {
    return U(c, W);
  }
  function J(c) {
    let d = "", C = "";
    for (; d = P(c); )
      C += d;
    return C;
  }
  function le(c) {
    let d = "";
    for (; ; ) {
      const C = c.currentChar();
      if (C === "{" || C === "}" || C === "@" || C === "|" || !C)
        break;
      if (C === Je || C === Te)
        if (G(c))
          d += C, c.next();
        else {
          if (X(c))
            break;
          d += C, c.next();
        }
      else
        d += C, c.next();
    }
    return d;
  }
  function de(c) {
    E(c);
    let d = "", C = "";
    for (; d = D(c); )
      C += d;
    const M = c.currentChar();
    if (M && M !== "}" && M !== rt && M !== Je && M !== Te && M !== "　") {
      const ce = ve(c);
      return y(Y.INVALID_TOKEN_IN_PLACEHOLDER, r(), 0, C + ce), C + ce;
    }
    return c.currentChar() === rt && y(Y.UNTERMINATED_CLOSING_BRACE, r(), 0), C;
  }
  function be(c) {
    E(c);
    let d = "";
    return c.currentChar() === "-" ? (c.next(), d += `-${J(c)}`) : d += J(c), c.currentChar() === rt && y(Y.UNTERMINATED_CLOSING_BRACE, r(), 0), d;
  }
  function Ce(c) {
    return c !== Xo && c !== Te;
  }
  function ot(c) {
    E(c), S(c, "'");
    let d = "", C = "";
    for (; d = U(c, Ce); )
      d === "\\" ? C += Ye(c) : C += d;
    const M = c.currentChar();
    return M === Te || M === rt ? (y(Y.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, r(), 0), M === Te && (c.next(), S(c, "'")), C) : (S(c, "'"), C);
  }
  function Ye(c) {
    const d = c.currentChar();
    switch (d) {
      case "\\":
      case "'":
        return c.next(), `\\${d}`;
      case "u":
        return qe(c, d, 4);
      case "U":
        return qe(c, d, 6);
      default:
        return y(Y.UNKNOWN_ESCAPE_SEQUENCE, r(), 0, d), "";
    }
  }
  function qe(c, d, C) {
    S(c, d);
    let M = "";
    for (let ce = 0; ce < C; ce++) {
      const fe = B(c);
      if (!fe) {
        y(Y.INVALID_UNICODE_ESCAPE_SEQUENCE, r(), 0, `\\${d}${M}${c.currentChar()}`);
        break;
      }
      M += fe;
    }
    return `\\${d}${M}`;
  }
  function je(c) {
    return c !== "{" && c !== "}" && c !== Je && c !== Te;
  }
  function ve(c) {
    E(c);
    let d = "", C = "";
    for (; d = U(c, je); )
      C += d;
    return C;
  }
  function Be(c) {
    let d = "", C = "";
    for (; d = O(c); )
      C += d;
    return C;
  }
  function st(c) {
    const d = (C) => {
      const M = c.currentChar();
      return M === "{" || M === "@" || M === "|" || M === "(" || M === ")" || !M || M === Je ? C : (C += M, c.next(), d(C));
    };
    return d("");
  }
  function ze(c) {
    E(c);
    const d = S(
      c,
      "|"
      /* TokenChars.Pipe */
    );
    return E(c), d;
  }
  function Yt(c, d) {
    let C = null;
    switch (c.currentChar()) {
      case "{":
        return d.braceNest >= 1 && y(Y.NOT_ALLOW_NEST_PLACEHOLDER, r(), 0), c.next(), C = m(
          d,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), E(c), d.braceNest++, C;
      case "}":
        return d.braceNest > 0 && d.currentType === 2 && y(Y.EMPTY_PLACEHOLDER, r(), 0), c.next(), C = m(
          d,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), d.braceNest--, d.braceNest > 0 && E(c), d.inLinked && d.braceNest === 0 && (d.inLinked = !1), C;
      case "@":
        return d.braceNest > 0 && y(Y.UNTERMINATED_CLOSING_BRACE, r(), 0), C = vt(c, d) || T(d), d.braceNest = 0, C;
      default: {
        let ce = !0, fe = !0, Z = !0;
        if (X(c))
          return d.braceNest > 0 && y(Y.UNTERMINATED_CLOSING_BRACE, r(), 0), C = m(d, 1, ze(c)), d.braceNest = 0, d.inLinked = !1, C;
        if (d.braceNest > 0 && (d.currentType === 4 || d.currentType === 5 || d.currentType === 6))
          return y(Y.UNTERMINATED_CLOSING_BRACE, r(), 0), d.braceNest = 0, jt(c, d);
        if (ce = x(c, d))
          return C = m(d, 4, de(c)), E(c), C;
        if (fe = _(c, d))
          return C = m(d, 5, be(c)), E(c), C;
        if (Z = A(c, d))
          return C = m(d, 6, ot(c)), E(c), C;
        if (!ce && !fe && !Z)
          return C = m(d, 12, ve(c)), y(Y.INVALID_TOKEN_IN_PLACEHOLDER, r(), 0, C.value), E(c), C;
        break;
      }
    }
    return C;
  }
  function vt(c, d) {
    const { currentType: C } = d;
    let M = null;
    const ce = c.currentChar();
    switch ((C === 7 || C === 8 || C === 11 || C === 9) && (ce === Te || ce === Je) && y(Y.INVALID_LINKED_FORMAT, r(), 0), ce) {
      case "@":
        return c.next(), M = m(
          d,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), d.inLinked = !0, M;
      case ".":
        return E(c), c.next(), m(
          d,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return E(c), c.next(), m(
          d,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return X(c) ? (M = m(d, 1, ze(c)), d.braceNest = 0, d.inLinked = !1, M) : N(c, d) || j(c, d) ? (E(c), vt(c, d)) : k(c, d) ? (E(c), m(d, 11, Be(c))) : K(c, d) ? (E(c), ce === "{" ? Yt(c, d) || M : m(d, 10, st(c))) : (C === 7 && y(Y.INVALID_LINKED_FORMAT, r(), 0), d.braceNest = 0, d.inLinked = !1, jt(c, d));
    }
  }
  function jt(c, d) {
    let C = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (d.braceNest > 0)
      return Yt(c, d) || T(d);
    if (d.inLinked)
      return vt(c, d) || T(d);
    switch (c.currentChar()) {
      case "{":
        return Yt(c, d) || T(d);
      case "}":
        return y(Y.UNBALANCED_CLOSING_BRACE, r(), 0), c.next(), m(
          d,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return vt(c, d) || T(d);
      default: {
        if (X(c))
          return C = m(d, 1, ze(c)), d.braceNest = 0, d.inLinked = !1, C;
        if (G(c))
          return m(d, 0, le(c));
        break;
      }
    }
    return C;
  }
  function Pn() {
    const { currentType: c, offset: d, startLoc: C, endLoc: M } = i;
    return i.lastType = c, i.lastOffset = d, i.lastStartLoc = C, i.lastEndLoc = M, i.offset = s(), i.startLoc = r(), o.currentChar() === rt ? m(
      i,
      13
      /* TokenTypes.EOF */
    ) : jt(o, i);
  }
  return {
    nextToken: Pn,
    currentOffset: s,
    currentPosition: r,
    context: f
  };
}
const du = "parser", fu = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function mu(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const o = parseInt(t || n, 16);
      return o <= 55295 || o >= 57344 ? String.fromCodePoint(o) : "�";
    }
  }
}
function pu(e = {}) {
  const t = e.location !== !1, { onError: n } = e;
  function o(u, b, x, _, ...A) {
    const N = u.currentPosition();
    if (N.offset += _, N.column += _, n) {
      const k = t ? Gn(x, N) : null, j = Ht(b, k, {
        domain: du,
        args: A
      });
      n(j);
    }
  }
  function s(u, b, x) {
    const _ = { type: u };
    return t && (_.start = b, _.end = b, _.loc = { start: x, end: x }), _;
  }
  function r(u, b, x, _) {
    t && (u.end = b, u.loc && (u.loc.end = x));
  }
  function a(u, b) {
    const x = u.context(), _ = s(3, x.offset, x.startLoc);
    return _.value = b, r(_, u.currentOffset(), u.currentPosition()), _;
  }
  function l(u, b) {
    const x = u.context(), { lastOffset: _, lastStartLoc: A } = x, N = s(5, _, A);
    return N.index = parseInt(b, 10), u.nextToken(), r(N, u.currentOffset(), u.currentPosition()), N;
  }
  function i(u, b) {
    const x = u.context(), { lastOffset: _, lastStartLoc: A } = x, N = s(4, _, A);
    return N.key = b, u.nextToken(), r(N, u.currentOffset(), u.currentPosition()), N;
  }
  function f(u, b) {
    const x = u.context(), { lastOffset: _, lastStartLoc: A } = x, N = s(9, _, A);
    return N.value = b.replace(fu, mu), u.nextToken(), r(N, u.currentOffset(), u.currentPosition()), N;
  }
  function g(u) {
    const b = u.nextToken(), x = u.context(), { lastOffset: _, lastStartLoc: A } = x, N = s(8, _, A);
    return b.type !== 11 ? (o(u, Y.UNEXPECTED_EMPTY_LINKED_MODIFIER, x.lastStartLoc, 0), N.value = "", r(N, _, A), {
      nextConsumeToken: b,
      node: N
    }) : (b.value == null && o(u, Y.UNEXPECTED_LEXICAL_ANALYSIS, x.lastStartLoc, 0, Ze(b)), N.value = b.value || "", r(N, u.currentOffset(), u.currentPosition()), {
      node: N
    });
  }
  function y(u, b) {
    const x = u.context(), _ = s(7, x.offset, x.startLoc);
    return _.value = b, r(_, u.currentOffset(), u.currentPosition()), _;
  }
  function m(u) {
    const b = u.context(), x = s(6, b.offset, b.startLoc);
    let _ = u.nextToken();
    if (_.type === 8) {
      const A = g(u);
      x.modifier = A.node, _ = A.nextConsumeToken || u.nextToken();
    }
    switch (_.type !== 9 && o(u, Y.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Ze(_)), _ = u.nextToken(), _.type === 2 && (_ = u.nextToken()), _.type) {
      case 10:
        _.value == null && o(u, Y.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Ze(_)), x.key = y(u, _.value || "");
        break;
      case 4:
        _.value == null && o(u, Y.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Ze(_)), x.key = i(u, _.value || "");
        break;
      case 5:
        _.value == null && o(u, Y.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Ze(_)), x.key = l(u, _.value || "");
        break;
      case 6:
        _.value == null && o(u, Y.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Ze(_)), x.key = f(u, _.value || "");
        break;
      default: {
        o(u, Y.UNEXPECTED_EMPTY_LINKED_KEY, b.lastStartLoc, 0);
        const A = u.context(), N = s(7, A.offset, A.startLoc);
        return N.value = "", r(N, A.offset, A.startLoc), x.key = N, r(x, A.offset, A.startLoc), {
          nextConsumeToken: _,
          node: x
        };
      }
    }
    return r(x, u.currentOffset(), u.currentPosition()), {
      node: x
    };
  }
  function T(u) {
    const b = u.context(), x = b.currentType === 1 ? u.currentOffset() : b.offset, _ = b.currentType === 1 ? b.endLoc : b.startLoc, A = s(2, x, _);
    A.items = [];
    let N = null;
    do {
      const K = N || u.nextToken();
      switch (N = null, K.type) {
        case 0:
          K.value == null && o(u, Y.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Ze(K)), A.items.push(a(u, K.value || ""));
          break;
        case 5:
          K.value == null && o(u, Y.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Ze(K)), A.items.push(l(u, K.value || ""));
          break;
        case 4:
          K.value == null && o(u, Y.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Ze(K)), A.items.push(i(u, K.value || ""));
          break;
        case 6:
          K.value == null && o(u, Y.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, Ze(K)), A.items.push(f(u, K.value || ""));
          break;
        case 7: {
          const X = m(u);
          A.items.push(X.node), N = X.nextConsumeToken || null;
          break;
        }
      }
    } while (b.currentType !== 13 && b.currentType !== 1);
    const k = b.currentType === 1 ? b.lastOffset : u.currentOffset(), j = b.currentType === 1 ? b.lastEndLoc : u.currentPosition();
    return r(A, k, j), A;
  }
  function S(u, b, x, _) {
    const A = u.context();
    let N = _.items.length === 0;
    const k = s(1, b, x);
    k.cases = [], k.cases.push(_);
    do {
      const j = T(u);
      N || (N = j.items.length === 0), k.cases.push(j);
    } while (A.currentType !== 13);
    return N && o(u, Y.MUST_HAVE_MESSAGES_IN_PLURAL, x, 0), r(k, u.currentOffset(), u.currentPosition()), k;
  }
  function p(u) {
    const b = u.context(), { offset: x, startLoc: _ } = b, A = T(u);
    return b.currentType === 13 ? A : S(u, x, _, A);
  }
  function E(u) {
    const b = uu(u, ye({}, e)), x = b.context(), _ = s(0, x.offset, x.startLoc);
    return t && _.loc && (_.loc.source = u), _.body = p(b), e.onCacheKey && (_.cacheKey = e.onCacheKey(u)), x.currentType !== 13 && o(b, Y.UNEXPECTED_LEXICAL_ANALYSIS, x.lastStartLoc, 0, u[x.offset] || ""), r(_, b.currentOffset(), b.currentPosition()), _;
  }
  return { parse: E };
}
function Ze(e) {
  if (e.type === 13)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function hu(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (r) => (n.helpers.add(r), r) };
}
function qo(e, t) {
  for (let n = 0; n < e.length; n++)
    Co(e[n], t);
}
function Co(e, t) {
  switch (e.type) {
    case 1:
      qo(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      qo(e.items, t);
      break;
    case 6: {
      Co(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function wu(e, t = {}) {
  const n = hu(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && Co(e.body, n);
  const o = n.context();
  e.helpers = Array.from(o.helpers);
}
function gu(e) {
  const t = e.body;
  return t.type === 2 ? zo(t) : t.cases.forEach((n) => zo(n)), e;
}
function zo(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const o = e.items[n];
      if (!(o.type === 3 || o.type === 9) || o.value == null)
        break;
      t.push(o.value);
    }
    if (t.length === e.items.length) {
      e.static = xo(t);
      for (let n = 0; n < e.items.length; n++) {
        const o = e.items[n];
        (o.type === 3 || o.type === 9) && delete o.value;
      }
    }
  }
}
const bu = "minifier";
function Dt(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      Dt(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, n = t.cases;
      for (let o = 0; o < n.length; o++)
        Dt(n[o]);
      t.c = n, delete t.cases;
      break;
    }
    case 2: {
      const t = e, n = t.items;
      for (let o = 0; o < n.length; o++)
        Dt(n[o]);
      t.i = n, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      Dt(t.key), t.k = t.key, delete t.key, t.modifier && (Dt(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      if (process.env.NODE_ENV !== "production")
        throw Ht(Y.UNHANDLED_MINIFIER_NODE_TYPE, null, {
          domain: bu,
          args: [e.type]
        });
  }
  delete e.type;
}
const vu = "parser";
function _u(e, t) {
  const { filename: n, breakLineCode: o, needIndent: s } = t, r = t.location !== !1, a = {
    filename: n,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: o,
    needIndent: s,
    indentLevel: 0
  };
  r && e.loc && (a.source = e.loc.source);
  const l = () => a;
  function i(p, E) {
    a.code += p;
  }
  function f(p, E = !0) {
    const u = E ? o : "";
    i(s ? u + "  ".repeat(p) : u);
  }
  function g(p = !0) {
    const E = ++a.indentLevel;
    p && f(E);
  }
  function y(p = !0) {
    const E = --a.indentLevel;
    p && f(E);
  }
  function m() {
    f(a.indentLevel);
  }
  return {
    context: l,
    push: i,
    indent: g,
    deindent: y,
    newline: m,
    helper: (p) => `_${p}`,
    needIndent: () => a.needIndent
  };
}
function yu(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), Rt(e, t.key), t.modifier ? (e.push(", "), Rt(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function Eu(e, t) {
  const { helper: n, needIndent: o } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(o());
  const s = t.items.length;
  for (let r = 0; r < s && (Rt(e, t.items[r]), r !== s - 1); r++)
    e.push(", ");
  e.deindent(o()), e.push("])");
}
function ku(e, t) {
  const { helper: n, needIndent: o } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(o());
    const s = t.cases.length;
    for (let r = 0; r < s && (Rt(e, t.cases[r]), r !== s - 1); r++)
      e.push(", ");
    e.deindent(o()), e.push("])");
  }
}
function xu(e, t) {
  t.body ? Rt(e, t.body) : e.push("null");
}
function Rt(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      xu(e, t);
      break;
    case 1:
      ku(e, t);
      break;
    case 2:
      Eu(e, t);
      break;
    case 6:
      yu(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw Ht(Y.UNHANDLED_CODEGEN_NODE_TYPE, null, {
          domain: vu,
          args: [t.type]
        });
  }
}
const Cu = (e, t = {}) => {
  const n = $(t.mode) ? t.mode : "normal", o = $(t.filename) ? t.filename : "message.intl";
  t.sourceMap;
  const s = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, r = t.needIndent ? t.needIndent : n !== "arrow", a = e.helpers || [], l = _u(e, {
    filename: o,
    breakLineCode: s,
    needIndent: r
  });
  l.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), l.indent(r), a.length > 0 && (l.push(`const { ${xo(a.map((g) => `${g}: _${g}`), ", ")} } = ctx`), l.newline()), l.push("return "), Rt(l, e), l.deindent(r), l.push("}"), delete e.helpers;
  const { code: i, map: f } = l.context();
  return {
    ast: e,
    code: i,
    map: f ? f.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function Tu(e, t = {}) {
  const n = ye({}, t), o = !!n.jit, s = !!n.minify, r = n.optimize == null ? !0 : n.optimize, l = pu(n).parse(e);
  return o ? (r && gu(l), s && Dt(l), { ast: l, code: "" }) : (wu(l, n), Cu(l, n));
}
/*!
  * core-base v11.2.8
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function Lu() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Ct().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Ct().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
function Xe(e) {
  return ee(e) && To(e) === 0 && (Ke(e, "b") || Ke(e, "body"));
}
const _r = ["b", "body"];
function Nu(e) {
  return gt(e, _r);
}
const yr = ["c", "cases"];
function Au(e) {
  return gt(e, yr, []);
}
const Er = ["s", "static"];
function Ou(e) {
  return gt(e, Er);
}
const kr = ["i", "items"];
function Iu(e) {
  return gt(e, kr, []);
}
const xr = ["t", "type"];
function To(e) {
  return gt(e, xr);
}
const Cr = ["v", "value"];
function an(e, t) {
  const n = gt(e, Cr);
  if (n != null)
    return n;
  throw Kt(t);
}
const Tr = ["m", "modifier"];
function Su(e) {
  return gt(e, Tr);
}
const Lr = ["k", "key"];
function Du(e) {
  const t = gt(e, Lr);
  if (t)
    return t;
  throw Kt(
    6
    /* NodeTypes.Linked */
  );
}
function gt(e, t, n) {
  for (let o = 0; o < t.length; o++) {
    const s = t[o];
    if (Ke(e, s) && e[s] != null)
      return e[s];
  }
  return n;
}
const Nr = [
  ..._r,
  ...yr,
  ...Er,
  ...kr,
  ...Lr,
  ...Tr,
  ...Cr,
  ...xr
];
function Kt(e) {
  return new Error(`unhandled node type: ${e}`);
}
function Un(e) {
  return (n) => Pu(n, e);
}
function Pu(e, t) {
  const n = Nu(t);
  if (n == null)
    throw Kt(
      0
      /* NodeTypes.Resource */
    );
  if (To(n) === 1) {
    const r = Au(n);
    return e.plural(r.reduce((a, l) => [
      ...a,
      Jo(e, l)
    ], []));
  } else
    return Jo(e, n);
}
function Jo(e, t) {
  const n = Ou(t);
  if (n != null)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const o = Iu(t).reduce((s, r) => [...s, Kn(e, r)], []);
    return e.normalize(o);
  }
}
function Kn(e, t) {
  const n = To(t);
  switch (n) {
    case 3:
      return an(t, n);
    case 9:
      return an(t, n);
    case 4: {
      const o = t;
      if (Ke(o, "k") && o.k)
        return e.interpolate(e.named(o.k));
      if (Ke(o, "key") && o.key)
        return e.interpolate(e.named(o.key));
      throw Kt(n);
    }
    case 5: {
      const o = t;
      if (Ke(o, "i") && _e(o.i))
        return e.interpolate(e.list(o.i));
      if (Ke(o, "index") && _e(o.index))
        return e.interpolate(e.list(o.index));
      throw Kt(n);
    }
    case 6: {
      const o = t, s = Su(o), r = Du(o);
      return e.linked(Kn(e, r), s ? Kn(e, s) : void 0, e.type);
    }
    case 7:
      return an(t, n);
    case 8:
      return an(t, n);
    default:
      throw new Error(`unhandled node on format message part: ${n}`);
  }
}
const $u = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function Mu(e, t) {
  t && ou(e) && nt(An($u, { source: e }));
}
const Ru = (e) => e;
let ln = re();
function Fu(e, t = {}) {
  let n = !1;
  const o = t.onError || tu;
  return t.onError = (s) => {
    n = !0, o(s);
  }, { ...Tu(e, t), detectError: n };
}
// @__NO_SIDE_EFFECTS__
function Uu(e, t) {
  if (!__INTLIFY_DROP_MESSAGE_COMPILER__ && $(e)) {
    const n = he(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && Mu(e, n);
    const s = (t.onCacheKey || Ru)(e), r = ln[s];
    if (r)
      return r;
    const { ast: a, detectError: l } = Fu(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), i = Un(a);
    return l ? i : ln[s] = i;
  } else {
    if (process.env.NODE_ENV !== "production" && !Xe(e))
      return nt(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), () => e;
    const n = e.cacheKey;
    if (n) {
      const o = ln[n];
      return o || (ln[n] = Un(e));
    } else
      return Un(e);
  }
}
let Xt = null;
function Bu(e) {
  Xt = e;
}
function Vu(e, t, n) {
  Xt && Xt.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const Hu = /* @__PURE__ */ Yu("function:translate");
function Yu(e) {
  return (t) => Xt && Xt.emit(e, t);
}
const Le = {
  INVALID_ARGUMENT: Qc,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, ju = 24;
function it(e) {
  return Ht(e, null, process.env.NODE_ENV !== "production" ? { messages: Wu } : void 0);
}
const Wu = {
  [Le.INVALID_ARGUMENT]: "Invalid arguments",
  [Le.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [Le.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [Le.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [Le.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [Le.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [Le.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function Lo(e, t) {
  return t.locale != null ? Zo(t.locale) : Zo(e.locale);
}
let Bn;
function Zo(e) {
  if ($(e))
    return e;
  if (ue(e)) {
    if (e.resolvedOnce && Bn != null)
      return Bn;
    if (e.constructor.name === "Function") {
      const t = e();
      if (Xc(t))
        throw it(Le.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return Bn = t;
    } else
      throw it(Le.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw it(Le.NOT_SUPPORT_LOCALE_TYPE);
}
function Gu(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...we(t) ? t : ee(t) ? Object.keys(t) : $(t) ? [t] : [n]
  ])];
}
function Ar(e, t, n) {
  const o = $(n) ? n : _n, s = e;
  s.__localeChainCache || (s.__localeChainCache = /* @__PURE__ */ new Map());
  let r = s.__localeChainCache.get(o);
  if (!r) {
    r = [];
    let a = [n];
    for (; we(a); )
      a = Qo(r, a, t);
    const l = we(t) || !Q(t) ? t : t.default ? t.default : null;
    a = $(l) ? [l] : l, we(a) && Qo(r, a, !1), s.__localeChainCache.set(o, r);
  }
  return r;
}
function Qo(e, t, n) {
  let o = !0;
  for (let s = 0; s < t.length && he(o); s++) {
    const r = t[s];
    $(r) && (o = Ku(e, t[s], n));
  }
  return o;
}
function Ku(e, t, n) {
  let o;
  const s = t.split("-");
  do {
    const r = s.join("-");
    o = Xu(e, r, n), s.splice(-1, 1);
  } while (s.length && o === !0);
  return o;
}
function Xu(e, t, n) {
  let o = !1;
  if (!e.includes(t) && (o = !0, t)) {
    o = t[t.length - 1] !== "!";
    const s = t.replace(/!/g, "");
    e.push(s), (we(n) || Q(n)) && n[s] && (o = n[s]);
  }
  return o;
}
const bt = [];
bt[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
bt[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
bt[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
bt[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
bt[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
bt[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
bt[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const qu = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function zu(e) {
  return qu.test(e);
}
function Ju(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function Zu(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function Qu(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : zu(t) ? Ju(t) : "*" + t;
}
function ed(e) {
  const t = [];
  let n = -1, o = 0, s = 0, r, a, l, i, f, g, y;
  const m = [];
  m[
    0
    /* Actions.APPEND */
  ] = () => {
    a === void 0 ? a = l : a += l;
  }, m[
    1
    /* Actions.PUSH */
  ] = () => {
    a !== void 0 && (t.push(a), a = void 0);
  }, m[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    m[
      0
      /* Actions.APPEND */
    ](), s++;
  }, m[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (s > 0)
      s--, o = 4, m[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (s = 0, a === void 0 || (a = Qu(a), a === !1))
        return !1;
      m[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function T() {
    const S = e[n + 1];
    if (o === 5 && S === "'" || o === 6 && S === '"')
      return n++, l = "\\" + S, m[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; o !== null; )
    if (n++, r = e[n], !(r === "\\" && T())) {
      if (i = Zu(r), y = bt[o], f = y[i] || y.l || 8, f === 8 || (o = f[0], f[1] !== void 0 && (g = m[f[1]], g && (l = r, g() === !1))))
        return;
      if (o === 7)
        return t;
    }
}
const es = /* @__PURE__ */ new Map();
function td(e, t) {
  return ee(e) ? e[t] : null;
}
function nd(e, t) {
  if (!ee(e))
    return null;
  let n = es.get(t);
  if (n || (n = ed(t), n && es.set(t, n)), !n)
    return null;
  const o = n.length;
  let s = e, r = 0;
  for (; r < o; ) {
    const a = n[r];
    if (Nr.includes(a) && Xe(s))
      return null;
    const l = s[a];
    if (l === void 0 || ue(s))
      return null;
    s = l, r++;
  }
  return s;
}
const Se = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7
}, od = 8, sd = {
  [Se.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [Se.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [Se.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [Se.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [Se.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [Se.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [Se.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function At(e, ...t) {
  return An(sd[e], ...t);
}
const rd = "11.2.8", In = -1, _n = "en-US", yn = "", ts = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function ad() {
  return {
    upper: (e, t) => t === "text" && $(e) ? e.toUpperCase() : t === "vnode" && ee(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && $(e) ? e.toLowerCase() : t === "vnode" && ee(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && $(e) ? ts(e) : t === "vnode" && ee(e) && "__v_isVNode" in e ? ts(e.children) : e
  };
}
let Or;
function id(e) {
  Or = e;
}
let Ir;
function ld(e) {
  Ir = e;
}
let Sr;
function cd(e) {
  Sr = e;
}
let Dr = null;
const ud = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  Dr = e;
}, dd = /* @__NO_SIDE_EFFECTS__ */ () => Dr;
let Pr = null;
const ns = (e) => {
  Pr = e;
}, fd = () => Pr;
let os = 0;
function md(e = {}) {
  const t = ue(e.onWarn) ? e.onWarn : nt, n = $(e.version) ? e.version : rd, o = $(e.locale) || ue(e.locale) ? e.locale : _n, s = ue(o) ? _n : o, r = we(e.fallbackLocale) || Q(e.fallbackLocale) || $(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : s, a = Q(e.messages) ? e.messages : Vn(s), l = Q(e.datetimeFormats) ? e.datetimeFormats : Vn(s), i = Q(e.numberFormats) ? e.numberFormats : Vn(s), f = ye(re(), e.modifiers, ad()), g = e.pluralRules || re(), y = ue(e.missing) ? e.missing : null, m = he(e.missingWarn) || vn(e.missingWarn) ? e.missingWarn : !0, T = he(e.fallbackWarn) || vn(e.fallbackWarn) ? e.fallbackWarn : !0, S = !!e.fallbackFormat, p = !!e.unresolving, E = ue(e.postTranslation) ? e.postTranslation : null, u = Q(e.processor) ? e.processor : null, b = he(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, x = !!e.escapeParameter, _ = ue(e.messageCompiler) ? e.messageCompiler : Or;
  process.env.NODE_ENV !== "production" && ue(e.messageCompiler) && Bc(At(Se.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const A = ue(e.messageResolver) ? e.messageResolver : Ir || td, N = ue(e.localeFallbacker) ? e.localeFallbacker : Sr || Gu, k = ee(e.fallbackContext) ? e.fallbackContext : void 0, j = e, K = ee(j.__datetimeFormatters) ? j.__datetimeFormatters : /* @__PURE__ */ new Map(), X = ee(j.__numberFormatters) ? j.__numberFormatters : /* @__PURE__ */ new Map(), G = ee(j.__meta) ? j.__meta : {};
  os++;
  const U = {
    version: n,
    cid: os,
    locale: o,
    fallbackLocale: r,
    messages: a,
    modifiers: f,
    pluralRules: g,
    missing: y,
    missingWarn: m,
    fallbackWarn: T,
    fallbackFormat: S,
    unresolving: p,
    postTranslation: E,
    processor: u,
    warnHtmlMessage: b,
    escapeParameter: x,
    messageCompiler: _,
    messageResolver: A,
    localeFallbacker: N,
    fallbackContext: k,
    onWarn: t,
    __meta: G
  };
  return U.datetimeFormats = l, U.numberFormats = i, U.__datetimeFormatters = K, U.__numberFormatters = X, process.env.NODE_ENV !== "production" && (U.__v_emitter = j.__v_emitter != null ? j.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && Vu(U, n, G), U;
}
const Vn = (e) => ({ [e]: re() });
function Sn(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function $r(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function No(e, t, n, o, s) {
  const { missing: r, onWarn: a } = e;
  if (process.env.NODE_ENV !== "production") {
    const l = e.__v_emitter;
    l && l.emit("missing", {
      locale: n,
      key: t,
      type: s,
      groupId: `${s}:${t}`
    });
  }
  if (r !== null) {
    const l = r(e, n, t, s);
    return $(l) ? l : t;
  } else
    return process.env.NODE_ENV !== "production" && $r(o, t) && a(At(Se.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function Wt(e, t, n) {
  const o = e;
  o.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function Mr(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function pd(e, t) {
  const n = t.indexOf(e);
  if (n === -1)
    return !1;
  for (let o = n + 1; o < t.length; o++)
    if (Mr(e, t[o]))
      return !0;
  return !1;
}
const ss = typeof Intl < "u", Rr = {
  dateTimeFormat: ss && typeof Intl.DateTimeFormat < "u",
  numberFormat: ss && typeof Intl.NumberFormat < "u"
};
function rs(e, ...t) {
  const { datetimeFormats: n, unresolving: o, fallbackLocale: s, onWarn: r, localeFallbacker: a } = e, { __datetimeFormatters: l } = e;
  if (process.env.NODE_ENV !== "production" && !Rr.dateTimeFormat)
    return r(At(Se.CANNOT_FORMAT_DATE)), yn;
  const [i, f, g, y] = Xn(...t), m = he(g.missingWarn) ? g.missingWarn : e.missingWarn, T = he(g.fallbackWarn) ? g.fallbackWarn : e.fallbackWarn, S = !!g.part, p = Lo(e, g), E = a(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    s,
    p
  );
  if (!$(i) || i === "")
    return new Intl.DateTimeFormat(p, y).format(f);
  let u = {}, b, x = null, _ = p, A = null;
  const N = "datetime format";
  for (let K = 0; K < E.length; K++) {
    if (b = A = E[K], process.env.NODE_ENV !== "production" && p !== b && Sn(T, i) && r(At(Se.FALLBACK_TO_DATE_FORMAT, {
      key: i,
      target: b
    })), process.env.NODE_ENV !== "production" && p !== b) {
      const X = e.__v_emitter;
      X && X.emit("fallback", {
        type: N,
        key: i,
        from: _,
        to: A,
        groupId: `${N}:${i}`
      });
    }
    if (u = n[b] || {}, x = u[i], Q(x))
      break;
    No(e, i, b, m, N), _ = A;
  }
  if (!Q(x) || !$(b))
    return o ? In : i;
  let k = `${b}__${i}`;
  On(y) || (k = `${k}__${JSON.stringify(y)}`);
  let j = l.get(k);
  return j || (j = new Intl.DateTimeFormat(b, ye({}, x, y)), l.set(k, j)), S ? j.formatToParts(f) : j.format(f);
}
const Fr = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function Xn(...e) {
  const [t, n, o, s] = e, r = re();
  let a = re(), l;
  if ($(t)) {
    const i = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!i)
      throw it(Le.INVALID_ISO_DATE_ARGUMENT);
    const f = i[3] ? i[3].trim().startsWith("T") ? `${i[1].trim()}${i[3].trim()}` : `${i[1].trim()}T${i[3].trim()}` : i[1].trim();
    l = new Date(f);
    try {
      l.toISOString();
    } catch {
      throw it(Le.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (jc(t)) {
    if (isNaN(t.getTime()))
      throw it(Le.INVALID_DATE_ARGUMENT);
    l = t;
  } else if (_e(t))
    l = t;
  else
    throw it(Le.INVALID_ARGUMENT);
  return $(n) ? r.key = n : Q(n) && Object.keys(n).forEach((i) => {
    Fr.includes(i) ? a[i] = n[i] : r[i] = n[i];
  }), $(o) ? r.locale = o : Q(o) && (a = o), Q(s) && (a = s), [r.key || "", l, r, a];
}
function as(e, t, n) {
  const o = e;
  for (const s in n) {
    const r = `${t}__${s}`;
    o.__datetimeFormatters.has(r) && o.__datetimeFormatters.delete(r);
  }
}
function is(e, ...t) {
  const { numberFormats: n, unresolving: o, fallbackLocale: s, onWarn: r, localeFallbacker: a } = e, { __numberFormatters: l } = e;
  if (process.env.NODE_ENV !== "production" && !Rr.numberFormat)
    return r(At(Se.CANNOT_FORMAT_NUMBER)), yn;
  const [i, f, g, y] = qn(...t), m = he(g.missingWarn) ? g.missingWarn : e.missingWarn, T = he(g.fallbackWarn) ? g.fallbackWarn : e.fallbackWarn, S = !!g.part, p = Lo(e, g), E = a(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    s,
    p
  );
  if (!$(i) || i === "")
    return new Intl.NumberFormat(p, y).format(f);
  let u = {}, b, x = null, _ = p, A = null;
  const N = "number format";
  for (let K = 0; K < E.length; K++) {
    if (b = A = E[K], process.env.NODE_ENV !== "production" && p !== b && Sn(T, i) && r(At(Se.FALLBACK_TO_NUMBER_FORMAT, {
      key: i,
      target: b
    })), process.env.NODE_ENV !== "production" && p !== b) {
      const X = e.__v_emitter;
      X && X.emit("fallback", {
        type: N,
        key: i,
        from: _,
        to: A,
        groupId: `${N}:${i}`
      });
    }
    if (u = n[b] || {}, x = u[i], Q(x))
      break;
    No(e, i, b, m, N), _ = A;
  }
  if (!Q(x) || !$(b))
    return o ? In : i;
  let k = `${b}__${i}`;
  On(y) || (k = `${k}__${JSON.stringify(y)}`);
  let j = l.get(k);
  return j || (j = new Intl.NumberFormat(b, ye({}, x, y)), l.set(k, j)), S ? j.formatToParts(f) : j.format(f);
}
const Ur = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function qn(...e) {
  const [t, n, o, s] = e, r = re();
  let a = re();
  if (!_e(t))
    throw it(Le.INVALID_ARGUMENT);
  const l = t;
  return $(n) ? r.key = n : Q(n) && Object.keys(n).forEach((i) => {
    Ur.includes(i) ? a[i] = n[i] : r[i] = n[i];
  }), $(o) ? r.locale = o : Q(o) && (a = o), Q(s) && (a = s), [r.key || "", l, r, a];
}
function ls(e, t, n) {
  const o = e;
  for (const s in n) {
    const r = `${t}__${s}`;
    o.__numberFormatters.has(r) && o.__numberFormatters.delete(r);
  }
}
const hd = (e) => e, wd = (e) => "", gd = "text", bd = (e) => e.length === 0 ? "" : xo(e), vd = qc;
function cs(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function _d(e) {
  const t = _e(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (_e(e.named.count) || _e(e.named.n)) ? _e(e.named.count) ? e.named.count : _e(e.named.n) ? e.named.n : t : t;
}
function yd(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function Ed(e = {}) {
  const t = e.locale, n = _d(e), o = ee(e.pluralRules) && $(t) && ue(e.pluralRules[t]) ? e.pluralRules[t] : cs, s = ee(e.pluralRules) && $(t) && ue(e.pluralRules[t]) ? cs : void 0, r = (u) => u[o(n, u.length, s)], a = e.list || [], l = (u) => a[u], i = e.named || re();
  _e(e.pluralIndex) && yd(n, i);
  const f = (u) => i[u];
  function g(u, b) {
    const x = ue(e.messages) ? e.messages(u, !!b) : ee(e.messages) ? e.messages[u] : !1;
    return x || (e.parent ? e.parent.message(u) : wd);
  }
  const y = (u) => e.modifiers ? e.modifiers[u] : hd, m = Q(e.processor) && ue(e.processor.normalize) ? e.processor.normalize : bd, T = Q(e.processor) && ue(e.processor.interpolate) ? e.processor.interpolate : vd, S = Q(e.processor) && $(e.processor.type) ? e.processor.type : gd, E = {
    list: l,
    named: f,
    plural: r,
    linked: (u, ...b) => {
      const [x, _] = b;
      let A = "text", N = "";
      b.length === 1 ? ee(x) ? (N = x.modifier || N, A = x.type || A) : $(x) && (N = x || N) : b.length === 2 && ($(x) && (N = x || N), $(_) && (A = _ || A));
      const k = g(u, !0)(E), j = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        A === "vnode" && we(k) && N ? k[0] : k
      );
      return N ? y(N)(j, A) : j;
    },
    message: g,
    type: S,
    interpolate: T,
    normalize: m,
    values: ye(re(), a, i)
  };
  return E;
}
const us = () => "", Ve = (e) => ue(e);
function ds(e, ...t) {
  const { fallbackFormat: n, postTranslation: o, unresolving: s, messageCompiler: r, fallbackLocale: a, messages: l } = e, [i, f] = zn(...t), g = he(f.missingWarn) ? f.missingWarn : e.missingWarn, y = he(f.fallbackWarn) ? f.fallbackWarn : e.fallbackWarn, m = he(f.escapeParameter) ? f.escapeParameter : e.escapeParameter, T = !!f.resolvedMessage, S = $(f.default) || he(f.default) ? he(f.default) ? r ? i : () => i : f.default : n ? r ? i : () => i : null, p = n || S != null && ($(S) || ue(S)), E = Lo(e, f);
  m && kd(f);
  let [u, b, x] = T ? [
    i,
    E,
    l[E] || re()
  ] : Br(e, i, E, a, y, g), _ = u, A = i;
  if (!T && !($(_) || Xe(_) || Ve(_)) && p && (_ = S, A = _), !T && (!($(_) || Xe(_) || Ve(_)) || !$(b)))
    return s ? In : i;
  if (process.env.NODE_ENV !== "production" && $(_) && e.messageCompiler == null)
    return nt(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${i}'.`), i;
  let N = !1;
  const k = () => {
    N = !0;
  }, j = Ve(_) ? _ : Vr(e, i, b, _, A, k);
  if (N)
    return _;
  const K = Ld(e, b, x, f), X = Ed(K), G = xd(e, j, X);
  let U = o ? o(G, i) : G;
  if (m && $(U) && (U = Gc(U)), process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const te = {
      timestamp: Date.now(),
      key: $(i) ? i : Ve(_) ? _.key : "",
      locale: b || (Ve(_) ? _.locale : ""),
      format: $(_) ? _ : Ve(_) ? _.source : "",
      message: U
    };
    te.meta = ye({}, e.__meta, /* @__PURE__ */ dd() || {}), Hu(te);
  }
  return U;
}
function kd(e) {
  we(e.list) ? e.list = e.list.map((t) => $(t) ? Wo(t) : t) : ee(e.named) && Object.keys(e.named).forEach((t) => {
    $(e.named[t]) && (e.named[t] = Wo(e.named[t]));
  });
}
function Br(e, t, n, o, s, r) {
  const { messages: a, onWarn: l, messageResolver: i, localeFallbacker: f } = e, g = f(e, o, n);
  let y = re(), m, T = null, S = n, p = null;
  const E = "translate";
  for (let u = 0; u < g.length; u++) {
    if (m = p = g[u], process.env.NODE_ENV !== "production" && n !== m && !Mr(n, m) && Sn(s, t) && l(At(Se.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: m
    })), process.env.NODE_ENV !== "production" && n !== m) {
      const A = e.__v_emitter;
      A && A.emit("fallback", {
        type: E,
        key: t,
        from: S,
        to: p,
        groupId: `${E}:${t}`
      });
    }
    y = a[m] || re();
    let b = null, x, _;
    if (process.env.NODE_ENV !== "production" && ct && (b = window.performance.now(), x = "intlify-message-resolve-start", _ = "intlify-message-resolve-end", Me && Me(x)), (T = i(y, t)) === null && (T = y[t]), process.env.NODE_ENV !== "production" && ct) {
      const A = window.performance.now(), N = e.__v_emitter;
      N && b && T && N.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: T,
        time: A - b,
        groupId: `${E}:${t}`
      }), x && _ && Me && Nt && (Me(_), Nt("intlify message resolve", x, _));
    }
    if ($(T) || Xe(T) || Ve(T))
      break;
    if (!pd(m, g)) {
      const A = No(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        m,
        r,
        E
      );
      A !== t && (T = A);
    }
    S = p;
  }
  return [T, m, y];
}
function Vr(e, t, n, o, s, r) {
  const { messageCompiler: a, warnHtmlMessage: l } = e;
  if (Ve(o)) {
    const m = o;
    return m.locale = m.locale || n, m.key = m.key || t, m;
  }
  if (a == null) {
    const m = () => o;
    return m.locale = n, m.key = t, m;
  }
  let i = null, f, g;
  process.env.NODE_ENV !== "production" && ct && (i = window.performance.now(), f = "intlify-message-compilation-start", g = "intlify-message-compilation-end", Me && Me(f));
  const y = a(o, Cd(e, n, s, o, l, r));
  if (process.env.NODE_ENV !== "production" && ct) {
    const m = window.performance.now(), T = e.__v_emitter;
    T && i && T.emit("message-compilation", {
      type: "message-compilation",
      message: o,
      time: m - i,
      groupId: `translate:${t}`
    }), f && g && Me && Nt && (Me(g), Nt("intlify message compilation", f, g));
  }
  return y.locale = n, y.key = t, y.source = o, y;
}
function xd(e, t, n) {
  let o = null, s, r;
  process.env.NODE_ENV !== "production" && ct && (o = window.performance.now(), s = "intlify-message-evaluation-start", r = "intlify-message-evaluation-end", Me && Me(s));
  const a = t(n);
  if (process.env.NODE_ENV !== "production" && ct) {
    const l = window.performance.now(), i = e.__v_emitter;
    i && o && i.emit("message-evaluation", {
      type: "message-evaluation",
      value: a,
      time: l - o,
      groupId: `translate:${t.key}`
    }), s && r && Me && Nt && (Me(r), Nt("intlify message evaluation", s, r));
  }
  return a;
}
function zn(...e) {
  const [t, n, o] = e, s = re();
  if (!$(t) && !_e(t) && !Ve(t) && !Xe(t))
    throw it(Le.INVALID_ARGUMENT);
  const r = _e(t) ? String(t) : (Ve(t), t);
  return _e(n) ? s.plural = n : $(n) ? s.default = n : Q(n) && !On(n) ? s.named = n : we(n) && (s.list = n), _e(o) ? s.plural = o : $(o) ? s.default = o : Q(o) && ye(s, o), [r, s];
}
function Cd(e, t, n, o, s, r) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: s,
    onError: (a) => {
      if (r && r(a), process.env.NODE_ENV !== "production") {
        const l = Td(o), i = `Message compilation error: ${a.message}`, f = a.location && l && zc(l, a.location.start.offset, a.location.end.offset), g = e.__v_emitter;
        g && l && g.emit("compile-error", {
          message: l,
          error: a.message,
          start: a.location && a.location.start.offset,
          end: a.location && a.location.end.offset,
          groupId: `translate:${n}`
        }), console.error(f ? `${i}
${f}` : i);
      } else
        throw a;
    },
    onCacheKey: (a) => Hc(t, n, a)
  };
}
function Td(e) {
  if ($(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function Ld(e, t, n, o) {
  const { modifiers: s, pluralRules: r, messageResolver: a, fallbackLocale: l, fallbackWarn: i, missingWarn: f, fallbackContext: g } = e, m = {
    locale: t,
    modifiers: s,
    pluralRules: r,
    messages: (T, S) => {
      let p = a(n, T);
      if (p == null && (g || S)) {
        const [, , E] = Br(
          g || e,
          // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
          T,
          t,
          l,
          i,
          f
        );
        p = a(E, T);
      }
      if ($(p) || Xe(p)) {
        let E = !1;
        const b = Vr(e, T, t, p, T, () => {
          E = !0;
        });
        return E ? us : b;
      } else return Ve(p) ? p : us;
    }
  };
  return e.processor && (m.processor = e.processor), o.list && (m.list = o.list), o.named && (m.named = o.named), _e(o.plural) && (m.pluralIndex = o.plural), m;
}
Lu();
/*!
  * vue-i18n v11.2.8
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
const Nd = "11.2.8";
function Ad() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (Ct().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (Ct().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Ct().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Ct().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const ke = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: ju,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function qt(e, ...t) {
  return Ht(e, null, process.env.NODE_ENV !== "production" ? { messages: Od, args: t } : void 0);
}
const Od = {
  [ke.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [ke.INVALID_ARGUMENT]: "Invalid argument",
  [ke.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [ke.NOT_INSTALLED]: "Need to install with `app.use` function",
  [ke.UNEXPECTED_ERROR]: "Unexpected error",
  [ke.REQUIRED_VALUE]: "Required in value: {0}",
  [ke.INVALID_VALUE]: "Invalid value",
  [ke.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [ke.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [ke.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [ke.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, Jn = /* @__PURE__ */ dt("__translateVNode"), Zn = /* @__PURE__ */ dt("__datetimeParts"), Qn = /* @__PURE__ */ dt("__numberParts"), eo = /* @__PURE__ */ dt("__enableEmitter"), to = /* @__PURE__ */ dt("__disableEmitter"), Id = dt("__setPluralRules"), Hr = /* @__PURE__ */ dt("__injectWithOption"), no = /* @__PURE__ */ dt("__dispose"), et = {
  FALLBACK_TO_ROOT: od,
  // 8
  NOT_FOUND_PARENT_SCOPE: 9,
  IGNORE_OBJ_FLATTEN: 10,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_LEGACY_MODE: 11,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE: 12,
  // duplicate `useI18n` calling
  DUPLICATE_USE_I18N_CALLING: 13
}, Sd = {
  [et.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [et.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [et.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [et.DEPRECATE_LEGACY_MODE]: `Legacy API mode has been deprecated in v11. Use Composition API mode instead.
About how to use the Composition API mode, see https://vue-i18n.intlify.dev/guide/advanced/composition.html`,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [et.DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE]: "'v-t' has been deprecated in v11. Use translate APIs ('t' or '$t') instead.",
  [et.DUPLICATE_USE_I18N_CALLING]: "Duplicate `useI18n` calling by local scope. Please don't call it on local scope, due to it does not work properly in component."
};
function En(e, ...t) {
  return An(Sd[e], ...t);
}
function zt(e) {
  if (!ee(e) || Xe(e))
    return e;
  for (const t in e)
    if (Ke(e, t))
      if (!t.includes("."))
        ee(e[t]) && zt(e[t]);
      else {
        const n = t.split("."), o = n.length - 1;
        let s = e, r = !1;
        for (let a = 0; a < o; a++) {
          if (n[a] === "__proto__")
            throw new Error(`unsafe key: ${n[a]}`);
          if (n[a] in s || (s[n[a]] = re()), !ee(s[n[a]])) {
            process.env.NODE_ENV !== "production" && nt(En(et.IGNORE_OBJ_FLATTEN, {
              key: n[a]
            })), r = !0;
            break;
          }
          s = s[n[a]];
        }
        if (r || (Xe(s) ? Nr.includes(n[o]) || delete e[t] : (s[n[o]] = e[t], delete e[t])), !Xe(s)) {
          const a = s[n[o]];
          ee(a) && zt(a);
        }
      }
  return e;
}
function Yr(e, t) {
  const { messages: n, __i18n: o, messageResolver: s, flatJson: r } = t, a = Q(n) ? n : we(o) ? re() : { [e]: re() };
  if (we(o) && o.forEach((l) => {
    if ("locale" in l && "resource" in l) {
      const { locale: i, resource: f } = l;
      i ? (a[i] = a[i] || re(), cn(f, a[i])) : cn(f, a);
    } else
      $(l) && cn(JSON.parse(l), a);
  }), s == null && r)
    for (const l in a)
      Ke(a, l) && zt(a[l]);
  return a;
}
function jr(e) {
  return e.type;
}
function Dd(e, t, n) {
  let o = ee(t.messages) ? t.messages : re();
  "__i18nGlobal" in n && (o = Yr(e.locale.value, {
    messages: o,
    __i18n: n.__i18nGlobal
  }));
  const s = Object.keys(o);
  s.length && s.forEach((r) => {
    e.mergeLocaleMessage(r, o[r]);
  });
  {
    if (ee(t.datetimeFormats)) {
      const r = Object.keys(t.datetimeFormats);
      r.length && r.forEach((a) => {
        e.mergeDateTimeFormat(a, t.datetimeFormats[a]);
      });
    }
    if (ee(t.numberFormats)) {
      const r = Object.keys(t.numberFormats);
      r.length && r.forEach((a) => {
        e.mergeNumberFormat(a, t.numberFormats[a]);
      });
    }
  }
}
function fs(e) {
  return kt(Jr, null, e, 0);
}
function Ao() {
  const e = "currentInstance";
  return e in $n ? $n[e] : $n.getCurrentInstance();
}
const ms = "__INTLIFY_META__", ps = () => [], Pd = () => !1;
let hs = 0;
function ws(e) {
  return (t, n, o, s) => e(n, o, Ao() || void 0, s);
}
const $d = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = Ao();
  let t = null;
  return e && (t = jr(e)[ms]) ? { [ms]: t } : null;
};
function Md(e = {}) {
  const { __root: t, __injectWithOption: n } = e, o = t === void 0, s = e.flatJson, r = ct ? z : zr;
  let a = he(e.inheritLocale) ? e.inheritLocale : !0;
  const l = r(
    // prettier-ignore
    t && a ? t.locale.value : $(e.locale) ? e.locale : _n
  ), i = r(
    // prettier-ignore
    t && a ? t.fallbackLocale.value : $(e.fallbackLocale) || we(e.fallbackLocale) || Q(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : l.value
  ), f = r(Yr(l.value, e)), g = r(Q(e.datetimeFormats) ? e.datetimeFormats : { [l.value]: {} }), y = r(Q(e.numberFormats) ? e.numberFormats : { [l.value]: {} });
  let m = t ? t.missingWarn : he(e.missingWarn) || vn(e.missingWarn) ? e.missingWarn : !0, T = t ? t.fallbackWarn : he(e.fallbackWarn) || vn(e.fallbackWarn) ? e.fallbackWarn : !0, S = t ? t.fallbackRoot : he(e.fallbackRoot) ? e.fallbackRoot : !0, p = !!e.fallbackFormat, E = ue(e.missing) ? e.missing : null, u = ue(e.missing) ? ws(e.missing) : null, b = ue(e.postTranslation) ? e.postTranslation : null, x = t ? t.warnHtmlMessage : he(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, _ = !!e.escapeParameter;
  const A = t ? t.modifiers : Q(e.modifiers) ? e.modifiers : {};
  let N = e.pluralRules || t && t.pluralRules, k;
  k = (() => {
    o && ns(null);
    const v = {
      version: Nd,
      locale: l.value,
      fallbackLocale: i.value,
      messages: f.value,
      modifiers: A,
      pluralRules: N,
      missing: u === null ? void 0 : u,
      missingWarn: m,
      fallbackWarn: T,
      fallbackFormat: p,
      unresolving: !0,
      postTranslation: b === null ? void 0 : b,
      warnHtmlMessage: x,
      escapeParameter: _,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    v.datetimeFormats = g.value, v.numberFormats = y.value, v.__datetimeFormatters = Q(k) ? k.__datetimeFormatters : void 0, v.__numberFormatters = Q(k) ? k.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (v.__v_emitter = Q(k) ? k.__v_emitter : void 0);
    const L = md(v);
    return o && ns(L), L;
  })(), Wt(k, l.value, i.value);
  function K() {
    return [
      l.value,
      i.value,
      f.value,
      g.value,
      y.value
    ];
  }
  const X = Ae({
    get: () => l.value,
    set: (v) => {
      k.locale = v, l.value = v;
    }
  }), G = Ae({
    get: () => i.value,
    set: (v) => {
      k.fallbackLocale = v, i.value = v, Wt(k, l.value, v);
    }
  }), U = Ae(() => f.value), te = /* @__PURE__ */ Ae(() => g.value), O = /* @__PURE__ */ Ae(() => y.value);
  function I() {
    return ue(b) ? b : null;
  }
  function D(v) {
    b = v, k.postTranslation = v;
  }
  function F() {
    return E;
  }
  function P(v) {
    v !== null && (u = ws(v)), E = v, k.missing = u;
  }
  function W(v, L) {
    return v !== "translate" || !L.resolvedMessage;
  }
  const B = (v, L, ne, me, _t, on) => {
    K();
    let St;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, o || (k.fallbackContext = t ? fd() : void 0), St = v(k);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, o || (k.fallbackContext = void 0);
    }
    if (ne !== "translate exists" && // for not `te` (e.g `t`)
    _e(St) && St === In || ne === "translate exists" && !St) {
      const [yt, Kr] = L();
      if (process.env.NODE_ENV !== "production" && t && $(yt) && W(ne, Kr) && (S && (Sn(T, yt) || $r(m, yt)) && nt(En(et.FALLBACK_TO_ROOT, {
        key: yt,
        type: ne
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: Io } = k;
        Io && S && Io.emit("fallback", {
          type: ne,
          key: yt,
          to: "global",
          groupId: `${ne}:${yt}`
        });
      }
      return t && S ? me(t) : _t(yt);
    } else {
      if (on(St))
        return St;
      throw qt(ke.UNEXPECTED_RETURN_TYPE);
    }
  };
  function J(...v) {
    return B((L) => Reflect.apply(ds, null, [L, ...v]), () => zn(...v), "translate", (L) => Reflect.apply(L.t, L, [...v]), (L) => L, (L) => $(L));
  }
  function le(...v) {
    const [L, ne, me] = v;
    if (me && !ee(me))
      throw qt(ke.INVALID_ARGUMENT);
    return J(L, ne, ye({ resolvedMessage: !0 }, me || {}));
  }
  function de(...v) {
    return B((L) => Reflect.apply(rs, null, [L, ...v]), () => Xn(...v), "datetime format", (L) => Reflect.apply(L.d, L, [...v]), () => yn, (L) => $(L) || we(L));
  }
  function be(...v) {
    return B((L) => Reflect.apply(is, null, [L, ...v]), () => qn(...v), "number format", (L) => Reflect.apply(L.n, L, [...v]), () => yn, (L) => $(L) || we(L));
  }
  function Ce(v) {
    return v.map((L) => $(L) || _e(L) || he(L) ? fs(String(L)) : L);
  }
  const Ye = {
    normalize: Ce,
    interpolate: (v) => v,
    type: "vnode"
  };
  function qe(...v) {
    return B((L) => {
      let ne;
      const me = L;
      try {
        me.processor = Ye, ne = Reflect.apply(ds, null, [me, ...v]);
      } finally {
        me.processor = null;
      }
      return ne;
    }, () => zn(...v), "translate", (L) => L[Jn](...v), (L) => [fs(L)], (L) => we(L));
  }
  function je(...v) {
    return B((L) => Reflect.apply(is, null, [L, ...v]), () => qn(...v), "number format", (L) => L[Qn](...v), ps, (L) => $(L) || we(L));
  }
  function ve(...v) {
    return B((L) => Reflect.apply(rs, null, [L, ...v]), () => Xn(...v), "datetime format", (L) => L[Zn](...v), ps, (L) => $(L) || we(L));
  }
  function Be(v) {
    N = v, k.pluralRules = N;
  }
  function st(v, L) {
    return B(() => {
      if (!v)
        return !1;
      const ne = $(L) ? L : l.value, me = vt(ne), _t = k.messageResolver(me, v);
      return Xe(_t) || Ve(_t) || $(_t);
    }, () => [v], "translate exists", (ne) => Reflect.apply(ne.te, ne, [v, L]), Pd, (ne) => he(ne));
  }
  function ze(v) {
    let L = null;
    const ne = Ar(k, i.value, l.value);
    for (let me = 0; me < ne.length; me++) {
      const _t = f.value[ne[me]] || {}, on = k.messageResolver(_t, v);
      if (on != null) {
        L = on;
        break;
      }
    }
    return L;
  }
  function Yt(v) {
    const L = ze(v);
    return L ?? (t ? t.tm(v) || {} : {});
  }
  function vt(v) {
    return f.value[v] || {};
  }
  function jt(v, L) {
    if (s) {
      const ne = { [v]: L };
      for (const me in ne)
        Ke(ne, me) && zt(ne[me]);
      L = ne[v];
    }
    f.value[v] = L, k.messages = f.value;
  }
  function Pn(v, L) {
    f.value[v] = f.value[v] || {};
    const ne = { [v]: L };
    if (s)
      for (const me in ne)
        Ke(ne, me) && zt(ne[me]);
    L = ne[v], cn(L, f.value[v]), k.messages = f.value;
  }
  function c(v) {
    return g.value[v] || {};
  }
  function d(v, L) {
    g.value[v] = L, k.datetimeFormats = g.value, as(k, v, L);
  }
  function C(v, L) {
    g.value[v] = ye(g.value[v] || {}, L), k.datetimeFormats = g.value, as(k, v, L);
  }
  function M(v) {
    return y.value[v] || {};
  }
  function ce(v, L) {
    y.value[v] = L, k.numberFormats = y.value, ls(k, v, L);
  }
  function fe(v, L) {
    y.value[v] = ye(y.value[v] || {}, L), k.numberFormats = y.value, ls(k, v, L);
  }
  hs++, t && ct && (wt(t.locale, (v) => {
    a && (l.value = v, k.locale = v, Wt(k, l.value, i.value));
  }), wt(t.fallbackLocale, (v) => {
    a && (i.value = v, k.fallbackLocale = v, Wt(k, l.value, i.value));
  }));
  const Z = {
    id: hs,
    locale: X,
    fallbackLocale: G,
    get inheritLocale() {
      return a;
    },
    set inheritLocale(v) {
      a = v, v && t && (l.value = t.locale.value, i.value = t.fallbackLocale.value, Wt(k, l.value, i.value));
    },
    get availableLocales() {
      return Object.keys(f.value).sort();
    },
    messages: U,
    get modifiers() {
      return A;
    },
    get pluralRules() {
      return N || {};
    },
    get isGlobal() {
      return o;
    },
    get missingWarn() {
      return m;
    },
    set missingWarn(v) {
      m = v, k.missingWarn = m;
    },
    get fallbackWarn() {
      return T;
    },
    set fallbackWarn(v) {
      T = v, k.fallbackWarn = T;
    },
    get fallbackRoot() {
      return S;
    },
    set fallbackRoot(v) {
      S = v;
    },
    get fallbackFormat() {
      return p;
    },
    set fallbackFormat(v) {
      p = v, k.fallbackFormat = p;
    },
    get warnHtmlMessage() {
      return x;
    },
    set warnHtmlMessage(v) {
      x = v, k.warnHtmlMessage = v;
    },
    get escapeParameter() {
      return _;
    },
    set escapeParameter(v) {
      _ = v, k.escapeParameter = v;
    },
    t: J,
    getLocaleMessage: vt,
    setLocaleMessage: jt,
    mergeLocaleMessage: Pn,
    getPostTranslationHandler: I,
    setPostTranslationHandler: D,
    getMissingHandler: F,
    setMissingHandler: P,
    [Id]: Be
  };
  return Z.datetimeFormats = te, Z.numberFormats = O, Z.rt = le, Z.te = st, Z.tm = Yt, Z.d = de, Z.n = be, Z.getDateTimeFormat = c, Z.setDateTimeFormat = d, Z.mergeDateTimeFormat = C, Z.getNumberFormat = M, Z.setNumberFormat = ce, Z.mergeNumberFormat = fe, Z[Hr] = n, Z[Jn] = qe, Z[Zn] = ve, Z[Qn] = je, process.env.NODE_ENV !== "production" && (Z[eo] = (v) => {
    k.__v_emitter = v;
  }, Z[to] = () => {
    k.__v_emitter = void 0;
  }), Z;
}
function gs(e, t) {
}
const Oo = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function Rd({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((o, s) => [
    ...o,
    // prettier-ignore
    ...s.type === xe ? s.children : [s]
  ], []) : t.reduce((n, o) => {
    const s = e[o];
    return s && (n[o] = s()), n;
  }, re());
}
function Wr() {
  return xe;
}
ye({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    validator: (e) => _e(e) || !isNaN(e)
  }
}, Oo);
function Fd(e) {
  return we(e) && !$(e[0]);
}
function Gr(e, t, n, o) {
  const { slots: s, attrs: r } = t;
  return () => {
    const a = { part: !0 };
    let l = re();
    e.locale && (a.locale = e.locale), $(e.format) ? a.key = e.format : ee(e.format) && ($(e.format.key) && (a.key = e.format.key), l = Object.keys(e.format).reduce((m, T) => n.includes(T) ? ye(re(), m, { [T]: e.format[T] }) : m, re()));
    const i = o(e.value, a, l);
    let f = [a.key];
    we(i) ? f = i.map((m, T) => {
      const S = s[m.type], p = S ? S({ [m.type]: m.value, index: T, parts: i }) : [m.value];
      return Fd(p) && (p[0].key = `${m.type}-${T}`), p;
    }) : $(i) && (f = [i]);
    const g = ye(re(), r), y = $(e.tag) || ee(e.tag) ? e.tag : Wr();
    return _s(y, g, f);
  };
}
ye({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, Oo);
const Ud = /* @__PURE__ */ dt("global-vue-i18n");
function Dn(e = {}) {
  const t = Ao();
  if (t == null)
    throw qt(ke.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw qt(ke.NOT_INSTALLED);
  const n = Bd(t), o = Hd(n), s = jr(t), r = Vd(e, s);
  if (r === "global")
    return Dd(o, e, s), o;
  if (r === "parent") {
    let i = Yd(n, t, e.__useComponent);
    return i == null && (process.env.NODE_ENV !== "production" && nt(En(et.NOT_FOUND_PARENT_SCOPE)), i = o), i;
  }
  const a = n;
  let l = a.__getInstance(t);
  if (l == null) {
    const i = ye({}, e);
    "__i18n" in s && (i.__i18n = s.__i18n), o && (i.__root = o), l = Md(i), a.__composerExtend && (l[no] = a.__composerExtend(l)), Wd(a, t, l), a.__setInstance(t, l);
  } else
    process.env.NODE_ENV !== "production" && r === "local" && nt(En(et.DUPLICATE_USE_I18N_CALLING));
  return l;
}
function Bd(e) {
  const t = Xr(e.isCE ? Ud : e.appContext.app.__VUE_I18N_SYMBOL__);
  if (!t)
    throw qt(e.isCE ? ke.NOT_INSTALLED_WITH_PROVIDE : ke.UNEXPECTED_ERROR);
  return t;
}
function Vd(e, t) {
  return On(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function Hd(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function Yd(e, t, n = !1) {
  let o = null;
  const s = t.root;
  let r = jd(t, n);
  for (; r != null; ) {
    const a = e;
    if (e.mode === "composition")
      o = a.__getInstance(r);
    else if (__VUE_I18N_LEGACY_API__) {
      const l = a.__getInstance(r);
      l != null && (o = l.__composer, n && o && !o[Hr] && (o = null));
    }
    if (o != null || s === r)
      break;
    r = r.parent;
  }
  return o;
}
function jd(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function Wd(e, t, n) {
  let o = null;
  kn(() => {
    if (process.env.NODE_ENV !== "production") {
      t.__VUE_I18N__ = n, o = Jc();
      const s = n;
      s[eo] && s[eo](o), o.on("*", gs);
    }
  }, t), qr(() => {
    const s = n;
    process.env.NODE_ENV !== "production" && (o && o.off("*", gs), s[to] && s[to](), delete t.__VUE_I18N__), e.__deleteInstance(t);
    const r = s[no];
    r && (r(), delete s[no]);
  }, t);
}
ye({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, Oo);
Ad();
id(Uu);
ld(nd);
cd(Ar);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = Ct();
  e.__INTLIFY__ = !0, Bu(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
function Gd(e, t) {
  const n = z({}), o = z({
    tz: "",
    merchant_name: "",
    memo1: "",
    memo2: ""
  }), s = z(!1), r = z(null);
  return { matrix: n, loading: s, error: r, merchantInfo: o, fetchMatrix: async (f = 1, g = 10) => {
    s.value = !0;
    try {
      n.value = await e.getSevenDayMatrix(f, g);
    } catch (y) {
      r.value = y.message || "無法獲取預約矩陣";
    } finally {
      s.value = !1;
    }
  }, submitBooking: async (f) => {
    s.value = !0;
    try {
      return await e.createOrder(f);
    } catch (g) {
      throw r.value = g.message || "預約失敗", g;
    } finally {
      s.value = !1;
    }
  }, fetchMerchantInfo: async (f) => {
    s.value = !0;
    try {
      o.value = await t.getMerchantInfo(f);
    } catch (g) {
      r.value = g.message || "無法獲取預約矩陣";
    } finally {
      s.value = !1;
    }
  } };
}
const Kd = { class: "flex flex-col h-screen max-w-xl mx-auto bg-slate-100 font-sans text-slate-700 overflow-hidden" }, Xd = { class: "flex-1 p-8 space-y-10 overflow-y-auto custom-scrollbar" }, qd = { class: "space-y-3 py-4 text-left" }, zd = { class: "text-3xl font-black tracking-tighter border-l-4 border-slate-700 pl-4 leading-none" }, Jd = ["innerHTML"], Zd = { class: "space-y-4" }, Qd = { class: "relative isolate" }, ef = ["value"], tf = {
  key: 0,
  class: "space-y-4"
}, nf = { class: "flex gap-3 overflow-x-auto pb-4 no-scrollbar px-1" }, of = ["onClick"], sf = { class: "text-[10px] font-black uppercase opacity-60" }, rf = { class: "text-xl font-black mt-1" }, af = {
  key: 1,
  class: "mb-8"
}, lf = {
  key: 0,
  class: "p-8 text-center animate-pulse font-bold uppercase tracking-widest text-xs"
}, cf = {
  key: 1,
  class: "grid grid-cols-4 gap-2"
}, uf = ["onClick", "disabled"], df = {
  key: 0,
  class: "absolute bottom-1.5 w-3 h-[2px] bg-white/40 rounded-full"
}, ff = {
  key: 2,
  class: "mt-4 text-center p-4 bg-slate-200/50 rounded-xl text-slate-500 text-[10px] font-bold uppercase tracking-wider"
}, mf = { class: "space-y-4 pb-12" }, pf = { class: "space-y-3" }, hf = ["onUpdate:modelValue", "type", "placeholder"], wf = { class: "p-8 bg-slate-100 border-t border-slate-200" }, gf = { class: "mb-3 text-center" }, bf = {
  key: 0,
  class: "text-[10px] font-black uppercase tracking-widest text-slate-400"
}, vf = ["disabled"], _f = /* @__PURE__ */ ut({
  __name: "ReservationPage",
  props: {
    bookingApi: {},
    tzApi: {},
    merchantID: {}
  },
  setup(e) {
    at.extend(za), at.locale("zh-tw");
    const { t } = Dn(), n = e, { matrix: o, merchantInfo: s, loading: r, error: a, fetchMatrix: l, submitBooking: i, fetchMerchantInfo: f } = Gd(n.bookingApi, n.tzApi), g = z(2), y = z(""), m = z(""), T = z({
      name: "",
      phone: "",
      email: ""
    }), S = ["name", "phone", "email"], p = Ae(() => {
      var O;
      const U = o.value;
      if ((O = U == null ? void 0 : U["0"]) != null && O["0"]) return U[0][0];
      const te = [];
      for (let I = 10; I <= 20; I++)
        te.push(`${I.toString().padStart(2, "0")}:00`), I < 20 && te.push(`${I.toString().padStart(2, "0")}:30`);
      return te;
    }), E = Ae(() => o.value ? Object.fromEntries(Object.entries(o.value).filter(([U]) => U !== "0")) : {}), u = Ae(() => Object.keys(E.value).sort()), b = Ae(() => !y.value || !E.value[y.value] ? [] : E.value[y.value][g.value] || []), x = (U) => b.value.includes(U), _ = (U, te) => at(U).format(te);
    wt(E, (U) => {
      const te = Object.keys(U).sort();
      te.length > 0 && !y.value && (y.value = te[0]);
    }, { deep: !0 }), wt([g, y], () => {
      m.value = "";
    }), kn(async () => {
      f(n.merchantID), await l();
    });
    const A = (U) => /^\S+@\S+\.\S+$/.test(U), N = (U) => /^09\d{8}$/.test(U), k = Ae(() => y.value ? m.value ? T.value.name.trim() === "" ? "INVALID_NAME" : N(T.value.phone) ? A(T.value.email) ? "SUCCESS" : "INVALID_EMAIL" : "INVALID_PHONE" : "MISSING_TIME" : "MISSING_DATE"), j = Ae(() => k.value === "SUCCESS"), K = Ae(() => ({
      SUCCESS: "Confirm Order / 確認預約",
      MISSING_DATE: "Please Select Date / 請選擇日期",
      MISSING_TIME: "Please Select Time / 請選擇時段",
      INVALID_NAME: "Name Required / 請輸入姓名",
      INVALID_PHONE: "Invalid Phone / 電話格式錯誤",
      INVALID_EMAIL: "Invalid Email / 信箱格式錯誤"
    })[k.value]), X = async () => {
      if (!j.value) return;
      const U = at(`${y.value} ${m.value}`).utc(!0).toISOString();
      try {
        await i({
          guest_count: g.value,
          merchant_name: s.value.merchant_name,
          start_time: U,
          name: T.value.name,
          phone: T.value.phone,
          email: T.value.email
        }), await Gt.fire({
          title: '<span class="font-black text-slate-700 uppercase tracking-tighter">確認信已寄出</span>',
          html: `
        <div class="text-slate-600 font-bold leading-relaxed px-4 text-sm">
          確認連結已發送至<br/>
          <span class="bg-slate-700 text-white px-3 py-1 rounded-full mt-2 inline-block">${T.value.email}</span><br/>
          <p class="mt-4 opacity-60 uppercase tracking-widest text-[10px]">確認連結將在15分鐘後過期</p>
        </div>`,
          icon: "success",
          iconColor: "#334155",
          background: "#f1f5f9",
          confirmButtonText: t("common.ok"),
          confirmButtonColor: "#334155",
          customClass: {
            popup: "rounded-[2.5rem] border-none shadow-2xl",
            confirmButton: "rounded-xl font-black px-10 py-3 tracking-widest"
          }
        }), await l();
      } catch (te) {
        Hn.error("預約失敗", te), await Gt.fire({ title: "ERROR", text: "預約失敗，請稍後再試", icon: "error", confirmButtonColor: "#334155" });
      }
    }, G = ["1de956ad-ea63-4e74-853a-8b24b4ef3d26", "8cba5a9b-8007-4a4c-830e-01d402f1ccc0"];
    return wt(() => n.merchantID, (U) => {
      U && G.includes(U) && (T.value = { name: "測試人員", phone: "0912345678", email: "bjk543@gmail.com" });
    }, { immediate: !0 }), (U, te) => (V(), H("div", Kd, [
      h("main", Xd, [
        h("header", qd, [
          h("h1", zd, q(ae(s).merchant_name), 1),
          h("span", {
            class: "text-xs font-bold tracking-widest",
            innerHTML: ae(s).memo2
          }, null, 8, Jd)
        ]),
        h("section", Zd, [
          te[1] || (te[1] = h("label", { class: "block text-[10px] font-black uppercase tracking-[0.2em] opacity-50" }, "01. Guests / 預約人數", -1)),
          h("div", Qd, [
            Ge(h("select", {
              "onUpdate:modelValue": te[0] || (te[0] = (O) => g.value = O),
              class: "w-full appearance-none bg-white text-slate-700 p-5 rounded-2xl font-bold transition-all outline-none border-2 border-transparent focus:border-slate-700 shadow-sm cursor-pointer hover:bg-slate-50"
            }, [
              (V(), H(xe, null, We(8, (O) => h("option", {
                key: O,
                value: O
              }, q(O) + " 人 / " + q(O) + " " + q(O > 1 ? "Guests" : "Guest"), 9, ef)), 64))
            ], 512), [
              [bs, g.value]
            ])
          ])
        ]),
        u.value.length ? (V(), H("section", tf, [
          te[2] || (te[2] = h("label", { class: "block text-[10px] font-black uppercase tracking-[0.2em] opacity-50" }, "02. Date / 預約日期", -1)),
          h("div", nf, [
            (V(!0), H(xe, null, We(u.value, (O) => (V(), H("button", {
              key: O,
              onClick: (I) => y.value = O,
              class: Pe([
                "min-w-[80px] py-5 rounded-2xl transition-all border-2 flex flex-col items-center shrink-0",
                y.value === O ? "bg-slate-700 text-white border-slate-700 shadow-lg" : "bg-white text-slate-700 border-transparent hover:border-slate-300 shadow-sm"
              ])
            }, [
              h("span", sf, q(_(O, "ddd")), 1),
              h("span", rf, q(_(O, "DD")), 1)
            ], 10, of))), 128))
          ])
        ])) : $e("", !0),
        u.value.length ? (V(), H("section", af, [
          te[3] || (te[3] = h("label", { class: "block text-[10px] font-black uppercase tracking-[0.2em] opacity-50 mb-3 ml-1" }, "03. Time / 預約時段", -1)),
          ae(r) ? (V(), H("div", lf, " Synchronizing... ")) : (V(), H("div", cf, [
            (V(!0), H(xe, null, We(p.value, (O) => (V(), H("button", {
              key: O,
              onClick: (I) => m.value = O,
              disabled: !x(O),
              class: Pe([
                /* 使用 px-0 釋放所有橫向空間，py-4 維持垂直厚度展現專業感 */
                /* text-[12px] 或 text-xs 是四欄布局的最佳平衡點 */
                "py-4 px-0 rounded-xl font-mono font-bold transition-all border-2 text-[12px] shadow-sm text-center relative flex items-center justify-center",
                m.value === O ? "bg-slate-700 text-white border-slate-700 shadow-md z-10 scale-[1.02]" : x(O) ? "bg-white text-slate-700 border-transparent hover:border-slate-300" : "bg-slate-50 text-slate-300 border-transparent cursor-not-allowed opacity-40"
              ])
            }, [
              xt(q(O) + " ", 1),
              m.value === O ? (V(), H("div", df)) : $e("", !0)
            ], 10, uf))), 128))
          ])),
          !ae(r) && b.value.length === 0 ? (V(), H("div", ff, " ⚠️ No slots available for this date. ")) : $e("", !0)
        ])) : $e("", !0),
        h("section", mf, [
          te[4] || (te[4] = h("label", { class: "block text-[10px] font-black uppercase tracking-[0.2em] opacity-50" }, "04. Info / 聯繫資訊", -1)),
          h("div", pf, [
            (V(), H(xe, null, We(S, (O) => h("div", { key: O }, [
              Ge(h("input", {
                "onUpdate:modelValue": (I) => T.value[O] = I,
                type: O === "email" ? "email" : "text",
                placeholder: O.toUpperCase(),
                class: "w-full p-5 bg-white rounded-xl border-2 border-transparent outline-none focus:border-slate-700 transition-all font-bold placeholder:text-slate-300 shadow-sm"
              }, null, 8, hf), [
                [Zr, T.value[O]]
              ])
            ])), 64))
          ])
        ])
      ]),
      h("footer", wf, [
        h("div", gf, [
          kt(oo, { name: "fade" }, {
            default: so(() => [
              !j.value && (y.value || m.value) ? (V(), H("p", bf, " Status: " + q(K.value), 1)) : $e("", !0)
            ]),
            _: 1
          })
        ]),
        h("button", {
          onClick: X,
          disabled: !j.value || ae(r),
          class: Pe([
            "w-full py-5 rounded-2xl font-black text-lg tracking-[0.3em] uppercase transition-all active:scale-[0.98]",
            j.value ? "bg-slate-700 text-white shadow-lg shadow-slate-300" : "bg-slate-200 text-slate-400 cursor-not-allowed"
          ])
        }, [
          ae(r) ? (V(), H(xe, { key: 0 }, [
            xt("Processing...")
          ], 64)) : (V(), H(xe, { key: 1 }, [
            xt(q(j.value ? "Confirm Order" : K.value), 1)
          ], 64))
        ], 10, vf)
      ])
    ]));
  }
}), rm = /* @__PURE__ */ ro(_f, [["__scopeId", "data-v-91731172"]]);
function yf(e) {
  const t = z({}), n = z(!1), o = z(null);
  return { reservations: t, loading: n, error: o, loadData: async () => {
    n.value = !0, o.value = null;
    try {
      const r = await e.fetchReservations();
      t.value = r || {}, Hn.log("載入預約資料成功:", t.value);
    } catch (r) {
      o.value = "無法載入預約資料", Hn.error("載入預約資料失敗:", r);
    } finally {
      n.value = !1;
    }
  } };
}
const Ef = { class: "p-4 md:p-8 bg-slate-50 font-sans antialiased text-slate-700" }, kf = { class: "max-w-5xl mx-auto" }, xf = { class: "mb-8 flex flex-col md:flex-row md:items-center justify-between gap-6" }, Cf = { class: "flex flex-col gap-1" }, Tf = { class: "text-slate-500 font-bold uppercase text-xs tracking-widest mt-1" }, Lf = { class: "text-indigo-700 font-black" }, Nf = { class: "flex flex-wrap items-center gap-2 mb-8" }, Af = ["onClick"], Of = {
  key: 0,
  class: "mr-1"
}, If = ["disabled"], Sf = {
  key: 0,
  class: "mb-10"
}, Df = { class: "flex items-center gap-3 overflow-x-auto pb-4 no-scrollbar scroll-smooth" }, Pf = ["onClick"], $f = { class: "text-[10px] uppercase opacity-60 tracking-[0.2em] mb-1" }, Mf = { class: "text-xl leading-none tabular-nums" }, Rf = { class: "relative min-h-[700px]" }, Ff = { class: "flex items-center justify-between mb-4 px-2" }, Uf = { class: "text-xs font-black text-slate-700 uppercase tracking-[0.3em]" }, Bf = { class: "flex flex-col md:flex-row md:items-center gap-6" }, Vf = {
  key: 0,
  class: "flex -space-x-4"
}, Hf = { class: "text-2xl font-black leading-none" }, Yf = { class: "flex-1" }, jf = { class: "flex-1 px-4 md:px-0" }, Wf = { class: "flex items-center gap-3" }, Gf = { class: "font-black text-slate-700 text-2xl tracking-tight leading-none" }, Kf = { class: "flex items-center gap-1 bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-[10px] font-black uppercase" }, Xf = { class: "flex flex-wrap items-center gap-x-6 gap-y-2 mt-3 text-sm text-slate-500 font-bold" }, qf = { class: "flex items-center gap-2" }, zf = {
  key: 0,
  class: "text-slate-700 hidden md:inline"
}, Jf = {
  key: 1,
  class: "text-slate-700 font-medium"
}, Zf = { class: "flex flex-row md:flex-col items-center md:items-end gap-4 px-4 md:px-0 md:pl-8 border-t md:border-t-0 md:border-l border-slate-100 pt-4 md:pt-0" }, Qf = {
  key: 1,
  class: "text-center py-40 bg-white rounded-[3rem] border-4 border-dashed border-slate-100"
}, em = { class: "text-2xl font-black text-slate-700 uppercase tracking-[0.2em]" }, tm = /* @__PURE__ */ ut({
  __name: "AdminReservationList",
  props: {
    api: {}
  },
  setup(e) {
    const t = e, { reservations: n, loading: o, error: s, loadData: r } = yf(t.api);
    kn(async () => {
      await r();
    });
    const a = z(null), l = z(2);
    z(null);
    const i = Ae(() => {
      const p = n.value;
      return p ? l.value === null ? Object.keys(p) : Object.keys(p).filter((E) => p[E].some((u) => u.status === l.value)) : [];
    });
    wt(i, (p) => {
      if (p.length > 0 && !a.value) {
        const E = at().format("YYYY-MM-DD");
        a.value = p.includes(E) ? E : p[0];
      }
    }, { immediate: !0 });
    const f = [
      { label: "已確認", value: 2, color: "green" },
      { label: "全部", value: null, color: "slate" }
    ], g = Ae(() => {
      const p = n.value;
      if (!a.value || !p) return [];
      let E = p[a.value] || [];
      return l.value !== null && (E = E.filter((u) => u.status === l.value)), E;
    }), y = Ae(() => {
      const p = n.value;
      return p ? Object.values(p).reduce((E, u) => E + ((u == null ? void 0 : u.length) || 0), 0) : 0;
    }), m = (p) => {
      if (!p) return "slate";
      const E = at(p).hour();
      return E >= 5 && E < 12 ? "cyan" : E >= 12 && E < 17 ? "amber" : "indigo";
    }, T = (p) => {
      switch (p) {
        case 1:
          return "bg-orange-100 text-orange-700 border-orange-200";
        case 2:
          return "bg-green-100 text-green-700 border-green-200";
        case 3:
          return "bg-red-100 text-red-700 border-red-200";
      }
    }, S = (p) => p ? at(p).format("HH:mm") : "--:--";
    return (p, E) => (V(), H("div", Ef, [
      h("div", kf, [
        h("header", xf, [
          h("div", Cf, [
            E[3] || (E[3] = h("h1", { class: "text-4xl font-black tracking-tight text-slate-700" }, "預約看板", -1)),
            h("p", Tf, [
              E[1] || (E[1] = xt(" 目前共有 ", -1)),
              h("span", Lf, q(y.value), 1),
              E[2] || (E[2] = xt(" 筆預約 ", -1))
            ])
          ]),
          h("div", Nf, [
            (V(), H(xe, null, We(f, (u) => h("button", {
              key: u.label,
              onClick: (b) => l.value = u.value,
              class: Pe([[
                l.value === u.value ? `bg-${u.color}-700 text-white shadow-lg` : `bg-white text-slate-700 hover:bg-${u.color}-100`
              ], "px-5 py-2 rounded-full border text-xs font-black uppercase tracking-wider transition-all active:scale-95"])
            }, [
              l.value === u.value ? (V(), H("span", Of, "●")) : $e("", !0),
              xt(" " + q(u.label), 1)
            ], 10, Af)), 64))
          ]),
          h("button", {
            onClick: E[0] || (E[0] = //@ts-ignore
            (...u) => ae(r) && ae(r)(...u)),
            disabled: ae(o),
            class: "flex items-center gap-2 px-6 py-3 bg-white border border-slate-200 rounded-2xl font-bold shadow-sm hover:shadow-md transition-all active:scale-95 disabled:opacity-50"
          }, [
            h("span", {
              class: Pe({ "animate-spin": ae(o) })
            }, q(ae(o) ? "⌛" : "🔄"), 3),
            xt(" " + q(ae(o) ? "載入中..." : "重新整理"), 1)
          ], 8, If)
        ]),
        i.value.length > 0 ? (V(), H("div", Sf, [
          h("nav", Df, [
            (V(!0), H(xe, null, We(i.value, (u) => (V(), H("button", {
              key: u,
              onClick: (b) => a.value = u,
              class: Pe([[
                a.value === u ? "bg-indigo-700 text-white shadow-xl shadow-indigo-100 scale-105 border-indigo-700" : "bg-white text-slate-500 hover:bg-slate-100 border-slate-200"
              ], "flex-shrink-0 px-6 py-4 rounded-[2rem] border-2 font-black transition-all duration-700 flex flex-col items-center min-w-[110px]"])
            }, [
              h("span", $f, q(ae(at)(u).format("ddd")), 1),
              h("span", Mf, q(ae(at)(u).format("MM/DD")), 1)
            ], 10, Pf))), 128))
          ])
        ])) : $e("", !0),
        h("div", Rf, [
          kt(oo, {
            name: "list-fade",
            mode: "out-in"
          }, {
            default: so(() => [
              (V(), H("div", {
                key: a.value || "none",
                class: "space-y-6"
              }, [
                g.value.length > 0 ? (V(), H(xe, { key: 0 }, [
                  h("div", Ff, [
                    h("h2", Uf, " Showing " + q(a.value) + " • " + q(g.value.length) + " Bookings ", 1)
                  ]),
                  (V(!0), H(xe, null, We(g.value, (u) => {
                    var b, x;
                    return V(), H("div", {
                      key: u.booking_id,
                      class: Pe(["group rounded-[2.5rem] p-3 pr-8 shadow-sm border border-slate-100 hover:shadow-2xl hover:shadow-indigo-700 hover:border-indigo-100 transition-all duration-700", [
                        u.status === 1 ? "bg-orange-100" : "",
                        // 待處理 (Pending)
                        u.status === 2 ? "bg-green-100" : "",
                        // 已確認 (Confirmed)
                        u.status === 3 ? "bg-red-100" : "",
                        // 已取消 (Cancelled)
                        [1, 2, 3].includes(u.status) ? "" : "bg-white"
                        // 預設
                      ]])
                    }, [
                      h("div", Bf, [
                        h("div", {
                          class: Pe([[`bg-${m((x = (b = u.table_reservations) == null ? void 0 : b[0]) == null ? void 0 : x.booking_period.Lower)}-100/50`], "flex items-center gap-5 p-5 rounded-[2rem] md:w-80 transition-colors group-hover:bg-indigo-50"])
                        }, [
                          u.status !== 3 ? (V(), H("div", Vf, [
                            (V(!0), H(xe, null, We(u.table_reservations, (_) => (V(), H("div", {
                              key: _.id,
                              class: Pe([[`bg-${m(_.booking_period.Lower)}-700`], "w-16 h-16 text-white rounded-2xl flex flex-col items-center justify-center border-4 border-white shadow-md transition-all duration-700 group-hover:rotate-6 group-hover:scale-110"])
                            }, [
                              E[4] || (E[4] = h("span", { class: "text-[8px] font-black opacity-60 uppercase mb-1" }, "Tab", -1)),
                              h("span", Hf, q(_.table_id), 1)
                            ], 2))), 128))
                          ])) : $e("", !0),
                          h("div", Yf, [
                            h("div", {
                              class: Pe([[`text-${m(u.start_time)}-700`], "text-2xl font-black tabular-nums tracking-tighter"])
                            }, q(S(u.start_time)), 3)
                          ])
                        ], 2),
                        h("div", jf, [
                          h("div", Wf, [
                            h("span", Gf, q(u.guest_name), 1),
                            h("div", Kf, q(u.guest_count) + " 人 ", 1)
                          ]),
                          h("div", Xf, [
                            h("span", qf, "📞 " + q(u.phone_number), 1),
                            u.email ? (V(), H("span", zf, "|")) : $e("", !0),
                            u.email ? (V(), H("span", Jf, "✉️ " + q(u.email), 1)) : $e("", !0)
                          ])
                        ]),
                        h("div", Zf, [
                          h("div", {
                            class: Pe([T(u.status), "px-6 py-2 rounded-2xl text-[11px] font-black uppercase tracking-widest border transition-all shadow-sm"])
                          }, q(u.status === 2 ? "✓ Confirmed" : u.status === 1 ? "• Pending" : "X Cancel"), 3)
                        ])
                      ])
                    ], 2);
                  }), 128))
                ], 64)) : ae(o) ? $e("", !0) : (V(), H("div", Qf, [
                  E[5] || (E[5] = h("div", { class: "text-6xl mb-6 grayscale opacity-20" }, "📅", -1)),
                  h("h2", em, q(i.value.length > 0 ? "No bookings for this date" : "No reservations found"), 1)
                ]))
              ]))
            ]),
            _: 1
          })
        ])
      ])
    ]));
  }
}), am = /* @__PURE__ */ ro(tm, [["__scopeId", "data-v-81f7dd50"]]);
export {
  am as AdminReservationList,
  sm as BookingConfigPage,
  rm as ReservationPage,
  Qr as useBookingConfig,
  Gd as useBookingOrder,
  yf as useReservationAdmin
};
